/* eslint-disable */
import { CR, RC, AJRS } from './base_i2_success_codes'
import bi1_data_validation from './base_i1_datavalidation'
import base_i3_log from './base_i3_logging'
import { ajax } from 'noquery-ajax';
import bi6_misc from './base_i6_misc_functions'
import Vue from 'vue'
import moment, { relativeTimeRounding } from 'moment';
import localForage from 'localforage';
import getNGPRulesInformation from "./json_tasks/p2s7/p2s7t12";
import getNotificationGroupActiveEntries from './json_tasks/p2s7/p2s7t16'
import p2s7t18GetNgpEntriesByEntityKey from './json_tasks/p2s7/p2s7t18'


// CI == class instance
// IV == instance variable
"use strict";
class bi7_watchdog_firebase {
    constructor() {
        var CI = this;
        CI.IV_local_forage = localForage;
        CI.IV_local_forage.config({
          driver: [
            CI.IV_local_forage.INDEXEDDB,
            CI.IV_local_forage.LOCALSTORAGE,
            CI.IV_local_forage.WEBSQL
          ],
          name: 'DGnet_Watchdog'
        });
        CI.IV_firebase_db_object = null;
        CI.IV_id_token_pointer = '';
        CI.IV_firebase_uid_pointer = '';
        CI.IV_firebase_guest_flag_pointer = true;
        CI.IV_firebase_email_pointer = '';
        CI.IV_instance_initialized = false;
        CI.IV_user_folder_path = ''
        CI.IV_process_datastore_request_active = false;
        CI.IV_process_datatore_last_request_count = 0;
        CI.IV_process_datastore_last_run_time = 0;
        CI.IV_user_folder_valid = {
          'meta_data': {
            'created': false,
            'uid': false,
            'contact_email': false,
            'first_name': false,
            'last_name': false,
            'web_uid': false
          },
          folders: {
            'org_permissions': false,
            'doghouse_active': false,
            'meta_data': false,
            'doghouse_history': false,
            'notification_rules': false,
            'notification_rule_joins': false,
            'dog_house_ackowledged': false,
            'dog_house_tags': false,
            'notification_groups': false
          } 
        };
        CI.IV_last_updated_timestamps = {
            'org_permissions':0,
            'presets':{},
            'org_meta_data': {},
            'org_locations' : {},
            'obj_meta_data': {},
            'obj_atr_meta_data': {},
            'usr_contact_email':{},
            'doghouse_active':{},
            'notification_rule_joins': {},
            'ngp_meta_data': {}
        };
        CI.IV_rebuild_data_requests = {'org_permissions':0,'presets':{}}
        CI.IV_org_locations = {};
        CI.IV_org_parents_lookup = {};
        //used with indexOf to check if an is a sub org of another org
        CI.IV_org_location_strings = {};
        CI.IV_org_structure = {};
        CI.IV_org_permissions = {};
        CI.IV_org_users_permissions_last_updated = {};
        CI.IV_progress_counts_for_bulk_rule_application = {
          'organizations': 0,
          'systems': 0,
          'objects': 0,
          'attributes': 0
        };

        CI.IV_doghouse_history = {};
        CI.IV_doghouse_active = {};
        CI.IV_doghouse_acknowledged = {}
        CI.IV_notification_rules = {};
        CI.IV_notification_rule_joins = {};

        CI.IV_page_load_time = parseInt(new Date().getTime() / 1000);
        CI.IV_doghouse_active_count_org_level = {};
        CI.IV_doghouse_acknowledged_count_org_level = {};
        CI.IV_doghouse_active_count_sys_level = {};
        CI.IV_doghouse_acknowledged_count_sys_level = {};
        CI.IV_doghouse_active_count_object_level = {};
        CI.IV_doghouse_acknowledged_count_object_level = {};
        CI.IV_doghouse_active_count_obj_atr_level = {};
        CI.IV_doghouse_acknowledged_count_obj_atr_level = {};
        CI.IV_doghouse_active_count_tree_based_org_level = {}
        CI.IV_doghouse_acknowledged_count_tree_based_org_level = {}
        CI.IV_doghouse_count_update_queue = {};
        CI.IV_doghouse_count_update_request_active = false;
        CI.IV_doghouse_update_count_request_status = {};
        CI.IV_doghouse_count_update_last_run_time = 0;
        CI.IV_doghouse_count_last_updated = {
          'active_alerts': 0,
          'acknowledged_alerts': 0
        };

        CI.IV_account_notificaitons = {};

        CI.IV_meta_data_requests = {};
        CI.IV_meta_data_requests_retry_count = {};
        CI.IV_meta_data_requests_max_retry_count = 10;

        CI.IV_org_system_joins = {};
        CI.IV_system_org_joins = {};
        CI.IV_system_live_uids = {};
        CI.IV_object_attribute_live_uids = {};
        CI.IV_object_live_uids = {};
        CI.IV_system_object_joins = {};
        CI.IV_system_object_joins_reverse_lookup = {};
        CI.IV_object_attribute_joins = {};
        CI.IV_object_attribute_joins_reverse_lookup = {};
        CI.IV_object_attribute_values = {};
        CI.IV_object_attribute_history_values = {};
        CI.IV_object_attribute_history_last_time = {};
        CI.IV_geting_object_attribute_history_ref = {};
        CI.IV_listener_object_attribute_history_ref = {};
        CI.IV_object_attribute_history_ref = {};
        CI.IV_last_time_sys_location_updated = {};
        CI.IV_last_time_sys_devices_structure_updated = {};
        CI.IV_last_time_obj_metadata_updated_for_system = {};
        CI.IV_last_time_obj_atr_metadata_updated_for_system = {};

        CI.IV_data_change_callbacks = {'IV_user_info': null};

        CI.IV_users_contact_email = {};
        CI.IV_filtered_attributes_list = [];
        CI.IV_org_meta_data = {};
        CI.IV_objects_meta_data = {};
        CI.IV_object_attributes_meta_data = {};
        CI.IV_object_attributes_command_history = {};
        CI.IV_object_attribute_rule_joins = {};
        CI.IV_mass_applied_rules_history = {};
        CI.IV_rx_tx_log_data = {};
        CI.IV_rx_tx_last_time = {};
        CI.IV_default_obj_attribute_names = {};
        CI.IV_renamed_obj_attributes_uids = {};

        /// NGP data structures
        CI.IV_org_ngp_joins = {};
        CI.IV_user_ngp_joins = {};
        CI.IV_ngp_org_joins = {};
        CI.IV_ngp_meta_data = {};
        CI.IV_ngp_rule_joins = {};
        CI.IV_ngp_rule_assignment_data = {};
        CI.IV_ngp_users_last_updated = {};
        CI.IV_ngp_loading_states = {};
        CI.IV_ngp_active_tags_all = {};
        CI.IV_ngp_active_tags_focused = {};
        CI.IV_loading_ngp_rules = {};
        CI.IV_ngp_triggered_alerts_entries = {};
        CI.IV_ngp_triggered_alerts_data = {};
        CI.IV_ngp_triggered_data = {};
        CI.IV_notification_group_rules_information = {};
        CI.IV_last_fetched_time_ngp_triggered_alerts_data = {};

        CI.IV_listener_users_ngp_joins = null;
        CI.IV_listener_ngp_org_joins = null;
        CI.IV_listener_org_ngp_joins = {};
        CI.IV_listener_ngp_users_global_last_updated = null;
        CI.IV_listener_ngp_rule_joins = {};
        CI.IV_listener_ngp_rule_assignment = {};
        CI.IV_listener_ngp_triggered_focused = {};
        CI.IV_listener_ngp_triggered_all = {};
        CI.IV_listener_ngp_active_tags_all = {};
        CI.IV_listener_ngp_active_tags_focused = {};
        ///</end> NGP data structures

        CI.IV_listener_user_info = {};
        CI.IV_listener_org_permissions = {};
        CI.IV_listener_orgs = {};
        CI.IV_listener_org_meta_data = {};
        CI.IV_listener_org_user_permission_changes = {};
        CI.IV_listener_mass_applied_rules_history = null;
        CI.IV_listener_system_all_object_and_attributes_joins = {};
        
        CI.IV_listener_object_meta_data = {};
        CI.IV_listener_object_attributes_meta_data = {};
        CI.IV_listener_object_attribute_values = {};
        CI.IV_listener_object_attribute_history_values = {};
        CI.IV_listener_object_attribute_command_history = {};
        CI.IV_listener_object_attribute_parent_system = {};
        CI.IV_listener_account_notifications = {};
        CI.IV_listener_doghouse_history = {};
        CI.IV_listener_doghouse_active = {};
        CI.IV_listener_doghouse_acknowledge = {};
        CI.IV_listener_rx_tx_logging = {};
        CI.IV_notification_rules_listener = {};
        CI.IV_notification_rule_joins_listener = {};
        CI.IV_save_join_data_to_cache_lockout = false;
        CI.IV_last_join_listener_started_time = null;
        CI.IV_last_join_data_change = 0;
        CI.IV_last_update_cached_join_data_run_time = 0;
        CI.IV_firebase_listeners_lookup = {
          'user_info': 'IV_listener_user_info',
          'org_permissions': 'IV_listener_org_permissions',
          'orgs': 'IV_listener_orgs',
          'org_meta_data': 'IV_listener_org_meta_data',
          'org_user_permission_changes': 'IV_listener_org_user_permission_changes',
          'object_meta_data': 'IV_listener_object_meta_data',
          'object_attributes_meta_data': 'IV_listener_object_attributes_meta_data',
          'object_attribute_values': 'IV_listener_object_attribute_values',
          'object_attribute_history_values': 'IV_listener_object_attribute_history_values',
          'object_attribute_command_history': 'IV_listener_object_attribute_command_history',
          'object_attribute_parent_system': 'IV_listener_object_attribute_parent_system',
          'account_notifications': 'IV_listener_account_notifications',
          'doghouse_history': 'IV_listener_doghouse_history',
          'doghouse_active': 'IV_listener_doghouse_active',
          'rx_tx_logging': 'IV_listener_rx_tx_logging',
          'ngp_rule_joins': 'IV_listener_ngp_rule_joins',
          'ngp_rule_assignments': 'IV_listener_ngp_rule_assignment',
          'org_ngp_joins': 'IV_listener_org_ngp_joins',
          'ngp_triggered_focused': 'IV_listener_ngp_triggered_focused'
        };

        CI.IV_presets = {};

        CI.IV_active_transcations = {};
        CI.IV_vue_transcations = {};
        CI.IV_org_count_and_loading = {};

        CI.IV_user_info = { 'uid': 0, 'contact_email': '', 'first_name': '', 'last_name': '','web_uid' :'' };
        CI.IV_success_global_callbacks = {};
        CI.IV_failure_global_callbacks = {};
        CI.IV_global_org_system_joins_listener = false;
        CI.IV_global_org_locations_listener = false;
        CI.IV_global_listener_renamed_obj_attributes = null;
        CI.IV_deleted_object_uids = {};
        CI.IV_listener_dog_house_tags = null;
        CI.IV_dog_house_tags = {};
        CI.IV_first_time_orgs_Locations_loaded = false;
        CI.IV_first_time_org_sys_joins_loaded = false;
        CI.IV_doghouse_history_listeners_count = 0
        CI.IV_component_loading_states = {}
        CI.IV_deletion_items_keys_after_csv = []
        CI.IV_items_count_for_csv_report = {
          'objects': 0,
          'attributes': 0
        };
        CI.IV_last_time_metadata_updated_for_objects_attribute = {};
        CI.IV_earliest_date_for_object_attribute_history = {};

        //this recalls itself to run forever
        setTimeout(CI.bi7processDataStoreRequests.bind(CI), 2000);
        setTimeout(CI.processDoghouseCountUpdateQueue.bind(CI), 2000);
        setTimeout(CI.bi7BuildPresets.bind(CI), 2000);

        //setInterval(CI.bi7UpdateCachedJoinData.bind(CI),30000); //#debug ks-07-01 #3Rl33SZs
        CI.bi7initDogHouseActiveGlobalListener();
        CI.bi7initDogHouseAcknowledgedGlobalListener();
        CI.bi7initGlobalRenamedObjectAttributesListener();
        CI.bi7InitUserNotificationGroupJoinsListener();
        CI.bi7InitNotificationGroupOrgJoinsListener();
    }


    bi7SetFirebaseToken(firebase_token=null) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7SetFirebaseToken ";
        var task_id = "bi7_watchdog_firebase:bi7SetFirebaseToken";

        ////// input validation
        call_result = bi1_data_validation.is_string(firebase_token);
        debug_data.push(call_result);

        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation
        var CI = this;
        CI.IV_id_token_pointer = firebase_token;
    }
    setFirebaseParams(firebase_db_object = null, firebase_token = '', firebase_uid = '',firebae_email = '',guest_flag=true) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:setFirebaseParams ";
        var task_id = "bi7_watchdog_firebase:setFirebaseParams";

        ////// input validation
        try {
          call_result = bi1_data_validation.is_string(firebase_db_object['app']['options_']['apiKey']);
          debug_data.push(call_result);
        } catch (err) {
          return_msg += "fire_base_db_object is not valid, errors:" + JSON.stringify(err.message);
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }

        call_result = bi1_data_validation.is_string(firebase_token);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(firebase_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_email_address(firebae_email);
        debug_data.push(call_result);


        var validation_failed = false;
        for (var index in debug_data) {
          if (debug_data[index][CR.success] !== RC.success) {
            validation_failed = true;
          }
        }

        if(validation_failed === true) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        //////</end> input validation
        var CI = this;
        CI.IV_id_token_pointer = firebase_token;
        CI.IV_firebase_uid_pointer = firebase_uid;
        CI.IV_firebase_email_pointer = firebae_email;
        CI.IV_firebase_guest_flag_pointer = guest_flag;
        if (guest_flag === true) {
            CI.IV_user_folder_path = '/user/guest';
        } else {
            CI.IV_user_folder_path = '/user/' + firebase_uid;
            
        }

        CI.IV_firebase_db_object = firebase_db_object;
        CI.IV_instance_initialized = true;
    }

    callCallBackFunction(callback, args = null) {
        var call_result = {};
        var debug_data = [];
        var return_msg = "bi7_watchdog_firebase:callCallBackFunction";
        var task_id = "bi7_watchdog_firebase:callCallBackFunction";

        ////// input validation
        call_result = bi1_data_validation.is_function(callback)
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation

        try {
          if (Array.isArray(args) === true) {
            callback(args)
          } else {
            callback([args])
          }
        } catch (err) {
          return_msg += "callback execution failed with error:" + JSON.stringify(err);
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    bi7ClearAllData() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7ClearAllData ";
        var task_id = "bi7_watchdog_firebase:bi7ClearAllData";
        var CI = this;

        CI.IV_user_info = { 'uid': 0, 'contact_email': '', 'first_name': '', 'last_name': '','web_uid' :'' };
        var deletion_items =  [CI.IV_org_location_strings, CI.IV_org_structure, CI.IV_org_permissions,
            CI.IV_doghouse_history, CI.IV_doghouse_active, CI.IV_meta_data_requests, CI.IV_org_system_joins,
            CI.IV_system_org_joins, CI.IV_system_object_joins, CI.IV_object_attribute_joins,
            CI.IV_object_attribute_values, CI.IV_org_meta_data, CI.IV_objects_meta_data,
            CI.IV_object_attributes_meta_data, CI.IV_presets]
            
        for(var index in deletion_items) {
            for(var key in deletion_items[index]) {
                if(deletion_items[index][key] !== null && deletion_items[index][key] !== undefined) {
                    Vue.delete(deletion_items[index],key);
                }
            }
        }


    }

    bi7CreateDataStoreRequest(type=null,uid=null,timestamp=null,make_cache=true) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7CreateDataStoreRequest ";
        var task_id = "bi7_watchdog_firebase:bi7CreateDataStoreRequest";
        var CI = this;
        ////// input validation
        //sometimes firebase gives us a null value, this will cause to create a request instead of creating a validation issue
        if(timestamp === null) {
            var date_object = new Date();
            // the timestamps for mktime in python are in seconds not ms
            timestamp = date_object.getTime() / 1000;
        }
        call_result = bi1_data_validation.is_string(type);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_bool(make_cache);
        debug_data.push(call_result);

        if(typeof timestamp === 'string') {
            call_result = bi1_data_validation.is_string(timestamp);
            debug_data.push(call_result);

            if(call_result[CR.success] === RC.success) {
                timestamp = parseInt(timestamp)
            }
        }
        call_result = bi1_data_validation.is_number(timestamp);
        debug_data.push(call_result);
        
        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }
        if(type.indexOf('sys_') >= 0) {
            type = type.replace('sys_','obj_')
            uid = uid.replace('sys_','obj_')
        }

        if(validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        //////</end> input validation

        ////  if we already have newer information than requested loaded into intance variables we don't need to do anything
        var newer_data_flag = false;
        switch(type) {
          case 'org_meta_data':
            if (CI.IV_last_updated_timestamps['org_meta_data'][uid] >= timestamp) { newer_data_flag = true; }
          
          case 'obj_meta_data':
            if (CI.IV_last_updated_timestamps['obj_meta_data'][uid] >= timestamp) { newer_data_flag = true; }

          case 'obj_atr_meta_data':
            if (CI.IV_last_updated_timestamps['obj_atr_meta_data'][uid] >= timestamp) { newer_data_flag = true; }
          
          case 'ngp_meta_data':
            if (CI.IV_last_updated_timestamps['ngp_meta_data'][uid] >= timestamp) { newer_data_flag = true; }

        }

        if (newer_data_flag === true) {
          return_msg += "newer data already exists";
          return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
        }
        ////</end>  if we already have newer information than requested loaded into intance variables we don't need to do anything


        ///// sub-function to get the last time the value was updated in indexdb and if the value is local store is new enough to use, use it
        CI.IV_local_forage.getItem(uid,function(error,cached_value_list){
          var call_result = {};
          var debug_data = [];
          var return_msg = "bi7_watchdog_firebase:bi7ProcessMetaDataRequestStep1 ";
          var CI = this;
          var cached_last_updated = null;
          var cached_data = null;

          if(cached_value_list !== null && cached_value_list !== undefined) {
            try {
              cached_last_updated = cached_value_list[0];
              cached_data = cached_value_list[1];
            } catch(error) {
              return_msg += "failed to parse cached_value_list  with error:" + error;
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
              return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
            }
          }

          // request the item since it doesn't exist or is too ol
          if(cached_last_updated === null || cached_last_updated === undefined || parseInt(cached_last_updated) < timestamp) {
              call_result = CI.bi7CreateMetaDataJsonRequest(type,uid,timestamp,make_cache);
              debug_data.push(call_result);
              if (call_result[CR.success] !== RC.success) {
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
              }
            }
          // if no value exists in the db
          if(cached_data === null || cached_data === undefined){
            return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
          }


        ///////  use the value from indexDB even if its going to get replaced, this way there will be placeholder data
        var cache_success = false;
        switch(type) {
            case 'org_meta_data':
              Vue.set(CI.IV_org_meta_data,uid,cached_data);
              CI.IV_last_updated_timestamps['org_meta_data'][uid] = cached_last_updated;
              cache_success = true;
              break;
    
            case 'obj_meta_data':
              Vue.set(CI.IV_objects_meta_data,uid,cached_data);
              CI.IV_last_updated_timestamps['obj_meta_data'][uid] = cached_last_updated;
              cache_success = true;
              break;
    
            case 'obj_atr_meta_data':
              Vue.set(CI.IV_object_attributes_meta_data,uid,cached_data);
              /// Tracking last time an object has received updated meta data for one of its object attributes
              let obj_uid = uid.replace("atr_", "").split("-")[0]
              CI.IV_last_time_metadata_updated_for_objects_attribute[obj_uid] = new Date().getTime()
              ///</end> Tracking last time an object has received updated meta data for one of its object attributes
            
              CI.IV_last_updated_timestamps['obj_atr_meta_data'][uid] = cached_last_updated;
              cache_success = true;
              break;

            case 'ngp_meta_data':
              Vue.set(CI.IV_ngp_meta_data, uid, cached_data);
              CI.IV_last_updated_timestamps['ngp_meta_data'][uid] = cached_last_updated;
              cache_success = true;
              break;
        }  
          if(cache_success !== true) {
            return_msg += "failed to get cached value for " + type + " " + uid;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
          }
            return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
        ///////</end>  use the value from indexDB even if its going to get replaced, this way there will be placeholder data

        }.bind(CI))
        ///// sub-function to get the last time the value was updated in indexdb and if the value is local store is new enough to use, use it
    };
    
    bi7CreateMetaDataJsonRequest(type,uid,request_time,make_cache=true) {
      var call_result = {};
      var debug_data = [];
      var return_msg = "bi7_watchdog_firebase:bi7CreateMetaDataJsonRequest ";
      var task_id = "bi7_watchdog_firebase:bi7CreateMetaDataJsonRequest";

      //// input validation
      call_result = bi1_data_validation.is_string(type);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_number(request_time);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_bool(make_cache);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
          if (debug_data[index][CR.success] !== RC.success) {
              validation_failed = true;
          }
      }
      if(validation_failed === true) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      ////</end> input validation

      var CI = this;
      if (type in CI.IV_meta_data_requests === false) {
        CI.IV_meta_data_requests[type] = {};
      }
      if (uid in CI.IV_meta_data_requests[type] === false) {
        CI.IV_meta_data_requests[type][uid] = {};
      }
      
      CI.IV_meta_data_requests[type][uid]["request_time"] = request_time;
      CI.IV_meta_data_requests[type][uid]["make_cache"] = make_cache;

      // setting retry count for uids to prevent loop after max number of retry
      if (type in CI.IV_meta_data_requests_retry_count === false) {
          CI.IV_meta_data_requests_retry_count[type] = {};
      }
      if (uid in CI.IV_meta_data_requests_retry_count[type] === false) {
        CI.IV_meta_data_requests_retry_count[type][uid] = 0;
      }
      //</end> setting retry count for uids to prevent loop after max number of retry
      return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    bi7ActivelyMonitorSystem(system_uid=null) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7ActivelyMonitorSystem ";
        var task_id = "bi7_watchdog_firebase:bi7ActivelyMonitorSystem";
        var CI = this;
        
        ///// input validation
        call_result = bi1_data_validation.is_system_uid(system_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////</end> input validation
        
        if (system_uid in CI.IV_system_object_joins === false) {
            Vue.set(CI.IV_system_object_joins, system_uid, {});
        }

        if (system_uid in CI.IV_listener_system_all_object_and_attributes_joins === false) {
          CI.bi7LoadCachedJoinData("sys_obj_join-", system_uid);
          CI.bi7InitSystemObjectAndAttributeJoinsListener(system_uid);
        }
    }

    bi7InitSystemObjectAndAttributeJoinsListener(system_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7InitSystemObjectAndAttributeJoinsListener ";
        var task_id = "bi7_watchdog_firebase:bi7InitSystemObjectAndAttributeJoinsListener";

        ///// input validation
        call_result = bi1_data_validation.is_system_uid(system_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////</end> input validation

        var CI = this;
        if(CI.IV_listener_system_all_object_and_attributes_joins[system_uid] !== null &&
            CI.IV_listener_system_all_object_and_attributes_joins[system_uid] !== undefined) {
            return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        var listener_location = 'systems/' + system_uid;
        CI.IV_listener_system_all_object_and_attributes_joins[system_uid] = CI.IV_firebase_db_object.ref(listener_location);

        CI.updateLastJoinListenerStartTime();
        CI.IV_listener_system_all_object_and_attributes_joins[system_uid].on("value",
            function (a_data) {
              CI.SystemAttributeJoinsAndMetaDataListener(system_uid, a_data);
            }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(this));
    }

    SystemAttributeJoinsAndMetaDataListener(system_uid, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:SystemAttributeJoinsAndMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:SystemAttributeJoinsAndMetaDataListener";

        ////// input validation 
        call_result = bi1_data_validation.is_system_uid(system_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data.val() === null || data.val() === undefined) {
            return_msg += "data.val() is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var firebase_data = data.val();
        var CI = this;
        
        var system_object_uids = firebase_data['object_uids'];
        var system_attribute_uids = firebase_data['object_attributes'];

        if (system_object_uids !== null && system_object_uids !== undefined) {
            for (let object_uid in system_object_uids) {

                //ignore last updated entries, the system is technically an object but we don't list it with the objects under the system
                if (object_uid === "last_updated" || object_uid === system_uid.replace('sys_','obj_')) {
                    continue;
                }

                Vue.set(CI.IV_deleted_object_uids, object_uid, {});
                // removing deleted objects from dictionaries and local storage
                if (system_object_uids[object_uid].indexOf('deleted') === 0) {
                    CI.IV_object_live_uids[object_uid] = false;
                    Vue.set(CI.IV_deleted_object_uids, object_uid, true);
                    CI.IV_local_forage.removeItem("sys_obj_join-" + system_uid);
                    CI.IV_local_forage.removeItem("obj_atr_join-" + object_uid);
                }

                //store the object uid
                if (object_uid in CI.IV_objects_meta_data === false) {
                    Vue.set(CI.IV_objects_meta_data,object_uid, {});
                }
                if (object_uid in CI.IV_object_attribute_joins === false) {
                    Vue.set(CI.IV_object_attribute_joins, object_uid, {});
                }
                CI.IV_object_live_uids[object_uid] = true;
                if (object_uid in CI.IV_system_object_joins[system_uid] === false || CI.IV_system_object_joins[system_uid][object_uid] !== object_uid) {
                    Vue.set(CI.IV_system_object_joins[system_uid],object_uid,object_uid);
                    Vue.set(CI.IV_system_object_joins_reverse_lookup,object_uid,system_uid);
                }
                if (object_uid in CI.IV_listener_object_meta_data === false) {
                    CI.initObjectMetaDataListener(object_uid);
                }
            }
        }

        if (system_attribute_uids !== null && system_attribute_uids !== undefined) {
            for (let object_attribute_uid in system_attribute_uids) {

                //ignore last updated entries
                if (object_attribute_uid === "last_updated" || object_attribute_uid === 'deletion_prevention_key') {
                    continue;
                }

                var object_uid = "";
                try {
                    object_uid = `obj_${CI.bi7ExtractNumbers(object_attribute_uid.split("-")[0])}`;
                } catch(error) {
                    return_msg += "failed to JSOn parse firebase data with error:" + error;
                    base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
                    continue;
                }

                // checking if the attribute belongs to any object under this system
                if (object_uid in CI.IV_object_attribute_joins === false) {
                  continue;
                }
                //</end> checking if the attribute belongs to any object under this system

                if (object_attribute_uid in  CI.IV_object_attribute_rule_joins === false) {
                    Vue.set(CI.IV_object_attribute_rule_joins, object_attribute_uid, {})
                }
                if (object_attribute_uid in CI.IV_object_attribute_values === false) {
                    Vue.set(CI.IV_object_attribute_values, object_attribute_uid, {})
                 }

                //store the object attribute join
                if (object_attribute_uid in CI.IV_object_attribute_joins[object_uid] === false) {
                    Vue.set(CI.IV_object_attribute_joins[object_uid],object_attribute_uid,object_attribute_uid);
                    Vue.set(CI.IV_object_attribute_joins_reverse_lookup,object_attribute_uid,object_uid);
                }
                
                if (object_attribute_uid in CI.IV_object_attributes_meta_data === false) {
                    Vue.set(CI.IV_object_attributes_meta_data,object_attribute_uid, {});
                }

                if (object_attribute_uid in CI.IV_listener_object_attributes_meta_data === false) {
                    CI.initObjectAttributeMetaDataListener(object_attribute_uid);
                }

                CI.IV_object_attribute_live_uids[object_attribute_uid] = true;
            }
        }
    }

    setSuccessGlobalCallBack(function_name = '', callback = null) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:setSuccessCallBack ";
        var task_id = "bi7_watchdog_firebase:setSuccessCallBack";
        var CI = this;

        ///// input validation
        call_result = bi1_data_validation.is_function(callback);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        
        call_result = bi1_data_validation.is_string(function_name);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////</end> input validation

        CI.IV_success_global_callbacks[function_name] = callback;
        return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    setFailureGlobalCallBack(function_name = '', callback = null) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:setFailureCallBack ";
        var task_id = "bi7_watchdog_firebase:setFailureCallBack";
        var CI = this;
        
        ///// input validation
        call_result = bi1_data_validation.is_function(callback);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        
        call_result = bi1_data_validation.is_string(function_name);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////</end> input validation

        CI.IV_failure_global_callbacks[function_name] = callback;
        return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    bi7setDataChangedCallback(instance_variable, callback) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7setDataChangedCallback ";
        var task_id = "bi7_watchdog_firebase:bi7setDataChangedCallback";
        var CI = this;
        call_result = bi1_data_validation.is_string(instance_variable);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_function(callback);
        debug_data.push(call_result);
        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }

        if(validation_failed === false && instance_variable in CI.IV_data_change_callbacks === false) {
            return_msg+= 'attempt to set a callback for an instance variable that is not the data change callbacks'
            validation_failed = true;
        }

        if(validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }

        CI.IV_data_change_callbacks[instance_variable] = callback;
        return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
        
    }

    bi7UnsubscribeAllListeners() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7UnsubscribeAllListeners ";
        var task_id = "bi7_watchdog_firebase:bi7UnsubscribeAllListeners";
        var CI = this;

        var listener_dicts = [
            CI.IV_listener_org_permissions,
            CI.IV_listener_orgs,
            CI.IV_listener_org_meta_data,
            CI.IV_listener_object_meta_data,
            CI.IV_listener_object_attributes_meta_data,
            CI.IV_listener_doghouse_active,
            CI.IV_listener_doghouse_history,
            CI.IV_listener_user_info,
            CI.IV_listener_object_attribute_values,
            CI.IV_notification_rules_listener,
            CI.IV_notification_rule_joins_listener,
            CI.IV_listener_object_attribute_parent_system,
            CI.IV_listener_account_notifications,
            CI.IV_listener_org_user_permission_changes,
            CI.IV_global_org_locations_listener,
            CI.IV_global_org_system_joins_listener
        ]
        var failure_flag = false;
        for(var listener_list_index in listener_dicts) {
            for (var listener_key in listener_dicts[listener_list_index]) {
                try {
                    listener_dicts[listener_list_index][listener_key].off();
                    listener_dicts[listener_list_index][listener_key] = null;
                    delete listener_dicts[listener_list_index][listener_key];
                } catch(error) {
                    failure_flag = true;
                    listener_dicts[listener_list_index][listener_key] = null;
                    delete listener_dicts[listener_list_index][listener_key];
                    debug_data.push(JSON.stringify(error))
                }
            }
        }

        if(failure_flag === true) {
            return_msg += "failed to turn some listeners off";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }


    InitOrgListeners() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:InitOrgListeners ";
        var task_id = "bi7_watchdog_firebase:InitOrgListeners";
        var CI = this;

        if (CI.IV_instance_initialized === false) {
            return_msg += 'instance is not initialized';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        var listener_location = CI.IV_user_folder_path +  '/org_permissions';
        CI.IV_listener_org_permissions['all_permissions'] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_org_permissions['all_permissions']);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_org_permissions['all_permissions'];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        Vue.set(CI.IV_org_count_and_loading, 'is_loading', true)

        CI.IV_listener_org_permissions['all_permissions'].on("value",CI.OrgPermissionsListener.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    OrgPermissionsListener(data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:OrgPermissionsListener ";
        var task_id = "bi7_watchdog_firebase:OrgPermissionsListener";
        var CI = this;
        
        ///// input validation
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        /////</end> input validation
        var regenerate_org_tree_flag = false;
        var firebase_data = data.val();

        for (var org_uid in firebase_data) {
            //set the last updated timestamp for the permissions
            if (org_uid === "last_updated") {
                CI.IV_last_updated_timestamps['org_permissions'] =  firebase_data[org_uid]
                continue;
            }
            if(org_uid === 'deletion_prevention_key') {
                continue;
            }
            if (org_uid in CI.IV_org_meta_data === false) {
                Vue.set(CI.IV_org_meta_data,org_uid,{});
                call_result = CI.bi7CreateDataStoreRequest("org_meta_data",org_uid,1);
                debug_data.push(call_result);


                // we'll get one time data from server to verify if we have latest data in cache.
                CI.initOrgMetaDataListener(org_uid, true, "bi7")
            }

            //update the permisions the user has for this org
            if (org_uid in CI.IV_org_permissions === false) {
                Vue.set(CI.IV_org_permissions,org_uid, {});
            }
            if (CI.IV_org_permissions[org_uid]['permissions'] !== firebase_data[org_uid]) {
                Vue.set(CI.IV_org_permissions[org_uid],'permissions', firebase_data[org_uid]);
            }
            regenerate_org_tree_flag = true;
        }

        let org_count = Object.keys(CI.IV_org_permissions).length;
        Vue.set(CI.IV_org_count_and_loading, 'org_count', org_count)

        // We are only getting data of orgs user has permission to.
        // Now org structure changes we'll need to restart these listeners.
        // Or this is running for the first time after page load.
        CI.InitOrgSystemJoinsGlobalListener()
        CI.InitOrgLocationsGlobalListener()

        if(regenerate_org_tree_flag === true) {
            CI.bi7getOrgLocationsOnce(); 
        }
    }

    bi7getOrgLocationsOnce() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7getOrgLocationsOnce ";
        var task_id = "bi7_watchdog_firebase:bi7getOrgLocationsOnce";
        var CI = this;

        var listener_location = 'org_parents/';
        var listener_ref = CI.IV_firebase_db_object.ref(listener_location);

        listener_ref.once("value",
            function (a_data) { CI.OrgLocationsGlobalListener(a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI)
        );
    }

    InitOrgSystemJoinsGlobalListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:InitOrgSystemJoinsGlobalListener ";
        var task_id = "bi7_watchdog_firebase:InitOrgSystemJoinsGlobalListener";
        var CI = this;

        var listener_location = 'org_systems_v2'

        CI.IV_global_org_system_joins_listener = CI.IV_firebase_db_object.ref(listener_location);

        CI.updateLastJoinListenerStartTime();
        CI.IV_global_org_system_joins_listener.on("value",
            function (a_data) {
              CI.OrgSystemJoinsGlobalListener(a_data);              
            }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(this));
    }

    OrgSystemJoinsGlobalListener(data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:OrgSystemJoinsGlobalListener ";
        var task_id = "bi7_watchdog_firebase:OrgSystemJoinsGlobalListener";

        var regenerate_org_tree_flag = false;
        ////// input validation 
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        var firebase_data = data.val();
        for (var org_uid in firebase_data) {

          // checking if user has read permissions to this org.
          if (org_uid in CI.IV_org_permissions === false) {
            continue;
          }

          // checking if user has read/view permission for systems under this org.
          let org_permissions = CI.IV_org_permissions[org_uid]['permissions'];
          if (org_permissions.includes("a") === false && org_permissions.includes("l") === false) {
            continue;
          }

          if (org_uid in CI.IV_org_system_joins === false) {
            Vue.set(CI.IV_org_system_joins,org_uid,{});
          }

          var systems_list = firebase_data[org_uid];
          for (var system_uid in systems_list) {
            //ignore last updated entries
            if (system_uid === 'deletion_prevention_key' || system_uid === "last_updated") {
                continue;
            }

            const system_properties = systems_list[system_uid];
            const actual_sys_uid = `sys_${system_uid}`;

            for (let key in system_properties) {
              // /// Setting system's online Status

              // mu- Deprecated, We are starting online system's listener for only visible systems
              // This code block could be removed in new PR once new functionality is tested properly.

              // if (key.indexOf("cs_") === 0) {
              //   let sys_online_attribute_uid = `obj_atr_${system_uid}-8`;

              //   //// Deleting system's online status entry if we get deleted: flag
              //   if (system_properties[key].indexOf('deleted:') === 0) {
              //     Vue.delete(CI.IV_object_attribute_values, sys_online_attribute_uid);
              //     continue;
              //   }
              //   ////</end> Deleting system's online status entry if we get deleted: flag
                
              //   if (sys_online_attribute_uid in CI.IV_object_attribute_values === false) {
              //     Vue.set(CI.IV_object_attribute_values, sys_online_attribute_uid, {});
              //   }

              //   Vue.set(CI.IV_object_attribute_values[sys_online_attribute_uid], "value", system_properties[key]);
              //   continue;
              // }
              // ///</end> Setting system's online Status

              /// Setting org's system joins
              if (key.indexOf("sys_") === 0) {

                //// Deleting system from org system joins if we get deleted: flag
                if (system_properties[key].indexOf('deleted:') === 0) {
                    Vue.delete(CI.IV_org_system_joins[org_uid], actual_sys_uid, actual_sys_uid);
                    Vue.delete(CI.IV_system_org_joins,actual_sys_uid, org_uid);
                    delete(CI.IV_system_live_uids[actual_sys_uid]);
                    
                    //if the preset data has already been generated update it
                    regenerate_org_tree_flag = true;
                    continue;
                }
                ////</end> Deleting system from org system joins if we get deleted: flag

                //this has to be set for values already cached and non-cached data or the systems will be deleted from cache.
                CI.IV_system_live_uids[actual_sys_uid] = true; 

                if (actual_sys_uid in CI.IV_org_system_joins[org_uid] === false) {
                    Vue.set(CI.IV_org_system_joins[org_uid], actual_sys_uid, actual_sys_uid);
                    Vue.set(CI.IV_system_org_joins, actual_sys_uid, org_uid);
                    regenerate_org_tree_flag = true;
                }

                var sys_obj_uid = actual_sys_uid.replace("sys_", "obj_");
                if (sys_obj_uid in CI.IV_objects_meta_data === false) {
                  Vue.set(CI.IV_objects_meta_data, sys_obj_uid, {});
                  call_result = CI.bi7CreateDataStoreRequest("obj_meta_data", sys_obj_uid, 1);
                  debug_data.push(call_result);

                  // we'll get one time data from server to verify if we have latest data in cache.
                  CI.initSysMetaDataListener(actual_sys_uid, true, "bi7")
                }
              }
              ///</end> Setting org's system joins
            
              /// Setting system last_time location changed timestamp
              if (key.indexOf("ldf_") === 0) {
                //// Deleting system from org system joins if we get deleted: flag
                if (system_properties[key].indexOf('deleted:') === 0) {
                    Vue.delete(CI.IV_org_system_joins[org_uid], actual_sys_uid, actual_sys_uid);
                    Vue.delete(CI.IV_system_org_joins,actual_sys_uid, org_uid);
                    delete(CI.IV_system_live_uids[actual_sys_uid]);
                    delete(CI.IV_last_time_sys_location_updated[actual_sys_uid])
                    //if the preset data has already been generated update it
                    regenerate_org_tree_flag = true;
                    continue;
                }
                ////</end> Deleting system from org system joins if we get deleted: flag

                if (system_properties[key].indexOf('ldf_removed:') === 0) {
                  delete(CI.IV_last_time_sys_location_updated[actual_sys_uid])
                  continue;
                }

                Vue.set(CI.IV_last_time_sys_location_updated, actual_sys_uid, system_properties[key])
                continue;
              }
              ///</end> Setting system last_time location changed timestamp
              
              /// setting more properties last_updated time for object metadata, attribute metadata, device_structure
              if (key.indexOf("luds_") === 0) {
                Vue.set(CI.IV_last_time_sys_devices_structure_updated, actual_sys_uid, system_properties[key])
                continue;
              }

              if (key.indexOf("lud_") === 0) {
                Vue.set(CI.IV_last_time_obj_metadata_updated_for_system, actual_sys_uid, system_properties[key])
                continue;
              }

              if (key.indexOf("luda_") === 0) {
                Vue.set(CI.IV_last_time_obj_atr_metadata_updated_for_system, actual_sys_uid, system_properties[key])
                continue;
              }
              ///</END> setting more properties last_updated time for object metadata, attribute metadata, device_structure
            }
          }
        }
        CI.updateLastJoinDataChanged();

        //only update the org tree if it has already been generated once.
        if(regenerate_org_tree_flag === true && 
            CI.IV_last_updated_timestamps['presets']['all_preset'] !== null &&
            CI.IV_last_updated_timestamps['presets']['all_preset'] !== undefined
          ) {
            var date_object = new Date();
            CI.IV_last_updated_timestamps['presets']['all_preset'] = date_object.getTime() / 1000;
        }

        // This will be checked in org_sys_global listener to stop loading on dashboard
        CI.IV_first_time_org_sys_joins_loaded = true;
        
        // if the org_sys_joins also loaded we can stop showing loading on dashboard
        if (CI.IV_first_time_orgs_Locations_loaded === true && CI.IV_org_count_and_loading['is_loading'] === true) {
          
          // Estimation that the build preset will take around 3 seconds.
          setTimeout(function() { 
            Vue.set(CI.IV_org_count_and_loading, 'is_loading', false);
          }.bind(CI),3000);
        }
    }

    InitOrgLocationsGlobalListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:InitOrgLocationsGlobalListener ";
        var task_id = "bi7_watchdog_firebase:InitOrgLocationsGlobalListener";

        var CI = this;
        var listener_location = 'org_parents/';
        CI.IV_global_org_locations_listener = CI.IV_firebase_db_object.ref(listener_location);

        CI.IV_global_org_locations_listener.on("value",
            function (a_data) { CI.OrgLocationsGlobalListener(a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    OrgLocationsGlobalListener(data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:OrgLocationsGlobalListener ";
        var task_id = "bi7_watchdog_firebase:OrgLocationsGlobalListener";

        ////// input validation 
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        var firebase_data = data.val();
        var regenerate_org_tree_flag = false;

        for (var org_uid in firebase_data) {
            // checking if user has read permissions to this org and view systems.
            if (org_uid in CI.IV_org_permissions === false) {
              continue;
            }

            regenerate_org_tree_flag = true;
            let org_location = firebase_data[org_uid];

            if (org_location === "last_updated" || org_location === null) {
                return;
            }
            //org1 is the parent org of all orgs in the UI we ignore it.
            CI.IV_org_location_strings[org_uid] = org_location.replace(/<~!ORG!~>/g,'org_')
            org_location = org_location.replace('<~!ORG!~>1','');

            var org_structure = org_location.split('<~!ORG!~>');

            ////recursively go through the org structure dictionary and make sure all the org structures are there
            //think of last_location as an array of pointers with the last entry in the array being our most recent location in CI.IV_org_structure
            var last_location = [];
            last_location.push(CI.IV_org_structure);
            Vue.set(CI.IV_org_parents_lookup,org_uid,[]);
            for (var index in org_structure) {
                if (org_structure[index] === '') {
                    continue;
                }
                var org_parents_list = [];
                //when we do the split we get numbers without the org prefix, this just adds it back
                var last_org_location_uid = 'org_' + org_structure[index];
                if(last_org_location_uid !== org_uid) {
                    CI.IV_org_parents_lookup[org_uid].push(last_org_location_uid);
                }

                //if the org doesn't exist under the current org create it
                if (last_org_location_uid in last_location[last_location.length - 1] === false) {
                    last_location[last_location.length - 1][last_org_location_uid] = {};
                }
                //set the new pointer to the existing org or the one we just created
                last_location.push(last_location[last_location.length - 1][last_org_location_uid]);

            }
            ////</end>recursively go through the org structure dictionary and make sure all the org structures are there
            if (org_uid in CI.IV_org_locations === false || CI.IV_org_locations[org_uid] !== org_structure) {
                CI.IV_org_locations[org_uid] = org_structure;
            }
        }
        
        // This will be checked in org_sys_global listener to stop loading on dashboard
        CI.IV_first_time_orgs_Locations_loaded = true;
        
        // if the org_sys_joins also loaded we can stop showing loading on dashboard
        if (CI.IV_first_time_org_sys_joins_loaded === true && CI.IV_org_count_and_loading['is_loading'] === true) {

          // Estimation that the build preset will take around 3 seconds.
          setTimeout(function() { 
            Vue.set(CI.IV_org_count_and_loading, 'is_loading', false);
          }.bind(CI),3000);
        }
        if (regenerate_org_tree_flag === true) {
          var date_object = new Date();
          CI.IV_rebuild_data_requests['presets']['all_preset'] = date_object.getTime();
        }

    }

    initOrgMetaDataListener(org_uid, remove_listener_command=null, component_id=null) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:initOrgMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:initOrgMetaDataListener";

        ////// input validation 
        if (component_id !== null && component_id !== undefined) {
          call_result = bi1_data_validation.is_string(component_id);
          debug_data.push(call_result);
          if (call_result[CR.success] !== RC.success) {
              return_msg += "input validation failed";
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
              return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
          }
        }
        call_result = bi1_data_validation.is_org_uid(org_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;

        // new listener_key_id will generate component specific listeners key.
        var listener_key_id = org_uid;
        if (component_id !== null && component_id !== undefined) {
          listener_key_id = component_id+"_"+org_uid
        }

        if (listener_key_id in CI.IV_listener_org_meta_data === true) { return; }

        if (org_uid in CI.IV_org_meta_data === false) {
            Vue.set(CI.IV_org_meta_data,org_uid,{});
        }

        var listener_location = 'organization/' + org_uid + '/meta_data/';
        CI.IV_listener_org_meta_data[listener_key_id] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_org_meta_data[listener_key_id]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_org_meta_data[listener_key_id];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_org_meta_data[listener_key_id].on("value",
            function (a_data) { CI.OrgMetaDataListener(org_uid, a_data, remove_listener_command, component_id) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    OrgMetaDataListener(org_uid, data, remove_listener_command=null, component_id=null) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:OrgMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:OrgMetaDataListener";

        ////// input validation 
        if (component_id !== null && component_id !== undefined) {
          call_result = bi1_data_validation.is_string(component_id);
          debug_data.push(call_result);
          if (call_result[CR.success] !== RC.success) {
              return_msg += "input validation failed";
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
              return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
          }
        }
        call_result = bi1_data_validation.is_org_uid(org_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation
        var CI = this;
        var firebase_data = data.val();
        for(var name in firebase_data) {
            if (name === 'last_updated') {
                CI.bi7CreateDataStoreRequest('org_meta_data',org_uid,firebase_data[name]);
            } else if (name === 'type') {
              if (org_uid in CI.IV_org_meta_data === false || CI.IV_org_meta_data[org_uid] === null || CI.IV_org_meta_data[org_uid] === undefined) {
                  Vue.set(CI.IV_org_meta_data, org_uid, {});
              }
              Vue.set(CI.IV_org_meta_data[org_uid], 'type', firebase_data[name]);
            }
        }

        // removing listeners when getting data for the first time.
        if (remove_listener_command === true) {

          // new listener_key_id will generate component specific listeners key.
          var listener_key_id = org_uid;
          if (component_id !== null && component_id !== undefined) {
            listener_key_id = component_id+"_"+org_uid
          }
          CI.IV_listener_org_meta_data[listener_key_id].off();
          CI.IV_listener_org_meta_data[listener_key_id] = null;
          delete CI.IV_listener_org_meta_data[listener_key_id];   
        }
    }

    initSysMetaDataListener(system_uid, remove_listener_command=null, component_id=null) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:initSysMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:initSysMetaDataListener";

        ////// input validation 
        if (component_id !== null && component_id !== undefined) {
          call_result = bi1_data_validation.is_string(component_id);
          debug_data.push(call_result);
          if (call_result[CR.success] !== RC.success) {
              return_msg += "input validation failed";
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
              return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
          }
        }
        call_result = bi1_data_validation.is_system_uid(system_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;
        //systems are really just objects to the DB
        var system_object_uid = system_uid.replace('sys_','obj_')

        // new listener_key_id will generate component specific listeners key.
        var listener_key_id = system_object_uid;
        if (component_id !== null && component_id !== undefined) {
          listener_key_id = component_id+"_"+system_object_uid
        }

        if (listener_key_id in CI.IV_listener_object_meta_data === true) { return; }

        var listener_location = 'objects/' + system_object_uid + '/meta_data/last_updated';
        CI.IV_listener_object_meta_data[listener_key_id] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_object_meta_data[listener_key_id]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_object_meta_data[listener_key_id];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_object_meta_data[listener_key_id].on("value",
            function (a_data) { CI.SysMetaDataListener(system_object_uid, a_data, remove_listener_command, component_id) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    SysMetaDataListener(system_object_uid, data, remove_listener_command=null, component_id=null) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:SysMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:SysMetaDataListener";

        ////// input validation 
        if (component_id !== null && component_id !== undefined) {
          call_result = bi1_data_validation.is_string(component_id);
          debug_data.push(call_result);
          if (call_result[CR.success] !== RC.success) {
              return_msg += "input validation failed";
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
              return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
          }
        }
        call_result = bi1_data_validation.is_object_uid(system_object_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        var firebase_data = data.val();
        CI.bi7CreateDataStoreRequest("obj_meta_data",system_object_uid,firebase_data);

        // removing listeners when getting data for the first time.
        if (remove_listener_command === true) {

          // new listener_key_id will generate component specific listeners key.
          var listener_key_id = system_object_uid;
          if (component_id !== null && component_id !== undefined) {
            listener_key_id = component_id+"_"+system_object_uid
          }
          CI.IV_listener_object_meta_data[listener_key_id].off();
          CI.IV_listener_object_meta_data[listener_key_id] = null;
          delete CI.IV_listener_object_meta_data[listener_key_id];   
        }
    }

    initObjectAttributeMetaDataListener(object_attribute_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:initObjectAttributeMetaDataListener ";
      var task_id = "bi7_watchdog_firebase:initObjectAttributeMetaDataListener";
      var CI = this;
      var object_uid = '';

      ////// input validation 
      call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
      debug_data.push(call_result);
      call_result = CI.bi7GetObjectUidFromOjbectAttributeUid(object_attribute_uid)
      if(call_result['success'] === RC.success) {
        object_uid = call_result['object_uid']
      }
      debug_data.push(call_result);
      
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
      }
      //////</end> input validation 

      if (object_attribute_uid in CI.IV_object_attributes_meta_data === false) {
        Vue.set(CI.IV_object_attributes_meta_data,object_attribute_uid, {});
      }

      /// using Cached data to show fast loading then the new data(if updated) will automatically be updated
      /// Use system's last updated timestamp if available instead of making listener
      let numeric_sys_uid = (object_attribute_uid.split("_")[2]).split("-")[0]
      let actual_sys_uid = `sys_${numeric_sys_uid}`;

      if (actual_sys_uid in CI.IV_last_time_obj_atr_metadata_updated_for_system === true) {
        let last_updated = CI.IV_last_time_obj_atr_metadata_updated_for_system[actual_sys_uid]

        CI.bi7CreateDataStoreRequest('obj_atr_meta_data', object_attribute_uid, last_updated);
      } else {
        CI.bi7CreateDataStoreRequest('obj_atr_meta_data', object_attribute_uid, 1);
      }
      ///</end> Use system's last updated timestamp if available instead of making listener
      
      ///// if a listener isn't active for this object attribute start one
      if (object_attribute_uid in CI.IV_listener_object_attributes_meta_data === false) {
        var listener_location = 'objects/' + object_uid + '/attribute_list/' + object_attribute_uid + '/last_updated';
        CI.IV_listener_object_attributes_meta_data[object_attribute_uid] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_object_attributes_meta_data[object_attribute_uid]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_object_attributes_meta_data[object_attribute_uid];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_object_attributes_meta_data[object_attribute_uid].on("value",
          function (a_data) { CI.ObjectAttributeMetaDataListener(object_attribute_uid, a_data) }.bind(CI),
          function (errorObject) {
              return_msg += "firebase read failed with error data:" + errorObject;
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          }.bind(this)
        );
      }
      /////</end> if a listener isn't active for this object attribute start one
    }

    ObjectAttributeMetaDataListener(object_attribute_uid, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:ObjectAttributeMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:ObjectAttributeMetaDataListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;
        var firebase_data = data.val();
        CI.bi7CreateDataStoreRequest('obj_atr_meta_data',object_attribute_uid,firebase_data);
    }

    bi7processDataStoreRequests(batch_request_check=false) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7processDataStoreRequests ";
        var task_id = "bi7_watchdog_firebase:bi7processDataStoreRequests";
        var CI = this;
        if(CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
            setTimeout(CI.bi7processDataStoreRequests.bind(CI),500);
            return;
        }

        var now_time = new Date();
        var now_time_epoch = now_time.getTime() / 1000;
        // we don't want to run the requests process too fast when there are very items in queue, this is because we want to ensure things are being run in efficent size batches
        if(batch_request_check === true) {
          var last_request_run_time_difference = now_time_epoch - CI.IV_process_datastore_last_run_time
          if( CI.IV_process_datatore_last_request_count < 2 && last_request_run_time_difference < 1) {
            return;
          }
        }
        
        //this acts as a safety in case bi7processDataStoreRequests crashes while running and doesn't set IV_process_datastore_request_active back to false
        if( CI.IV_process_datastore_request_active === true 
          && (now_time_epoch - CI.IV_process_datastore_last_run_time) > 20) {
            CI.IV_process_datastore_request_active = false;
        }


        if(CI.IV_process_datastore_request_active === true) {
          setTimeout(CI.bi7processDataStoreRequests.bind(CI),100);
            return;
        }
        CI.IV_process_datastore_request_active = true;
        var request_list = {};
        var request_list_string = '';
        var delete_list = {};
        var requst_count = 0;
        var max_request_count = 200;
        var prefix_comma = false;
        ///// build the request list and the list of requests we already processed
        for(var type in CI.IV_meta_data_requests) {
            for(var uid in CI.IV_meta_data_requests[type]) {
                //if the uid doesn't exist it means we've never gotten data for it
                if( uid in CI.IV_last_updated_timestamps[type] === false || CI.IV_meta_data_requests[type][uid]['request_time'] > CI.IV_last_updated_timestamps[type][uid])
                {
                    //// checking the uid retry count for this uid.
                    if (type in CI.IV_meta_data_requests_retry_count === false) {
                      CI.IV_meta_data_requests_retry_count[type] = {};
                    }
                    if (uid in CI.IV_meta_data_requests_retry_count[type] === false) {
                      CI.IV_meta_data_requests_retry_count[type][uid] = 0;
                    }

                    /// removing from request queue if reaches max retry count.
                    if (CI.IV_meta_data_requests_retry_count[type][uid] < CI.IV_meta_data_requests_max_retry_count) {
                      CI.IV_meta_data_requests_retry_count[type][uid] += 1;
                    } else {
                      delete CI.IV_meta_data_requests_retry_count[type][uid];
                      delete CI.IV_meta_data_requests[type][uid];
                      continue;
                    }
                    ///</end> removing from request queue if reaches max retry count.
                    ////</end> checking the uid retry count for this uid.

                    if(type in request_list === false) { request_list[type] = {}; }
                    if(uid in request_list[type] === false) { request_list[type][uid] = {}; }
                    request_list[type][uid]['request_time'] = CI.IV_meta_data_requests[type][uid]['request_time'];
                    request_list[type][uid]['make_cache'] = CI.IV_meta_data_requests[type][uid]['make_cache'];
                    
                    if(prefix_comma === true) { 
                        request_list_string += ','
                    }
                    requst_count += 1;
                    request_list_string += uid;
                    if(prefix_comma === false) {
                      prefix_comma = true;
                    }

                } else if (CI.IV_meta_data_requests[type][uid]['request_time'] < CI.IV_last_updated_timestamps[type][uid]) {
                    if(type in delete_list === false) { delete_list[type] = {}; }
                    delete_list[type][uid] = CI.IV_meta_data_requests[type][uid];   
                }
                if(requst_count > max_request_count) {
                  break;
                }
            }
            if(requst_count > max_request_count) {
              break;
            }
        }
        /////</end> build the request list and the list of requests we already processed

        ///// delete the requests we already processed
        for(var type in delete_list) {
            for(var uid in delete_list[type]) {
                delete CI.IV_meta_data_requests[type][uid];

                // clearing up uid from retry count structure for future.
                // In case we need to fetch updated value for this uid.
                if (type in CI.IV_meta_data_requests_retry_count === true) {
                  if (uid in CI.IV_meta_data_requests_retry_count[type] === true) {
                    delete CI.IV_meta_data_requests_retry_count[type][uid];
                  }
                }
                //</end> clearing up uid from retry count structure for future.
                //</end> In case we need to fetch updated value for this uid.
            }
        }
        /////</end> delete the requests we already processed

        if(request_list_string.length < 1) {
            setTimeout(CI.bi7processDataStoreRequests.bind(CI),2000);
            CI.IV_process_datatore_last_request_count = 0;
            CI.IV_process_datastore_request_active = false;
            return;
        }
        CI.IV_process_datatore_last_request_count = requst_count;
        ////// send the request
        var date_object = new Date();
        //JS getTime is in ms, pythong time function is in seconds. we have to compare to server data from python so we store it in seconds.
        var latest_data_time = date_object.getTime() / 1000;
        ajax({
            url: window.G_ajax_test_domain + '/json-requests/p2s7t3-get-object-info',
            method: 'POST',
            dataType: "json",
            data: {
                'p2s7_token': CI.IV_id_token_pointer,
                'p2s7_firebase_email': CI.IV_firebase_email_pointer,
                'p2s7t3_object_list': request_list_string
            },

            success: function (payload) {
                CI = this;                
                for (var key in payload) {
                    if (key.indexOf('org_') === 0) {
                        Vue.set(CI.IV_org_meta_data,key,payload[key]);
                        CI.IV_last_updated_timestamps['org_meta_data'][key] = latest_data_time;

                        if (key in CI.IV_meta_data_requests['org_meta_data'] === true) {
                          if ('make_cache' in CI.IV_meta_data_requests['org_meta_data'][key] &&
                              CI.IV_meta_data_requests['org_meta_data'][key]['make_cache'] === true) {
                              CI.IV_local_forage.setItem(key, [latest_data_time,payload[key]]);
                          }
                        }
                    } else if (key.indexOf('obj_atr_') === 0) {
                        if ('settable_value_string_values' in payload[key] && typeof payload[key]['settable_value_string_values'] === 'string') {
                            payload[key]['settable_value_string_values'] = payload[key]['settable_value_string_values'].split(',');
                        }
                        Vue.set(CI.IV_object_attributes_meta_data,key,payload[key]);

                        /// Tracking last time an object has received updated meta data for one of its object attributes
                        let obj_uid = uid.replace("atr_", "").split("-")[0];
                        CI.IV_last_time_metadata_updated_for_objects_attribute[obj_uid] = new Date().getTime();
                        ///</end> Tracking last time an object has received updated meta data for one of its object attributes

                        CI.IV_last_updated_timestamps['obj_atr_meta_data'][key] = latest_data_time;
                        
                        if (key in CI.IV_meta_data_requests['obj_atr_meta_data'] === true) {
                          if ('make_cache' in CI.IV_meta_data_requests['obj_atr_meta_data'][key] &&
                              CI.IV_meta_data_requests['obj_atr_meta_data'][key]['make_cache'] === true) {
                              CI.IV_local_forage.setItem(key, [latest_data_time,payload[key]]);
                          } else {

                            // if we are not making cache it means we are fetching data for CSV.
                            // So, we'll populate this attribute name to default names dictionary.
                            // Other attributes with same num_uid will be able use this name.
                            CI.IV_default_obj_attribute_names[key.split("-")[1]] = payload[key].name;
                          }
                        }
                    } else if (key.indexOf('obj_') === 0) {
                        Vue.set(CI.IV_objects_meta_data,key,payload[key]);
                        CI.IV_last_updated_timestamps['obj_meta_data'][key] = latest_data_time;
                        
                        if (key in CI.IV_meta_data_requests['obj_meta_data'] === true) {
                          if ('make_cache' in CI.IV_meta_data_requests['obj_meta_data'][key] &&
                              CI.IV_meta_data_requests['obj_meta_data'][key]['make_cache'] === true) {
                              CI.IV_local_forage.setItem(key, [latest_data_time,payload[key]]);
                          }
                        }
                    } else if (key.indexOf('usr_') === 0) {
                        CI.IV_last_updated_timestamps['usr_contact_email'][key] = latest_data_time;
                        Vue.set(CI.IV_users_contact_email,key,payload[key]['email']);
                    } else if (key.indexOf('ngp_') == 0) {
                        CI.IV_last_updated_timestamps['ngp_meta_data'][key] = latest_data_time;
                        Vue.set(CI.IV_ngp_meta_data,key,payload[key]);
                        CI.IV_local_forage.setItem(key, [latest_data_time,payload[key]]);
                    }

                }
                CI.IV_process_datastore_last_run_time = now_time_epoch;
                CI.IV_process_datastore_request_active = false;

            }.bind(CI),
            error: function (error) {
              
              if (error.status === 401) {
                window.G_firebase_auth.bi5forceTokenRefresh();
              }
              return_msg += "p2s7t3 failed with error data:" + JSON.stringify(error);
              CI.IV_process_datastore_request_active = false;
              CI.IV_process_datastore_last_run_time = now_time_epoch;
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI)
        });
        ////// </end> send the request        
        setTimeout(CI.bi7processDataStoreRequests.bind(CI),1000);
        return;
    }

    bi7BuildPresets() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7BuildPresets ";
        var task_id = "bi7_watchdog_firebase:bi7BuildPresets";
        var function_name = 'bi7BuildPresets';
        var CI = this;
        if(CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
            setTimeout(CI.bi7BuildPresets.bind(CI),1000);
            return;
        }
        var date_object = new Date();
        //we set the last updated time in the past so that if an update occurs while the rebuild is happening it will be caught
        var last_updated_time = date_object.getTime() - 1000;
        if('all_preset' in CI.IV_last_updated_timestamps['presets'] === false || 
            CI.IV_last_updated_timestamps['presets']['all_preset'] < CI.IV_rebuild_data_requests['presets']['all_preset']
          ) {
            Vue.set(CI.IV_presets,'all_preset',CI.bi7BuildPresetsFlagOrgs(JSON.parse(JSON.stringify(CI.IV_org_structure)), null, '', '1'));
            CI.IV_last_updated_timestamps['presets']['all_preset'] = last_updated_time;
        }
        setTimeout(CI.bi7BuildPresets.bind(CI),3000);        
    }

    bi7BuildPresetsFlagOrgs(org, org_uid = null, parent_key = '', preset_id) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7BuildPresetsFlagOrgs ";
        var task_id = "bi7_watchdog_firebase:bi7BuildPresetsFlagOrgs";
        
        ////// input validation 
        if (org_uid !== null && org_uid !== undefined) {
          call_result = bi1_data_validation.is_org_uid(org_uid);
          debug_data.push(call_result);
        }
        call_result = bi1_data_validation.is_string(parent_key);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(preset_id);
        debug_data.push(call_result);

        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }

        if(validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        //////</end> input validation 
        
        var CI = this;
        var nodes = {};
        var system_nodes = [];
        var org_nodes = [];
        var sub_org_nodes = [];

        //we only want the last entry in a key to have the full prefix
        parent_key = parent_key.replace('org_', 'O');
        parent_key = parent_key.replace('sys_', 'S');
        ////if the org has systems add them to it
        if (org_uid !== null && org_uid !== undefined && org_uid in CI.IV_org_system_joins) {
            for (var system_uid in CI.IV_org_system_joins[org_uid]) {
                if (system_uid === "last_updated") { continue; }
                system_nodes.push({ 'isSys': true, 'uid': system_uid, 'key': preset_id + parent_key + system_uid });
            }
        }
        ////</end>if the org has systems add them to it
        for (var suborg in org) {

            //go a level deeper
            var lower_level_org_sys_dict = CI.bi7BuildPresetsFlagOrgs(org[suborg], suborg, parent_key + suborg, preset_id);
            if ('orgs' in lower_level_org_sys_dict === true || 'systems' in lower_level_org_sys_dict === true) {
                org_nodes.push({ 'uid': suborg, 'key': preset_id + parent_key + suborg, 'isOrg': true, 'nodes': lower_level_org_sys_dict });
            } else {
                org_nodes.push({ 'uid': suborg, 'key': preset_id + parent_key + suborg, 'isOrg': true });
            }
        }


        if (org_nodes.length > 0) {
            nodes['orgs'] = org_nodes;
        }
        if (system_nodes.length > 0) {
            nodes['systems'] = system_nodes;
        }
        return (nodes);
    }

    initObjectMetaDataListener(object_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:initObjectMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:initObjectMetaDataListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_uid(object_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;

        /// Return if we already have an active listener
        if (object_uid in CI.IV_listener_object_meta_data == true) {
            return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///</end> Return if we already have an active listener
        
        /// using Cached data to show fast loading then the new data(if updated) will automatically be updated
        /// Use system's last updated timestamp if available instead of making listener
        let sys_uid = CI.IV_system_object_joins_reverse_lookup[object_uid]

        if (sys_uid in CI.IV_last_time_obj_metadata_updated_for_system === true) {
          let last_updated = CI.IV_last_time_obj_metadata_updated_for_system[sys_uid]

          CI.bi7CreateDataStoreRequest('obj_meta_data', object_uid, last_updated);
        } else {
          CI.bi7CreateDataStoreRequest("obj_meta_data", object_uid ,1);
        }
        ///</end> Use system's last updated timestamp if available instead of making listener

        var listener_location = 'objects/' + object_uid + '/meta_data/last_updated';
        CI.IV_listener_object_meta_data[object_uid] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_object_meta_data[object_uid]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_object_meta_data[object_uid];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_object_meta_data[object_uid].on("value",
            function (a_data) { CI.ObjectMetaDataListener(object_uid, a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    ObjectMetaDataListener(object_uid, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:ObjectMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:ObjectMetaDataListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_uid(object_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        var firebase_data = data.val();
        CI.bi7CreateDataStoreRequest("obj_meta_data",object_uid,firebase_data);

    }


    bi7initObjectAttributeValueListener(object_attribute_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7initObjectAttributeValueListener ";
        var task_id = "bi7_watchdog_firebase:bi7initObjectAttributeValueListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;
        var listener_location = 'newest_obj_atr_values/' + object_attribute_uid + '/';
        
        if (object_attribute_uid in CI.IV_object_attribute_values === false){
            Vue.set(CI.IV_object_attribute_values,object_attribute_uid,{});
        }
        if(object_attribute_uid in CI.IV_listener_object_attribute_values && 
          CI.IV_listener_object_attribute_values[object_attribute_uid] !== null &&
          CI.IV_listener_object_attribute_values[object_attribute_uid] !== undefined
        ) {
            return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        CI.IV_listener_object_attribute_values[object_attribute_uid] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_object_attribute_values[object_attribute_uid]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_object_attribute_values[object_attribute_uid];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_object_attribute_values[object_attribute_uid].on("value",
            function (a_data) { CI.ObjectAttributeValueListener(object_attribute_uid, a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    ObjectAttributeValueListener(object_attribute_uid, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:ObjectMetaDataListener ";
        var task_id = "bi7_watchdog_firebase:ObjectMetaDataListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        var firebase_data = data.val();
        if (firebase_data === null) { // the object attribute may have no data yet
          return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        Vue.set(CI.IV_object_attribute_values[object_attribute_uid],'value', firebase_data['value']);
        Vue.set(CI.IV_object_attribute_values[object_attribute_uid],'last_updated', firebase_data['last_updated']);
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    InitUserInfoListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:InitUserInfoListener ";
        var task_id = "bi7_watchdog_firebase:InitUserInfoListener";
        var CI = this;

        if (CI.IV_instance_initialized === false) {
            return_msg += 'instance is not initialized';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        /*when a new user is made, these directories the server creates the users directory after the client 
        subscribes, creating the folder ensures that when the cserver creates the data, the client will get the 
        update.*/

        var folder_missing_flag = false;
        for(var key in CI.IV_user_folder_valid.folders) {
            if(CI.IV_user_folder_valid.folders[key] === false) {
                folder_missing_flag = true;
                var folder_name  = key.toString();
                var user_folder_created_callback = function() {
                    CI.IV_user_folder_valid.folders[folder_name] = true;
                }.bind(CI)

                CI.bi7CreateUserFolderIfNotExists(CI.IV_user_folder_path +  '/' + key ,user_folder_created_callback);
            }
        }

        if(folder_missing_flag !== false) {
            setTimeout(function() { CI.InitUserInfoListener();}.bind(CI),300);
            return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }


        var listener_location = CI.IV_user_folder_path +  '/meta_data';
        CI.IV_listener_user_info['info'] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_user_info['info']);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_user_info['info'];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_user_info['info'].on("value",CI.UserInfoListener.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    UserInfoListener(data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:UserInfoListener ";
        var task_id = "bi7_watchdog_firebase:UserInfoListener";
        
        ////// input validation 
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;
        var firebase_data = data.val();

        for (var field in firebase_data) {
             if(field in CI.IV_user_info) {
                CI.IV_user_info[field] = firebase_data[field];
                CI.IV_user_folder_valid[field] = true;
            }
        }
        var fields_missing = false;
        for(var key in CI.IV_user_folder_valid) {
            if(CI.IV_user_folder_valid[key] === false) {
                fields_missing = true;
            }
        }
        if(fields_missing === true) { 
            return;
        }
        CI.callCallBackFunction(CI.IV_data_change_callbacks['IV_user_info']);
    }

    bi7CreateUserFolderIfNotExists(folder,finished_callback) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7CreateUserFolderIfNotExists ";
        var task_id = "bi7_watchdog_firebase:bi7CreateUserFolderIfNotExists";

        ////// input validation
        call_result = bi1_data_validation.is_string(folder);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_function(finished_callback);
        debug_data.push(call_result);

        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }

        if(validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////// </end> input validation

        var CI = this;
        if (CI.IV_instance_initialized === false) {
            return_msg += 'instance is not initialized';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        var listener = CI.IV_firebase_db_object.ref(folder);
        if (listener === null) {
            return_msg += "failed to create listener for " + folder;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        var listener_callback = function (data,finished_callback) {
            var firebase_data = data.val();
            if (firebase_data === null) {
                listener.set({'deletion_prevention_key':'deletion_prevention_key'})
                listener.off();
            }
            CI.callCallBackFunction(finished_callback);
        }

        listener.once("value", function(data) { listener_callback(data,finished_callback);}.bind(this) ,
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
        
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitDoghouseListener(org_uid = null, sys_uid = null, obj_uid = null, obj_atr_uid = null,doghouse_active_flag=false,doghouse_history_flag = false) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7InitDoghouseListenerStep1 ";
        var task_id = "bi7_watchdog_firebase:bi7InitDoghouseListenerStep1";
        var CI = this;
        //////// input validation
        if (org_uid !== null && org_uid !== undefined) {
            call_result = bi1_data_validation.is_org_uid(org_uid);
            debug_data.push(call_result);
        } 
        if (sys_uid !== null && sys_uid !== undefined) {
            call_result = bi1_data_validation.is_system_uid(sys_uid);
            debug_data.push(call_result);
        }
        if (obj_uid !== null && obj_uid !== undefined) {
            call_result = bi1_data_validation.is_object_uid(obj_uid);
            debug_data.push(call_result);
        } 
        if (obj_atr_uid !== null && obj_atr_uid !== undefined) {
            call_result = bi1_data_validation.is_object_attribute_uid(obj_atr_uid);
            debug_data.push(call_result);
        } 

        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }
        if(validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////// </end> input validation

        ///// setup up listening folder paths
        var history_listen_folder = CI.IV_user_folder_path + '/dog_house_history/';
        var active_listen_folder = CI.IV_user_folder_path + '/dog_house_active/';
        if (org_uid !== null && org_uid !== undefined) {
            history_listen_folder += org_uid + '/';
            active_listen_folder += org_uid + '/';
        }
        if (sys_uid !== null && sys_uid !== undefined) {
            history_listen_folder += sys_uid + '/';
            active_listen_folder += sys_uid + '/';
        }
        if (obj_uid !== null && obj_uid !== undefined) {
            history_listen_folder += obj_uid + '/';
            active_listen_folder += obj_uid + '/';
        }
        if (obj_atr_uid !== null && obj_atr_uid !== undefined) {
            history_listen_folder += obj_atr_uid + '/';
            active_listen_folder += obj_atr_uid + '/';
        }
        /////</end> setup up listening folder paths


        ////// check if these paths are already being listened too
        if (doghouse_history_flag === true) {
            if(history_listen_folder in CI.IV_listener_doghouse_history) {
               doghouse_history_flag = false
            }
        }
        if (doghouse_history_flag === true) {
            for(var key in CI.IV_listener_doghouse_history) {
                if(key.indexOf(history_listen_folder)>=0) {
                    doghouse_history_flag = false;
                    break;
                }
            }
        }
        if (doghouse_active_flag === true) {
            if(active_listen_folder in CI.IV_listener_doghouse_active) {
                doghouse_active_flag = false
            }
        }
        if (doghouse_active_flag === true) {
            for(var key in CI.IV_listener_doghouse_active) {
                if(key.indexOf(active_listen_folder) >= 0) {
                    doghouse_active_flag = false;
                    break;
                }
            }
        }

        if (doghouse_active_flag === false && doghouse_history_flag === false) {
            return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        
        //////</end> check if these paths are already being listened too

        //// create paths for vue to monitor so reactivity works when data doesn't exist yet
        if(doghouse_history_flag === true) {
            Vue.set(CI.IV_component_loading_states, 'c5_doghouse_history', true);
            if (org_uid !== null && org_uid !== undefined && org_uid in CI.IV_doghouse_history === false) {
                Vue.set(CI.IV_doghouse_history,org_uid, {});
            }
            if (sys_uid !== null && sys_uid !== undefined && sys_uid in CI.IV_doghouse_history[org_uid] === false) {
                Vue.set(CI.IV_doghouse_history[org_uid],sys_uid, {});
            }
            if (obj_uid !== null && obj_uid !== undefined && obj_uid in CI.IV_doghouse_history[org_uid][sys_uid] === false) {
                Vue.set(CI.IV_doghouse_history[org_uid][sys_uid],obj_uid, {});
            }
            if (obj_atr_uid !== null && obj_atr_uid !== undefined && obj_atr_uid in CI.IV_doghouse_history[org_uid][sys_uid][obj_uid] === false) { 
                Vue.set(CI.IV_doghouse_history[org_uid][sys_uid][obj_uid],obj_atr_uid, {});
            }
            if (obj_atr_uid !== null && obj_atr_uid !== undefined && obj_atr_uid in CI.IV_doghouse_history[org_uid][sys_uid][obj_uid][obj_atr_uid] === false) { 
                Vue.set(CI.IV_doghouse_history[org_uid][sys_uid][obj_uid][obj_atr_uid],obj_atr_uid,null);            
            }
        }

        if(doghouse_active_flag === true) {
            if (org_uid !== null && org_uid !== undefined && org_uid in CI.IV_doghouse_active === false) {
                Vue.set(CI.IV_doghouse_active,org_uid, {});
            }
            if (sys_uid !== null && sys_uid !== undefined && sys_uid in CI.IV_doghouse_active[org_uid] === false) {
                Vue.set(CI.IV_doghouse_active[org_uid],sys_uid, {});
            }
            if (obj_uid !== null && obj_uid !== undefined && obj_uid in CI.IV_doghouse_active[org_uid][sys_uid] === false) {
                Vue.set(CI.IV_doghouse_active[org_uid][sys_uid],obj_uid, {});
            }
            if (obj_atr_uid !== null && obj_atr_uid !== undefined && obj_atr_uid in CI.IV_doghouse_active[org_uid][sys_uid][obj_uid] === false) { 
                Vue.set(CI.IV_doghouse_active[org_uid][sys_uid][obj_uid],obj_atr_uid, {});            
            }
            if (obj_atr_uid !== null && obj_atr_uid !== undefined && obj_atr_uid in CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_atr_uid] === false) { 
                Vue.set(CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_atr_uid],obj_atr_uid,null);            
            }
        }
        ////</end> create paths for vue to monitor so reactivity works when data doesn't exist yet


        var firebase_error_callback = function(error) {
            return_msg += "firebase read failed with error data:" + error;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }
        
        /////// create the doghouse history listener
        if (doghouse_history_flag === true) {
            CI.IV_listener_doghouse_history[history_listen_folder] = null;

            var init_history_listener_callback = function() {
                if (history_listen_folder in CI.IV_listener_doghouse_history === false || CI.IV_listener_doghouse_history[history_listen_folder] === null) {
                    CI.IV_listener_doghouse_history[history_listen_folder] = CI.IV_firebase_db_object.ref(history_listen_folder);
                }

                ///// removing invalid firebase listener key
                call_result = CI.validateFirebaseListener(CI.IV_listener_doghouse_history[history_listen_folder]);
                debug_data.push(call_result)
                if (call_result[CR.success] !== RC.success) {
                  delete CI.IV_listener_doghouse_history[history_listen_folder];
                  return_msg += "failed to create listener for " + listener_location;
                  base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
                  return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
                }
                ///// </end> removing invalid firebase listener key
                CI.IV_doghouse_history_listeners_count++;
                Vue.set(CI.IV_component_loading_states, 'c5_doghouse_history', true);
                CI.IV_listener_doghouse_history[history_listen_folder].on("value",
                    function (a_data) { CI.bi7DoghouseHistoryListener(a_data) }.bind(CI),
                    function (error) {firebase_error_callback(error)}.bind(this)
                );

                CI.IV_listener_doghouse_history[history_listen_folder].on("child_removed",
                    function (a_data) { CI.bi7DoghouseHistoryListener(a_data,true) }.bind(CI),
                    function (error) {firebase_error_callback(error)}.bind(this));
            };
    

            CI.IV_listener_doghouse_history[history_listen_folder]  = null;
            CI.bi7CreateUserFolderIfNotExists(history_listen_folder,init_history_listener_callback);
        }
        ///////</end> create the doghouse history listener

        /////// create the doghouse active listener
        if (doghouse_active_flag === true ) {
            CI.IV_listener_doghouse_active[active_listen_folder] = null;

            var init_active_listener_callback = function() {
                if (active_listen_folder in CI.IV_listener_doghouse_active === false || CI.IV_listener_doghouse_active[active_listen_folder] === null) {
                    CI.IV_listener_doghouse_active[active_listen_folder] = CI.IV_firebase_db_object.ref(active_listen_folder);
                }
                if (CI.IV_listener_doghouse_active[active_listen_folder] === null) {
                    return_msg += "failed to create listener for " + active_listen_folder;
                    base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
                    return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
                }
                CI.IV_listener_doghouse_active[active_listen_folder].on("value",
                    function (b_data) { CI.bi7DoghouseActiveListener(b_data) }.bind(CI),
                    function (error) {firebase_error_callback(error)}.bind(this)
                );
                CI.IV_listener_doghouse_active[active_listen_folder].on("child_removed",
                function (b_data) { CI.bi7DoghouseActiveListener(b_data) }.bind(CI),
                function (error) {firebase_error_callback(error)}.bind(this)
                );
            };

            CI.IV_listener_doghouse_active[active_listen_folder] = null;
            CI.bi7CreateUserFolderIfNotExists(active_listen_folder,init_active_listener_callback);
        }
        ///////</end> create the doghouse active listener
    
        return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    bi7initDogHouseActiveGlobalListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7initDogHouseActiveGlobalListener ";
        var task_id = "bi7_watchdog_firebase:bi7initDogHouseActiveGlobalListener";
        var CI = this;

        if(CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
            setTimeout(CI.bi7initDogHouseActiveGlobalListener.bind(CI),500);
            return;
        }

        var firebase_error_callback = function(error) {
            return_msg += "firebase read failed with error data:" + error;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }

        var active_listen_folder = CI.IV_user_folder_path + '/dog_house_active/';
        var path_ref = CI.IV_firebase_db_object.ref(active_listen_folder);
        path_ref.on("value",
          // arguments (firebase_snapshot, is_global)
            function (b_data) { CI.bi7DoghouseActiveListener(b_data, true) }.bind(CI),
            function (error) {firebase_error_callback(error)}.bind(this)
        );
    }

    bi7initDogHouseAcknowledgedGlobalListener() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7initDogHouseAcknowledgedGlobalListener ";
      var task_id = "bi7_watchdog_firebase:bi7initDogHouseAcknowledgedGlobalListener";
      var CI = this;

      if (CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
        setTimeout(CI.bi7initDogHouseAcknowledgedGlobalListener.bind(CI),500);
        return;
      }

      var firebase_error_callback = function(error) {
        return_msg += "firebase read failed with error data:" + error;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
      }

      Vue.set(CI.IV_component_loading_states, 'c5_acknowledged_items', true);

      var active_listen_folder = CI.IV_user_folder_path + '/dog_house_ackowledged/';
      var path_ref = CI.IV_firebase_db_object.ref(active_listen_folder);
      path_ref.on("value",
        // arguments (firebase_snapshot, is_global)
        function (b_data) { CI.bi7DoghouseAcknowledgedListener(b_data, true) }.bind(CI),
        function (error) {firebase_error_callback(error)}.bind(this)
      );

      return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    bi7InitDoghouseAcknowledgedListener(org_uid = null, sys_uid = null, obj_uid = null, obj_atr_uid = null) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitDoghouseAcknowledgedListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitDoghouseAcknowledgedListener";
      var CI = this;
      Vue.set(CI.IV_component_loading_states, 'c5_acknowledged_items', true);
      //////// input validation
      if(org_uid != null) {
          call_result = bi1_data_validation.is_org_uid(org_uid);
          debug_data.push(call_result);
      } 
      if(sys_uid != null) {
          call_result = bi1_data_validation.is_system_uid(sys_uid);
          debug_data.push(call_result);
      }
      if(obj_uid != null) {
          call_result = bi1_data_validation.is_object_uid(obj_uid);
          debug_data.push(call_result);
      } 
      if(obj_atr_uid != null) {
          call_result = bi1_data_validation.is_object_attribute_uid(obj_atr_uid);
          debug_data.push(call_result);
      } 

      var validation_failed = false;
      for (var index in debug_data) {
          if (debug_data[index][CR.success] != RC.success) {
              validation_failed = true;
          }
      }
      if(validation_failed == true) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      /////// </end> input validation

      ///// setup up listening folder paths
      var listen_folder = CI.IV_user_folder_path + '/dog_house_ackowledged/';
      if(org_uid != null) {
          listen_folder += org_uid + '/';
      }
      if(sys_uid != null) {
          listen_folder += sys_uid + '/';
      }
      if(obj_uid != null) {
          listen_folder += obj_uid + '/';
      }
      if(obj_atr_uid != null) {
          listen_folder += obj_atr_uid + '/';
      }
      /////</end> setup up listening folder paths

      // we already have listener for this location
      if (listen_folder in CI.IV_listener_doghouse_acknowledge == true) {
        return;
      }

      if(org_uid != null && org_uid in CI.IV_doghouse_acknowledged == false) {
        Vue.set(CI.IV_doghouse_acknowledged,org_uid, {});
      }
      if(sys_uid != null && sys_uid in CI.IV_doghouse_acknowledged[org_uid] == false) {
        Vue.set(CI.IV_doghouse_acknowledged[org_uid],sys_uid, {});
      }
      if(obj_uid != null && obj_uid in CI.IV_doghouse_acknowledged[org_uid][sys_uid] == false) {
        Vue.set(CI.IV_doghouse_acknowledged[org_uid][sys_uid],obj_uid, {});
      }
      if(obj_atr_uid != null && obj_atr_uid in CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid] == false) { 
        Vue.set(CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid],obj_atr_uid, {});            
      }
      if(obj_atr_uid != null && obj_atr_uid in CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_atr_uid] == false) { 
        Vue.set(CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_atr_uid],obj_atr_uid,null);            
      }

      CI.IV_listener_doghouse_acknowledge[listen_folder] = CI.IV_firebase_db_object.ref(listen_folder);

      var init_listener_callback = function() {
        CI.IV_listener_doghouse_acknowledge[listen_folder].on("value",
          function (b_data) { CI.bi7DoghouseAcknowledgedListener(b_data) }.bind(CI),
          function (error) {
            return_msg += "firebase read failed with error data:" + error;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          }.bind(this)
        );
      }

      CI.bi7CreateUserFolderIfNotExists(listen_folder,init_listener_callback);

      return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    bi7DoghouseAcknowledgedListener(data, is_global=false) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7DoghouseAcknowledgedListener ";
        var task_id = "bi7_watchdog_firebase:bi7DoghouseAcknowledgedListener";

        ///// input validation
        if (data == null) {
            Vue.set(CI.IV_component_loading_states, 'c5_acknowledged_items', false);
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        /////</end> input validation

        var CI = this;
        var firebase_data = data.val()

        /// convert the nested object into a flat array since the data is json encoded we don't need the structure
        try {
            firebase_data  = bi6_misc.bi6FlattenObject(firebase_data)
        } catch(error) {
            Vue.set(CI.IV_component_loading_states, 'c5_acknowledged_items', false);
            return_msg += "failed to create flatten firebase_data with error:" + JSON.stringify(error);
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.general_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///</end> convert the nested object into a flat array since the data is json encoded we don't need the structure

        var entry,org_uid,sys_uid,obj_uid,obj_atr_uid,rule_uid;
        let new_entries_to_queue = [];
 
        for(var key in firebase_data) {
            if (firebase_data[key] == 'deletion_prevention_key') {
                continue;
            }

            try {
                entry = JSON.parse(firebase_data[key])
                entry['rule_join_uid'] = entry['rule_uid']
                entry['rule_uid'] = entry['rule_join_uid'].split('|')[1]
            } catch(error) {
                var error_msg = return_msg + "failed to JSOn parse firebase data with error:" + error;
                debug_data.push(firebase_data[key])
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, error_msg, debug_data);
                continue;
            }
            
            org_uid = entry['org_uid'];
            sys_uid = entry['sys_uid'];
            obj_uid = entry['obj_uid'];
            obj_atr_uid = entry['obj_atr_uid'];
            rule_uid = entry['rule_uid']
            let key_parts = key.split("|");
            entry['timestamp'] = key_parts[key_parts.length - 1]

            if(org_uid in CI.IV_doghouse_acknowledged == false) {
                Vue.set(CI.IV_doghouse_acknowledged,org_uid, {});
            }

            if(sys_uid in CI.IV_doghouse_acknowledged[org_uid] == false) {
                Vue.set(CI.IV_doghouse_acknowledged[org_uid],sys_uid, {});
            }

            if(obj_uid in CI.IV_doghouse_acknowledged[org_uid][sys_uid] == false) {
                Vue.set(CI.IV_doghouse_acknowledged[org_uid][sys_uid],obj_uid, {});
            }

            if(obj_atr_uid in CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid] == false) { 
                Vue.set(CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid],obj_atr_uid, {});
            }
            if(rule_uid in CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_atr_uid] == false) { 
                Vue.set(CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_atr_uid], rule_uid, {});
            }

            let doghouse_count_process_type = 3;

            /// Queue this entry to process the doghouse count
            let event_timestamp = new Date().getTime();
            
            const org_num = org_uid.replace("org_", ""),
                  sys_num = sys_uid.replace("sys_", ""),
                  obj_num = obj_uid.replace("obj_", ""),
                  atr_num = obj_atr_uid.split("-")[1]

            let unique_key = `${org_num}_${sys_num}_${obj_num}_${atr_num}_${rule_uid}_${event_timestamp}`;
            let alert_count_entry = [+entry['timestamp'], doghouse_count_process_type, false, org_num, sys_num, obj_num, atr_num]

            if (entry['previous_state']) {
              alert_count_entry[7] = entry['previous_state']
            }
            if (entry['next_state']) {
              alert_count_entry[8] = entry['next_state']
            }
            ///</end> Queue this entry to process the doghouse count

            if ("delete" in entry == true) {
              doghouse_count_process_type = 4;

              CI.bi7DeleteFirebaseLocation(CI.IV_user_folder_path + '/dog_house_ackowledged/' + org_uid + '/' + sys_uid + '/' + obj_uid + '/' + obj_atr_uid + '/' + rule_uid);
              Vue.delete(CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_atr_uid],rule_uid);

              // Prevent adding old entries again.
              alert_count_entry[0] = parseInt(new Date().getTime() / 1000);
              alert_count_entry[1] = doghouse_count_process_type;
              new_entries_to_queue.push({key: unique_key, entry: alert_count_entry})
              continue;
            }

            Vue.set(CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_atr_uid], rule_uid, entry);

            // Prevent adding old entries again.
            if (+entry['timestamp'] <= CI.IV_doghouse_count_last_updated['acknowledged_alerts']) {continue;}

            new_entries_to_queue.push({key: unique_key, entry: alert_count_entry})
        }

        if (is_global === true && new_entries_to_queue.length > 0) {
          for (let item of new_entries_to_queue) {
            CI.bi7QueueDoghouseCountEntry(item['key'], item['entry'], "acknowledged");
          }
        }
 
        Vue.set(CI.IV_component_loading_states, 'c5_acknowledged_items', false);
        
        return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    bi7DoghouseActiveListener(data, is_global=false) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7DoghouseActiveListener ";
        var task_id = "bi7_watchdog_firebase:bi7DoghouseActiveListener";

        ///// input validation
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        /////</end> input validation

        var CI = this;
        var firebase_data = data.val()

        var active_entries = [];
        var entries_found_flag = false;
        var continue_flag = false;
        if (typeof(firebase_data) === 'string') {
            firebase_data = {'entry': firebase_data};
        }
        //// take the nested object and filter all un-needed entries, added the needed entries to a new list
        for( var key1 in firebase_data) {
            continue_flag = false;
            if (key1 === "deletion_prevention_key") { continue;}
            if (typeof(firebase_data[key1]) === 'string') {
              active_entries.push(firebase_data[key1]);
              entries_found_flag = true;
              continue_flag = true;
              continue;
            }
            for(var key2 in firebase_data[key1]) {
              if (key2 === "deletion_prevention_key") { continue;}
              if (typeof(firebase_data[key1][key2]) === 'string') {
                active_entries.push(firebase_data[key1][key2]);
                entries_found_flag = true;
                continue_flag = true;
                continue;
              }
              for(var key3 in firebase_data[key1][key2]) {
                if (key3 === "deletion_prevention_key") { continue;}
                if (typeof(firebase_data[key1][key2][key3]) === 'string') {
                    active_entries.push(firebase_data[key1][key2][key3]);
                    entries_found_flag = true;
                    continue_flag = true;
                    continue;
                  }
                
                for(var key4 in firebase_data[key1][key2][key3]) {
                  if (key4 === "deletion_prevention_key") { continue;}
                  if (typeof(firebase_data[key1][key2][key3][key4]) === 'string') {
                    active_entries.push(firebase_data[key1][key2][key3][key4]);
                    entries_found_flag = true;
                    continue_flag = true;
                    continue;
                    }
                  for(var key5 in firebase_data[key1][key2][key3][key4]) {
                    if (key5 === "deletion_prevention_key") { continue;}
                    if (typeof(firebase_data[key1][key2][key3][key4][key5]) === 'string') {
                        active_entries.push(firebase_data[key1][key2][key3][key4][key5]);
                        entries_found_flag = true;
                        continue_flag = true;
                        continue;
                    }
                    if(continue_flag === true) { continue;}
                  }
                  if(continue_flag === true) { continue;}
                }
                if(continue_flag === true) { continue;}
              }
              if(continue_flag === true) { continue;}
            }
            if(continue_flag === true) { continue;}
          }
        ////</end> take the nested object and filter all un-needed entries, added the needed entries to a new list

        var entry,org_uid,sys_uid,obj_uid,obj_atr_uid,rule_join_uid;
        let new_entries_to_queue = [];

        for(var index1 in active_entries) {
            try {
                entry = JSON.parse(active_entries[index1])
                //legacy format for rule UIDs is the rule join uid
                if(entry['rule_uid'].indexOf("|") > -1) {
                  entry['rule_join_uid'] = entry['rule_uid']
                  entry['rule_uid'] = entry['rule_join_uid'].split('|')[1]
                } else {
                  entry['rule_join_uid'] = entry['obj_atr_uid'] + "|" + entry['rule_uid']
                }

                if (entry["tags"] === undefined || entry["tags"] === null) {
                  entry["tags"] = [];
                }
                
            } catch(error) {
                var error_msg = return_msg + "failed to JSOn parse firebase data with error:" + error;
                debug_data.push(active_entries[index1])
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, error_msg, debug_data);
                continue;
            }
            rule_join_uid = entry['rule_join_uid'];
            if(rule_join_uid in CI.IV_last_updated_timestamps['doghouse_active'] && 
            CI.IV_last_updated_timestamps['doghouse_active'][rule_join_uid] === entry['timestamp']) {
                continue;
            }
            org_uid = entry['org_uid'];
            sys_uid = entry['sys_uid'];
            obj_uid = entry['obj_uid'];
            obj_atr_uid = entry['obj_atr_uid'];
            if(org_uid in CI.IV_doghouse_active === false) {
                Vue.set(CI.IV_doghouse_active,org_uid, {});
            }
            this.bi7CreateDataStoreRequest('org_meta_data',org_uid,1)
            if(sys_uid in CI.IV_doghouse_active[org_uid] === false) {
                Vue.set(CI.IV_doghouse_active[org_uid],sys_uid, {});
            }
            this.bi7CreateDataStoreRequest('sys_meta_data',sys_uid,1)
            if(obj_uid in CI.IV_doghouse_active[org_uid][sys_uid] === false) {
                Vue.set(CI.IV_doghouse_active[org_uid][sys_uid],obj_uid, {});
            }
            this.bi7CreateDataStoreRequest("obj_meta_data",obj_uid,1)
            if(obj_atr_uid in CI.IV_doghouse_active[org_uid][sys_uid][obj_uid] === false) { 
                Vue.set(CI.IV_doghouse_active[org_uid][sys_uid][obj_uid],obj_atr_uid, {});
            }
            this.bi7CreateDataStoreRequest('obj_atr_meta_data',obj_atr_uid,1)

            let doghouse_count_process_type = 1;
            let actual_event_timetamp = +entry['timestamp'];

            // setting manually active timestamp when the entry is moved from history to active
            if (entry["mact_timestamp"] !== null && entry["mact_timestamp"] !== undefined) {
              if (+entry["mact_timestamp"] > +entry['timestamp']) {
                actual_event_timetamp = +entry['mact_timestamp'];
              }
            }

            if('delete' in entry === true) {
                doghouse_count_process_type = 4;
                actual_event_timetamp = parseInt(new Date().getTime() / 1000) ;

                CI.bi7DeleteFirebaseLocation(CI.IV_user_folder_path + '/dog_house_active/' + org_uid + '/' + sys_uid + '/' + obj_uid + '/' + obj_atr_uid + '/' + entry['rule_uid'])
                CI.bi7DeleteFirebaseLocation(CI.IV_user_folder_path + '/dog_house_ackowledged/' + org_uid + '/' + sys_uid + '/' + obj_uid + '/' + obj_atr_uid + '/' + entry['rule_uid'])
                if(entry['rule_uid'] in CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_atr_uid] === true) {
                    try {
                      if (CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_atr_uid]) {Vue.delete(CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_atr_uid],entry['rule_uid'])};
                      if (CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_atr_uid]) {Vue.delete(CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_atr_uid],entry['rule_uid'])};
                    } catch (error){

                    }
                    CI.IV_last_updated_timestamps['doghouse_active'][rule_join_uid] = entry['timestamp'];
                }
            } else {
                Vue.set(CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_atr_uid], entry['rule_uid'],entry);
                CI.IV_last_updated_timestamps['doghouse_active'][rule_join_uid] = entry['timestamp']
            }

            // Prevent adding old entries again.
            if (actual_event_timetamp <= CI.IV_doghouse_count_last_updated['active_alerts']) {continue;}

            /// Queue this entry to process the doghouse count
            let event_timestamp = new Date().getTime();

            const org_num = org_uid.replace("org_", ""),
                  sys_num = sys_uid.replace("sys_", ""),
                  obj_num = obj_uid.replace("obj_", ""),
                  atr_num = obj_atr_uid.split("-")[1],
                  rule_uid = entry['rule_uid'];

                              // org_uid#   sys_uid#    obj_uid#    obj_atr_uid#
            let unique_key = `${org_num}_${sys_num}_${obj_num}_${atr_num}_${rule_uid}_${event_timestamp}`;
            let alert_count_entry = [actual_event_timetamp, doghouse_count_process_type, false, org_num, sys_num, obj_num, atr_num, entry["previous_state"]]

            new_entries_to_queue.push({key: unique_key, entry: alert_count_entry})
            ///</end> Queue this entry to process the doghouse count
        }

        if (is_global === true && new_entries_to_queue.length > 0) {
          for (let item of new_entries_to_queue) {
            CI.bi7QueueDoghouseCountEntry(item['key'], item['entry'], "active");
          }
        }

        return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }


    bi7DoghouseHistoryListener(data,item_deleted=false) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7DoghouseHistoryListener ";
        var task_id = "bi7_watchdog_firebase:bi7DoghouseHistoryListener";

        ///// input validation
        if (data === null) {
            if(--CI.IV_doghouse_history_listeners_count === 0){
              Vue.set(CI.IV_component_loading_states, 'c5_doghouse_history', false);
            }
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        /////</end> input validation

        var CI = this;
        var firebase_data = data.val()
        /// convert the nested object into a flat array since the data is json encoded we don't need the structure
        try {
            firebase_data  = bi6_misc.bi6FlattenObject(firebase_data)
        } catch(error) {
            if(--CI.IV_doghouse_history_listeners_count === 0){
              Vue.set(CI.IV_component_loading_states, 'c5_doghouse_history', false);
            }
            return_msg += "failed to create flatten firebase_data with error:" + JSON.stringify(error);
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.general_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///</end> convert the nested object into a flat array since the data is json encoded we don't need the structure

        var entry,org_uid,sys_uid,obj_uid,obj_atr_uid;
        for(var key in firebase_data) {
            if (firebase_data[key] === 'deletion_prevention_key') {
                continue;
            }
            try {
                entry = JSON.parse(firebase_data[key])
                //legacy format for rule UIDs is the rule join uid
                if(entry['rule_uid'].indexOf("|") > -1) {
                  entry['rule_join_uid'] = entry['rule_uid']
                  entry['rule_uid'] = entry['rule_join_uid'].split('|')[1]
                } else {
                  entry['rule_join_uid'] = entry['obj_atr_uid'] + "|" + entry['rule_uid']
                }

                if (entry["tags"] === undefined || entry["tags"] === null) {
                  entry["tags"] = [];
                }
            } catch(error) {
                var error_msg = return_msg + "failed to JSOn parse firebase data with error:" + error;
                debug_data.push(firebase_data[key])
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, error_msg, debug_data);
                continue;
            }
            
            org_uid = entry['org_uid'];
            sys_uid = entry['sys_uid'];
            obj_uid = entry['obj_uid'];
            obj_atr_uid = entry['obj_atr_uid'];
            if(org_uid in CI.IV_doghouse_history === false) {
                Vue.set(CI.IV_doghouse_history,org_uid, {});
            }
            this.bi7CreateDataStoreRequest('org_meta_data',org_uid,1)
            if(sys_uid in CI.IV_doghouse_history[org_uid] === false) {
                Vue.set(CI.IV_doghouse_history[org_uid],sys_uid, {});
            }
            this.bi7CreateDataStoreRequest('sys_meta_data',sys_uid,1)
            if(obj_uid in CI.IV_doghouse_history[org_uid][sys_uid] === false) {
                Vue.set(CI.IV_doghouse_history[org_uid][sys_uid],obj_uid, {});
            }
            this.bi7CreateDataStoreRequest("obj_meta_data",obj_uid,1)
            if(obj_atr_uid in CI.IV_doghouse_history[org_uid][sys_uid][obj_uid] === false) { 
                Vue.set(CI.IV_doghouse_history[org_uid][sys_uid][obj_uid],obj_atr_uid, {});
            }
            this.bi7CreateDataStoreRequest('obj_atr_meta_data',obj_atr_uid,1)
            if('delete' in entry) {
                Vue.set(CI.IV_doghouse_history[org_uid][sys_uid][obj_uid][obj_atr_uid], entry['timestamp'],null);
            } else {
                Vue.set(CI.IV_doghouse_history[org_uid][sys_uid][obj_uid][obj_atr_uid], entry['timestamp'], entry);
            }
        }
        if(--CI.IV_doghouse_history_listeners_count === 0){
          Vue.set(CI.IV_component_loading_states, 'c5_doghouse_history', false);
        }
    }

    bi7SubscribeSystemOnlineStatus(system_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7SubscribeSystemOnlineStatus ";
      var task_id = "bi7_watchdog_firebase:bi7SubscribeSystemOnlineStatus";

      ///// input validation
      call_result = bi1_data_validation.is_system_uid(system_uid);
      debug_data.push(call_result);
      
      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
      }
      /////</end> input validation

      var CI = this;
      
      //// this tracks systems online status
      var system_online_attribute_uid = system_uid.replace('sys_','obj_atr_')
      
      //8 is a reserved UID for system online status
      system_online_attribute_uid += '-8'

      if (system_online_attribute_uid in CI.IV_object_attribute_values === false) {
        Vue.set(CI.IV_object_attribute_values, system_online_attribute_uid, {})
      }
      
      if (system_online_attribute_uid in CI.IV_object_attribute_rule_joins === false) {
        Vue.set(CI.IV_object_attribute_rule_joins, system_online_attribute_uid, {})
      }
      
      if (system_online_attribute_uid in CI.IV_listener_object_attribute_values === false) {
        CI.bi7initObjectAttributeValueListener(system_online_attribute_uid);
      }

      return {success: RC.success, return_msg: return_msg, debug_data: debug_data};
    }

    bi7initRulesListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7initRulesListener ";
        var task_id = "bi7_watchdog_firebase:bi7initRulesListener";

        var CI = this;
        var listener_location = CI.IV_user_folder_path + '/notification_rules/';
        CI.IV_notification_rules_listener['rules'] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_notification_rules_listener['rules']);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_notification_rules_listener['rules'];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_notification_rules_listener['rules'].on("value",
            function (a_data) { CI.bi7RulesListener(a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    bi7RulesListener(data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7RulesListener ";
        var task_id = "bi7_watchdog_firebase:bi7RulesListener";
        
        ///// input validation
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;
        var firebase_data = data.val();
        var entry;
        for( var key in firebase_data) {
            if(key === 'deletion_prevention_key') {
                continue;
            }
            entry = null;
            try {
                var entry = JSON.parse(firebase_data[key]);
            } catch(error) {
                return_msg += "failed to parse JSON data with error:" + error;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
                return;
            }
            entry['uid'] = key;
            if ('delete' in entry) {
                Vue.delete(CI.IV_notification_rules,key);
                this.bi7DeleteFirebaseLocation(CI.IV_user_folder_path + '/notification_rules/' + key);

            } else {
                Vue.set(CI.IV_notification_rules,key,entry);
            }
            
        }
    }

    
    bi7initNotificationRuleJoinsListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7initNotificationRuleJoinsListener ";
        var task_id = "bi7_watchdog_firebase:bi7initNotificationRuleJoinsListener";

        var CI = this;
        var listener_location = CI.IV_user_folder_path + '/notification_rule_joins/';
        CI.IV_notification_rule_joins_listener['entries'] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_notification_rule_joins_listener['entries']);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_notification_rule_joins_listener['entries'];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_notification_rule_joins_listener['entries'].on("value",
            function (a_data) { CI.bi7NotificationRuleJoinsListener(a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    bi7NotificationRuleJoinsListener(data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7NotificationRuleJoinsListener ";
        var task_id = "bi7_watchdog_firebase:bi7NotificationRuleJoinsListener";
        
        ///// input validation
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        
        var CI = this;
        var firebase_data = data.val();
        var entry;
        for( var key in firebase_data) {
            if(key === 'deletion_prevention_key') {
                continue;
            }
            entry = null;
            try {
                var entry = JSON.parse(firebase_data[key]);
                entry['objectUid'] = 'obj_' + entry['object_uid'];
                entry['objectAttributeUid'] = 'obj_atr_' +  entry['object_uid'] + '-' + entry['attribute_uid']
                entry['uid'] = key;
            } catch(error) {
                return_msg += "failed to parse JSON data with error:" + error;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
                continue;
            }
            
            if(key in CI.IV_last_updated_timestamps['notification_rule_joins'] && 
            CI.IV_last_updated_timestamps['notification_rule_joins'][key] === entry['last_updated']) {
                continue;
            }
            
            if ('delete' in entry) {
                if (key in CI.IV_notification_rule_joins === true) {
                  Vue.delete(CI.IV_notification_rule_joins, key)
                };
                if (entry['objectAttributeUid'] in CI.IV_object_attribute_rule_joins) {
                  Vue.delete(CI.IV_object_attribute_rule_joins[entry['objectAttributeUid']], entry['rule_uid']);
                }
                this.bi7DeleteFirebaseLocation(CI.IV_user_folder_path + '/notification_rule_joins/' + key);
            } else {
                if (entry['objectAttributeUid'] in CI.IV_object_attribute_rule_joins === false) {
                  Vue.set(CI.IV_object_attribute_rule_joins, entry['objectAttributeUid'], {})
                }
                CI.IV_last_updated_timestamps['notification_rule_joins'][key] = entry['last_updated'];
                Vue.set(CI.IV_object_attribute_rule_joins[entry['objectAttributeUid']], entry['rule_uid'],entry)
                Vue.set(CI.IV_notification_rule_joins,key,entry);
            }
        }
    }

    bi7InitObjectAttributeParentSystemListener(object_uid,object_attribute_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7InitObjectAttributeParentSystemListener ";
        var task_id = "bi7_watchdog_firebase:bi7InitObjectAttributeParentSystemListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_uid(object_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);

        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }
        if(validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        //////</end> input validation 


        var CI = this;
        var listener_location = "objects/" + object_uid +  "/attribute_list/" + object_attribute_uid + '/processor_uid';
        CI.IV_listener_object_attribute_parent_system[object_attribute_uid] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_object_attribute_parent_system[object_attribute_uid]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_object_attribute_parent_system[object_attribute_uid];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_object_attribute_parent_system[object_attribute_uid].on("value",
            function (a_data) { CI.bi7ObjectAttributeParentSystemListener(object_uid, a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }
    
    bi7ObjectAttributeParentSystemListener(object_uid, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7ObjectAttributeParentSystemListener ";
        var task_id = "bi7_watchdog_firebase:bi7ObjectAttributeParentSystemListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_uid(object_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        var firebase_data = data.val();
        Vue.set(CI.IV_system_object_joins_reverse_lookup,object_uid,firebase_data);
    }

    bi7GetObjectUidFromOjbectAttributeUid(object_attribute_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7GetObjectUidFromOjbectAttributeUid ";
        var task_id = "bi7_watchdog_firebase:bi7GetObjectUidFromOjbectAttributeUid";
        
        ///// input validation
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        /////</end> input validation

        var object_uid = '';
        var processsed_string;
        try {
            processsed_string = object_attribute_uid.replace('obj_atr_','obj_');
            processsed_string = processsed_string.split('-',1)[0]
        } catch(error) {
            return_msg += "failed to parse object attribute uid:" + error;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data,object_uid:object_uid };
        }

        
        call_result = bi1_data_validation.is_object_uid(processsed_string);
        debug_data.push(call_result)
        if (call_result['success'] !== RC.success) {
            return_msg += "created object_uid is not a valid object_uid. object_uid:" + JSON.stringify(processsed_string);
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data,object_uid:object_uid };
        }
        object_uid = processsed_string;
        return { success: RC.success, return_msg: return_msg, debug_data: debug_data,object_uid:object_uid };
        
    }

    bi7InitAccountNotificationsListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7InitAccountNotificationsListener ";
        var task_id = "bi7_watchdog_firebase:bi7InitAccountNotificationsListener";
        var CI = this;

        if (CI.IV_instance_initialized === false) {
            return_msg += 'instance is not initialized';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        var listener_location = CI.IV_firebase_email_pointer.replace(/\./g,'-_-_-');
        listener_location = listener_location.replace('@','_-AT-_');
        listener_location = 'notifications/' + listener_location;
        CI.IV_listener_account_notifications['1'] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_account_notifications['1']);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_account_notifications['1'];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_account_notifications['1'].on("value",CI.bi7AccountNotificationsListener.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    bi7AccountNotificationsListener(data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7AccountNotificationsListener ";
        var task_id = "bi7_watchdog_firebase:bi7AccountNotificationsListener";
        
        ////// input validation 
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation
        
        var CI = this;
        var firebase_data = data.val();

        for (var key in firebase_data) {
            //set the last updated timestamp for the permissions
            if(key === 'deletion_prevention_key') {
                continue;
            }
            entry = null;
            try {
                var entry = JSON.parse(firebase_data[key]);
            } catch(error) {
                return_msg += "failed to parse JSON data with error:" + error;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
                return;
            }
            
            if('delete' in entry) {
                Vue.delete(CI.IV_account_notificaitons,key);
            } else if(key in CI.IV_account_notificaitons === false) {
                Vue.set(CI.IV_account_notificaitons,key,entry);
            }
            
        }
    }

    
    bi7InitOrgUserPermissionsChangeListener(org_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7InitOrgUserPermissionsChangeListener ";
        var task_id = "bi7_watchdog_firebase:bi7InitOrgUserPermissionsChangeListener";

        ////// input validation 
        call_result = bi1_data_validation.is_org_uid(org_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;
        if (org_uid in CI.IV_org_users_permissions_last_updated === false) {
            Vue.set(CI.IV_org_users_permissions_last_updated,org_uid,{});
        }
        var listener_location = 'organization/' + org_uid + '/user_permissions';
        CI.IV_listener_org_user_permission_changes[org_uid] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_org_user_permission_changes[org_uid]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_org_user_permission_changes[org_uid];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_org_user_permission_changes[org_uid].on("value",
            function (a_data) { CI.bi7OrgUserPermissionsChangeListener(org_uid, a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    bi7OrgUserPermissionsChangeListener(org_uid, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7OrgUserPermissionsChangeListener ";
        var task_id = "bi7_watchdog_firebase:bi7OrgUserPermissionsChangeListener";

        ////// input validation 
        call_result = bi1_data_validation.is_org_uid(org_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        var firebase_data = data.val();

        for( var key in firebase_data) {
        if (key === "last_updated") {
            Vue.set(CI.IV_org_users_permissions_last_updated[org_uid],'last_updated',firebase_data[key]);
        }
    }
       
    }

    bi7RemoveOrgUserPermissionsChangeListener(org_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7RemoveOrgUserPermissionsChangeListener ";
        var task_id = "bi7_watchdog_firebase:bi7RemoveOrgUserPermissionsChangeListener";

        ////// input validation 
        call_result = bi1_data_validation.is_org_uid(org_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;
        try {
            CI.IV_listener_org_user_permission_changes[org_uid].off();
            CI.IV_listener_org_user_permission_changes[org_uid] = null;
            delete CI.IV_listener_org_user_permission_changes[org_uid];
            Vue.delete(CI.IV_org_users_permissions_last_updated,org_uid);
        } catch(error) {
            return_msg += 'failed to remove listener with error:' + JSON.stringify(error);
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            CI.IV_listener_org_user_permission_changes[org_uid] = null;
            delete CI.IV_listener_org_user_permission_changes[org_uid];
            return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        
    }


    bi7DeleteFirebaseLocation(folder) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7DeleteFirebaseLocation ";
        var task_id = "bi7_watchdog_firebase:bi7DeleteFirebaseLocation";
        var CI = this;
        if (CI.IV_instance_initialized === false) {
            return_msg += 'instance is not initialized';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        var ref = CI.IV_firebase_db_object.ref(folder);
        if (ref === null) {
            return_msg += "failed to create ref for " + folder;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        ref.remove(function (errorObject) {
                if(errorObject === null) { return; }
                    return_msg += "firebase delete of '" + folder +"' failed with error data:" + errorObject;
                    base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
        
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7ClearDoghouseActiveEntry(rule_uid, rule_join_uid, org_uid, system_uid, object_uid, object_attribute_uid, timestamp, previous_state) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7ClearDoghouseActiveEntry ";
        var task_id = "bi7_watchdog_firebase:bi7ClearDoghouseActiveEntry";
        var CI = this;
        if (CI.IV_instance_initialized === false) {
            return_msg += 'instance is not initialized';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        //////// input validation
        if(org_uid !== null && org_uid !== undefined) {
            call_result = bi1_data_validation.is_org_uid(org_uid);
            debug_data.push(call_result);
        } 
        if(system_uid !== null && system_uid !== undefined) {
            call_result = bi1_data_validation.is_system_uid(system_uid);
            debug_data.push(call_result);
        }
        if(object_uid !== null && object_uid !== undefined) {
            call_result = bi1_data_validation.is_object_uid(object_uid);
            debug_data.push(call_result);
        } 
        if(object_attribute_uid !== null && object_attribute_uid !== undefined) {
            call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
            debug_data.push(call_result);
        }

        call_result = bi1_data_validation.is_string(rule_join_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(rule_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(previous_state);
        debug_data.push(call_result);

        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }
        if(validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////// </end> input validation

        var folder = CI.IV_user_folder_path + '/dog_house_active/' + org_uid + '/' + system_uid + '/' + object_uid + '/' + object_attribute_uid  + '/' + rule_uid;

        var reference = CI.IV_firebase_db_object.ref(folder);
        if (reference == null) {
          return_msg += "failed to create reference for " + folder;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        var data = {
          rule_uid: rule_join_uid, 
          org_uid: org_uid, 
          obj_atr_uid: object_attribute_uid, 
          sys_uid: system_uid, 
          obj_uid: object_uid,
          value: "",
          delete: "delete",
          previous_state: previous_state
        }

        reference.set(JSON.stringify(data), function(error) {
          if (error) {
            return_msg += "firebase write failed with error data:" + error;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          } else {
            return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
          }
        });
        
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7AcknowledgeDoghouseActiveEntry(rule_uid,rule_join_uid,org_uid,system_uid,object_uid,object_attribute_uid,value, previous_state) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7AcknowledgeDoghouseActiveEntry ";
        var task_id = "bi7_watchdog_firebase:bi7AcknowledgeDoghouseActiveEntry";
        var CI = this;

        //////// input validation
        if(org_uid != null) {
            call_result = bi1_data_validation.is_org_uid(org_uid);
            debug_data.push(call_result);
        } 
        if(system_uid != null) {
            call_result = bi1_data_validation.is_system_uid(system_uid);
            debug_data.push(call_result);
        }
        if(object_uid != null) {
            call_result = bi1_data_validation.is_object_uid(object_uid);
            debug_data.push(call_result);
        } 
        if(object_attribute_uid != null) {
            call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
            debug_data.push(call_result);
        }

        call_result = bi1_data_validation.is_string(rule_join_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(rule_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(value);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(previous_state);
        debug_data.push(call_result);

        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] != RC.success) {
                validation_failed = true;
            }
        }

        if(validation_failed == true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////// </end> input validation

        var folder = CI.IV_user_folder_path + '/dog_house_ackowledged/' + org_uid + '/' + system_uid + '/' + object_uid + '/' + object_attribute_uid  + '/' + rule_uid;

        var reference = CI.IV_firebase_db_object.ref(folder);
        if (reference == null) {
          return_msg += "failed to create reference for " + folder;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        var timestamp = Math.ceil(new Date().getTime() / 1000);
        var data = {
          rule_uid: rule_join_uid, 
          org_uid: org_uid, 
          obj_atr_uid: object_attribute_uid, 
          sys_uid: system_uid, 
          obj_uid: object_uid,
          value: value,
          previous_state: previous_state
        }

        reference.child(timestamp).set(JSON.stringify(data), function(error) {
          if (error) {
            return_msg += "firebase write failed with error data:" + error;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          } else {
            return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
          }
        });

        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7MoveAcknowledgedItemToActiveAlert(rule_uid,rule_join_uid,org_uid,system_uid,object_uid,object_attribute_uid, timestamp) {
      var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7MoveAcknowledgedItemToActiveAlert ";
        var task_id = "bi7_watchdog_firebase:bi7MoveAcknowledgedItemToActiveAlert";
        var CI = this;

        //////// input validation
        if(org_uid != null) {
            call_result = bi1_data_validation.is_org_uid(org_uid);
            debug_data.push(call_result);
        } 
        if(system_uid != null) {
            call_result = bi1_data_validation.is_system_uid(system_uid);
            debug_data.push(call_result);
        }
        if(object_uid != null) {
            call_result = bi1_data_validation.is_object_uid(object_uid);
            debug_data.push(call_result);
        } 
        if(object_attribute_uid != null) {
            call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
            debug_data.push(call_result);
        }

        call_result = bi1_data_validation.is_string(rule_join_uid);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(rule_uid);
        debug_data.push(call_result);

        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] != RC.success) {
                validation_failed = true;
            }
        }

        if(validation_failed == true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        /////// </end> input validation

        var folder = CI.IV_user_folder_path + '/dog_house_ackowledged/' + org_uid + '/' + system_uid + '/' + object_uid + '/' + object_attribute_uid  + '/' + rule_uid;
        
        var reference = CI.IV_firebase_db_object.ref(folder);
        if (reference == null) {
          return_msg += "failed to create reference for " + folder;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        var data = {
          rule_uid: rule_join_uid, 
          org_uid: org_uid, 
          obj_atr_uid: object_attribute_uid, 
          sys_uid: system_uid, 
          obj_uid: object_uid,
          delete: "delete",
          previous_state: "acknowledged",
          next_state: "active"
        }

        reference.child(timestamp).set(JSON.stringify(data), function(error) {
          if (error) {
            return_msg += "firebase write failed with error data:" + error;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          } else {
            return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
          }
        });

        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7initObjectAttributeCommandHistoryListener(object_attribute_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7initObjectAttributeCommandHistoryListener ";
        var task_id = "bi7_watchdog_firebase:bi7initObjectAttributeCommandHistoryListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        if (object_attribute_uid in CI.IV_object_attributes_command_history === false) {
            Vue.set(CI.IV_object_attributes_command_history,object_attribute_uid,{});
        }
        var listener_location = 'command_history_obj_atr/' + object_attribute_uid + '/';
        CI.IV_listener_object_attribute_command_history[object_attribute_uid] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_object_attribute_command_history[object_attribute_uid]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_object_attribute_command_history[object_attribute_uid];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_object_attribute_command_history[object_attribute_uid].on("value",
            function (a_data) { CI.bi7ObjectAttributeCommandHistoryListener(object_attribute_uid, a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    bi7ObjectAttributeCommandHistoryListener(object_attribute_uid, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7ObjectAttributeCommandHistoryListener ";
        var task_id = "bi7_watchdog_firebase:bi7ObjectAttributeCommandHistoryListener";

        ////// input validation 
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;
        var firebase_data = data.val();
        var entry;

        for(var year in firebase_data) {
            if (firebase_data[year] === 'deletion_prevention_key') {
                continue;
            }
            var entry_preparse = '';
            for(var month in firebase_data[year]) {
                for(var date in firebase_data[year][month]) {
                    for(var timestamp in firebase_data[year][month][date]) {
                        try {
                            entry_preparse = firebase_data[year][month][date][timestamp];
                            entry = JSON.parse(firebase_data[year][month][date][timestamp])
                        } catch(error) {
                            var error_msg = return_msg + "failed to JSOn parse firebase data with error:" + error;
                            debug_data.push(firebase_data[year][month][date])
                            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, error_msg, debug_data);
                            continue;
                        }
                        entry['human_timestamp'] = bi6_misc.bi6UtcToLocalTime(entry['timestamp']);
                        Vue.set(CI.IV_object_attributes_command_history[object_attribute_uid],entry['timestamp'],entry);
                    }
                }
            }
            
        }

    }

    bi7RequestUserEmail(user_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7RequestUserEmail ";
        var task_id = "bi7_watchdog_firebase:bi7RequestUserEmail";

        ////// input validation 
        call_result = bi1_data_validation.is_user_uid(user_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 
        var CI = this;

        if (user_uid in CI.IV_users_contact_email === false) {
            Vue.set(CI.IV_users_contact_email,user_uid,'');
            CI.bi7CreateDataStoreRequest('usr_contact_email',user_uid,null);
        }
    }

    bi7GetObjectAttributeHistoryRef(object_attribute_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetObjectAttributeHistoryRef ";
      var task_id = "bi7_watchdog_firebase:bi7GetObjectAttributeHistoryRef";

      call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
      debug_data.push(call_result);
      
      ////// input validation 
      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if(validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      //////</end> input validation 
      
      var CI = this;

      if (object_attribute_uid in CI.IV_object_attribute_history_ref === false) {
        CI.IV_object_attribute_history_ref[object_attribute_uid] = {};
      }

      CI.IV_geting_object_attribute_history_ref[object_attribute_uid] = true;
      var listener_location = 'v2_history_ref_obj_atr/history_ref_' + object_attribute_uid + '/';

      //if we already have a listener active, complete the transcation
      if (object_attribute_uid in CI.IV_listener_object_attribute_history_ref &&
          CI.IV_listener_object_attribute_history_ref[object_attribute_uid] !== null &&
          CI.IV_listener_object_attribute_history_ref[object_attribute_uid] !== undefined
        ) {
        CI.IV_geting_object_attribute_history_ref[object_attribute_uid] = false;
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      CI.IV_listener_object_attribute_history_ref[object_attribute_uid] = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_object_attribute_history_ref[object_attribute_uid]);
      debug_data.push(call_result)
      if (call_result[CR.success] !== RC.success) {
        delete CI.IV_listener_object_attribute_history_ref[object_attribute_uid];
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_object_attribute_history_ref[object_attribute_uid].on("value",
        function (a_data) { 
          CI.GetObjectAttributeHistoryRefCallback(object_attribute_uid, a_data) 
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(CI)
      );
    }

    GetObjectAttributeHistoryRefCallback(object_attribute_uid, data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:GetObjectAttributeHistoryRefCallback ";
      var task_id = "bi7_watchdog_firebase:GetObjectAttributeHistoryRefCallback";
      var CI = this;

      ////// input validation 
      call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
      debug_data.push(call_result);
      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }
      if (validation_failed === true) {
        CI.IV_geting_object_attribute_history_ref[object_attribute_uid] = false;
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return;
      }

      if (data === null) {
        CI.IV_geting_object_attribute_history_ref[object_attribute_uid] = false;
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var firebase_data = data.val();
      if (firebase_data === null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        CI.IV_geting_object_attribute_history_ref[object_attribute_uid] = false;
        return;
      }

      CI.IV_geting_object_attribute_history_ref[object_attribute_uid] = true;

      if (object_attribute_uid in CI.IV_object_attribute_history_ref === false) {
        CI.IV_object_attribute_history_ref[object_attribute_uid] = {};
      }

      for (var year in firebase_data) {
        if (year in CI.IV_object_attribute_history_ref[object_attribute_uid] === false) {
          CI.IV_object_attribute_history_ref[object_attribute_uid][year] = {};
        }

        for (var month in firebase_data[year]) {
          if (month in CI.IV_object_attribute_history_ref[object_attribute_uid][year] === false) {
            CI.IV_object_attribute_history_ref[object_attribute_uid][year][month] = {};
          }

          for (var day in firebase_data[year][month]) {
            if (day in CI.IV_object_attribute_history_ref[object_attribute_uid][year][month] === false) {
              CI.IV_object_attribute_history_ref[object_attribute_uid][year][month][day] = true;
            }
          }
        }
      }

      CI.IV_geting_object_attribute_history_ref[object_attribute_uid] = false;
    }

    bi7initGettingObjectAttributeHistoryValues(obj_attribute_uid, start_timestamp, end_timestamp, transcation_id, listener_type=null) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7initGettingObjectAttributeHistoryValues ";
      var task_id = "bi7_watchdog_firebase:bi7initGettingObjectAttributeHistoryValues";
      var CI = this;

      CI.IV_active_transcations[transcation_id] = true;
      Vue.set(CI.IV_vue_transcations, transcation_id, false);

      /// waiting here to get complete the bi7GetObjectAttributeHistoryRef function
      if (CI.IV_geting_object_attribute_history_ref[obj_attribute_uid]) {
        setTimeout(
          function() {
            CI.bi7initGettingObjectAttributeHistoryValues(obj_attribute_uid, start_timestamp, end_timestamp, transcation_id, listener_type)
          }.bind(CI),
          200
        );
        return;
      }
      ///</end> waiting here to get complete the bi7GetObjectAttributeHistoryRef function

      ////// input validation 
      call_result = bi1_data_validation.is_not_null(start_timestamp);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_not_null(end_timestamp);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_object_attribute_uid(obj_attribute_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(transcation_id);
      debug_data.push(call_result);

      if (listener_type !== null) {
        call_result = bi1_data_validation.is_string(listener_type);
        debug_data.push(call_result);
      }

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        
        CI.IV_active_transcations[transcation_id] = false;
        Vue.set(CI.IV_vue_transcations, transcation_id, true);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      //////</end> input validation 

      var startDate = moment(start_timestamp);
      var endDate = moment(end_timestamp);

      if (listener_type === null) {
        var duration = moment.duration(endDate.diff(startDate));
        var hours_diff = duration.asHours();

        // if (30 days)
        if (hours_diff <= 720) {
          listener_type = "days";

        // if (30 days to 6 months)
        } else if (hours_diff > 720 && hours_diff <= 4320) {
          listener_type = "months";

        // if (6 months to 3 years)
        } else if (hours_diff > 4320 && hours_diff <= 25920) {
          listener_type = "years";
        } else {
          // if the timespan is more than 3 years we'll get all data from firebase
          CI.bi7InitObjectAttributeHistoryListener(obj_attribute_uid, transcation_id);
          return;
        }
      }

      CI.bi7GetObjectAttributeHistoryValues(obj_attribute_uid, start_timestamp, end_timestamp, transcation_id, listener_type);

    }

    bi7GetObjectAttributeHistoryValues(obj_attribute_uid, start_timestamp, end_timestamp, transcation_id, listener_type) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetObjectAttributeHistoryValues ";
      var task_id = "bi7_watchdog_firebase:bi7GetObjectAttributeHistoryValues";
      var CI = this;

      /// This function will be called to stop loading sign
      /// It will be called if we get any error or all operations gets complete
      var end_loading = function() {
        CI.IV_active_transcations[transcation_id] = false;
        Vue.set(CI.IV_vue_transcations, transcation_id, true);
      };
      ///</end> This function will be called to stop loading sign
      ///</end> It will be called if we get any error or all operations gets complete

      //// This function will fetch the latest value of object attribute.
      //// This will be needed/called only if we did not get any value for selected timeframe
      var fetch_latest_obj_attribute_value = function() {
        var listener_location = 'newest_obj_atr_values/' + obj_attribute_uid + '/';
        var listener_ref = CI.IV_firebase_db_object.ref(listener_location);

        listener_ref.once("value").then(
          function (a_data) {
            if (a_data === null) {
              return_msg += "firebase read failed with null data:";
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
              end_loading();
              return;
            }
            var firebase_data = a_data.val();
            if (firebase_data === null) {
              return_msg += "firebase read failed with null data:";
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
              end_loading();
              return;
            }

            if (Object.keys(firebase_data).length == 0) {
              end_loading();
              return;
            }

            if (!Object.keys(firebase_data).find((key) => key !== "deletion_prevention_key")) {
              end_loading();
              return;
            }

            var vue_timestamp = 0;

            try {
              vue_timestamp = firebase_data.last_updated * 1000;
            } catch (error) {
              var error_msg = 'failed to get timestamp for history data with exception';
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, error_msg, error);
              end_loading();
              return;
            }

            var entry_object = {};
            entry_object.date = vue_timestamp;
            entry_object.value = firebase_data.value;
            CI.IV_object_attribute_history_values[obj_attribute_uid].push(entry_object);
            end_loading();
          }.bind(CI),
          function (error) {
            return_msg += "firebase read failed with error data:" + errorObject;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            end_loading();
          }
        )
      }
      ////</end> This function will fetch the latest value of object attribute.
      ////</end> This will be needed/called only if we did not get any value for selected timeframe

      ////// input validation 
      call_result = bi1_data_validation.is_not_null(start_timestamp);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_not_null(end_timestamp);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_object_attribute_uid(obj_attribute_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(transcation_id);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(listener_type);
      debug_data.push(call_result);
      
      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        
        CI.IV_active_transcations[transcation_id] = false;
        Vue.set(CI.IV_vue_transcations, transcation_id, true);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      //////</end> input validation 

      var startDate = moment(start_timestamp);
      var endDate = moment(end_timestamp);

      /// Checking if we reach to end date then we'll stop fetching here
      if (moment(startDate).isAfter(endDate, listener_type.replace("s",""))) {
        /// We'll fetch latest/newest attribute value.
        /// if we didn't get any singlr value within the time range selected

        if (CI.IV_object_attribute_history_values[obj_attribute_uid].length < 1) {
          var attribute_value = CI.IV_object_attribute_values[obj_attribute_uid];

          if (attribute_value !== null && attribute_value !== undefined &&
              Object.keys(attribute_value) > 0) {

            try {
              vue_timestamp = attribute_value.last_updated * 1000;
            } catch (error) {
              var error_msg = 'failed to get timestamp for history data with exception';
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, error_msg, error);
              end_loading();
              return;
            }

            var entry_object = {};
            entry_object.date = vue_timestamp;
            entry_object.value = attribute_value.value;
            CI.IV_object_attribute_history_values[obj_attribute_uid].push(entry_object);
            end_loading();
            return
          }

          fetch_latest_obj_attribute_value();
          return;
        }

        ///</end> We'll fetch latest/newest attribute value.
        ///</end> if we didn't get any singlr value within the time range selected

        end_loading();
        return;
      }
      ///</end> Checking if we reach to end date then we'll stop fetching here

      /// checking if the date is present in history ref dict
      /// starting listener if present or re calling function with next day

      ///// Daily data fetching
      if (listener_type === "days") {
        let year = startDate.year(), month = 1 + startDate.month(), day = startDate.date();
        var date_present = false;

        if (year in CI.IV_object_attribute_history_ref[obj_attribute_uid]) {
          if (month in CI.IV_object_attribute_history_ref[obj_attribute_uid][year]) {
            if (day in CI.IV_object_attribute_history_ref[obj_attribute_uid][year][month]) {
              date_present = true;
            }
          }
        }

        if (date_present === false) {
          let next_date = moment(startDate).add(1, "days");
          CI.bi7GetObjectAttributeHistoryValues(obj_attribute_uid, next_date, endDate, transcation_id, listener_type);
          return;
        }

        var listener_location = `v2_history_obj_atr/history_${obj_attribute_uid}/${year}/${month}/${day}/`;
        var location_ref = CI.IV_firebase_db_object.ref(listener_location);

      /////</end> Daily data fetching

      ///// MONTHLY data fetching
      } else if (listener_type === "months") {
        let year = startDate.year(), month = 1 + startDate.month();
        var date_present = false;

        if (year in CI.IV_object_attribute_history_ref[obj_attribute_uid]) {
          if (month in CI.IV_object_attribute_history_ref[obj_attribute_uid][year]) {
            date_present = true;
          }
        }

        if (date_present === false) {
          let next_date = moment(startDate).add(1, "months");
          CI.bi7GetObjectAttributeHistoryValues(obj_attribute_uid, next_date, endDate, transcation_id, listener_type);
          return;
        }

        var listener_location = `v2_history_obj_atr/history_${obj_attribute_uid}/${year}/${month}/`;
        var location_ref = CI.IV_firebase_db_object.ref(listener_location);
      ///// MONTHLY data fetching

      ///// Yearly data fetching      
      } else if (listener_type === "years") {
        let year = startDate.year();
        var date_present = false;

        if (year in CI.IV_object_attribute_history_ref[obj_attribute_uid]) {
          date_present = true;
        }

        if (date_present === false) {
          let next_date = moment(startDate).add(1, "years");
          CI.bi7GetObjectAttributeHistoryValues(obj_attribute_uid, next_date, endDate, transcation_id, listener_type);
          return;
        }

        var listener_location = `v2_history_obj_atr/history_${obj_attribute_uid}/${year}/`;
        var location_ref = CI.IV_firebase_db_object.ref(listener_location);
      }
      ///// Yearly data fetching      

      if (obj_attribute_uid in CI.IV_object_attribute_history_values === false) {
        CI.IV_object_attribute_history_values[obj_attribute_uid] = [];
      }

      location_ref.once("value",
        function (a_data) { 
          CI.GetObjectAttributeHistoryValuesCallback(obj_attribute_uid, a_data, startDate, endDate, transcation_id, listener_type) 
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          end_loading();
        }.bind(CI));
      ///</end> checking if the date is present in history ref dict
      ///</end> starting listener if present or re calling function with next day
    }

    GetObjectAttributeHistoryValuesCallback(obj_attribute_uid, data, start_timestamp, end_timestamp, transcation_id, listener_type) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:GetObjectAttributeHistoryValuesCallback ";
      var task_id = "bi7_watchdog_firebase:GetObjectAttributeHistoryValuesCallback";
      var CI = this;

      // Will re-call the function by adding 1 day, month, or year to start date
      // according to listener_type
      var call_next_date = function() {
        let next_date = moment(start_timestamp).add(1, listener_type);
        CI.bi7GetObjectAttributeHistoryValues(obj_attribute_uid, next_date, end_timestamp, transcation_id, listener_type);
      };

      ////// input validation 
      call_result = bi1_data_validation.is_object_attribute_uid(obj_attribute_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_not_null(start_timestamp);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_not_null(end_timestamp);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(transcation_id);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        
        CI.IV_active_transcations[transcation_id] = false;
        Vue.set(CI.IV_vue_transcations, transcation_id, true);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }

      if (data === null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);

        call_next_date();
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var firebase_data = data.val();
      
      if (!firebase_data) {
        call_next_date();
        return;
      }

      var one_day_data_handler = function(one_day_data) {
        for (var timestamp in one_day_data) {
          var vue_timestamp = 0;

          try {
            vue_timestamp = timestamp * 1000;
          } catch (error) {
            var error_msg = 'failed to get timestamp for history data with exception';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, error_msg, error);
            continue;
          }

          var entry_object = {};
          entry_object.date = vue_timestamp;
          entry_object.value = one_day_data[timestamp];
          CI.IV_object_attribute_history_values[obj_attribute_uid].push(entry_object);
        }
      }

      var one_month_data_handler = function(one_month_data) {
        for (let day in one_month_data) {
          one_day_data_handler(one_month_data[day]);
        }
      }

      var one_year_data_handler = function(one_year_data) {
        for (let month in one_year_data) {
          one_month_data_handler(one_year_data[month]);
        }
      }

      if (listener_type === "days") {
        one_day_data_handler(firebase_data);
      } else if (listener_type === "months") {
        one_month_data_handler(firebase_data);
      } else if (listener_type === "years") {
        one_year_data_handler(firebase_data);
      }

      /// Starting init function again for next date;
      call_next_date();

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitObjectAttributeHistoryListener(object_attribute_uid,transcation_id,start_timestamp,end_timestamp) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7InitObjectAttributeHistoryListener ";
        var task_id = "bi7_watchdog_firebase:bi7InitObjectAttributeHistoryListener";

        ////// input validation 
        call_result = bi1_data_validation.is_string(transcation_id);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
        
        var validation_failed = false;
        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }

        if(validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }
        //////</end> input validation 

        var CI = this;
        var listener_location = 'v2_history_obj_atr/history_' + object_attribute_uid + '/';
        
        if (object_attribute_uid in CI.IV_object_attribute_history_values === false) {
          Vue.set(CI.IV_object_attribute_history_values, object_attribute_uid, []);
        }

        //if we already have a listener active, complete the transcation
        if(object_attribute_uid in CI.IV_listener_object_attribute_history_values &&
            CI.IV_listener_object_attribute_history_values[object_attribute_uid] !== null &&
            CI.IV_listener_object_attribute_history_values[object_attribute_uid] !== undefined
          ) {
            CI.IV_active_transcations[transcation_id] = false;
            Vue.set(CI.IV_vue_transcations,transcation_id,true);
            return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        CI.IV_active_transcations[transcation_id] = true;
        Vue.set(CI.IV_vue_transcations,transcation_id,false);
        CI.IV_listener_object_attribute_history_values[object_attribute_uid] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_object_attribute_history_values[object_attribute_uid]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_object_attribute_history_values[object_attribute_uid];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_object_attribute_history_values[object_attribute_uid].on("value",
            function (a_data) { CI.bi7ObjectAttributeHistoryListener(object_attribute_uid,transcation_id, a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    bi7ObjectAttributeHistoryListener(object_attribute_uid,transcation_id, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7ObjectAttributeHistoryListener ";
        var task_id = "bi7_watchdog_firebase:bi7ObjectAttributeHistoryListener";

        ////// input validation 
        call_result = bi1_data_validation.is_string(transcation_id);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
        var validation_failed = false;

        for (var index in debug_data) {
            if (debug_data[index][CR.success] !== RC.success) {
                validation_failed = true;
            }
        }

        if (validation_failed === true) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return;
        }

        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        //////</end> input validation 

        var CI = this;
        var firebase_data = data.val();

        if (firebase_data === null) {
          CI.IV_active_transcations[transcation_id] = false;
          Vue.set(CI.IV_vue_transcations,transcation_id,true);
          return;
        }

        /// create the flag to track the newest value we have already read
        if (object_attribute_uid in CI.IV_object_attribute_history_last_time === false) {
            CI.IV_object_attribute_history_last_time[object_attribute_uid] = 0;
        }

        for(var year in firebase_data) {
            for(var month in firebase_data[year]) {
                for(var day in firebase_data[year][month]) {
                    for(var timestamp in firebase_data[year][month][day]) {
                        var vue_timestamp = 0;
                        try {
                            vue_timestamp  = timestamp * 1000;              
                                                                            
                        } catch (error) {
                            var error_msg = 'failed to get timestamp for history data with exception';
                            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, error_msg, error);
                            continue;
                        }
                        //this prevents adding the same data twice since
                        if(vue_timestamp <= CI.IV_object_attribute_history_last_time[object_attribute_uid]) {
                            continue;
                        } else {                        
                            CI.IV_object_attribute_history_last_time[object_attribute_uid] = vue_timestamp;
                        }
                        var entry_object = {};
                        entry_object.date = vue_timestamp;
                        entry_object.value = firebase_data[year][month][day][timestamp];
                        CI.IV_object_attribute_history_values[object_attribute_uid].push(entry_object);
                    }
                }
            }
        }
        CI.IV_active_transcations[transcation_id] = false;
        Vue.set(CI.IV_vue_transcations,transcation_id, true);
    }

    updateLastJoinListenerStartTime() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:updateLastJoinListenerStartTime ";
      var task_id = "bi7_watchdog_firebase:updateLastJoinListenerStartTime";
      var CI = this;
      
      var date_object = new Date();
      CI.IV_last_join_listener_started_time = date_object.getTime()  / 1000;
    }

    updateLastJoinDataChanged() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:updateLastJoinDataChanged ";
      var task_id = "bi7_watchdog_firebase:updateLastJoinDataChanged";
      var CI = this;
      
      var date_object = new Date();
      CI.IV_last_join_data_change = date_object.getTime()  / 1000; 
    }

    validateFirebaseListener(listener_object) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:validateFirebaseListener ";
      var task_id = "bi7_watchdog_firebase:validateFirebaseListener";
      var CI = this;

      try {
        call_result = bi1_data_validation.is_string(listener_object['database']['app']['options_']['apiKey']);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(listener_object['key']);
        debug_data.push(call_result);
      } catch (err) {
        return_msg += "object is not a valid firebase listener, errors:" + JSON.stringify(err.message);
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }
      if(validation_failed === true) {
        return_msg += "object is not a valid firebase listener";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7LogClearDoghouseActiveEntry(rule_uid, rule_join_uid, org_uid, system_uid, object_uid, object_attribute_uid, tags, value, triggered_timestamp) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7LogClearDoghouseActiveEntry ";
      var task_id = "bi7_watchdog_firebase:bi7LogClearDoghouseActiveEntry";
      var CI = this;

      if (CI.IV_instance_initialized === false) {
        return_msg += 'instance is not initialized';
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      //////// input validation
      if(org_uid !== null && org_uid !== undefined) {
        call_result = bi1_data_validation.is_org_uid(org_uid);
        debug_data.push(call_result);
      } 
      if(system_uid !== null && system_uid !== undefined) {
        call_result = bi1_data_validation.is_system_uid(system_uid);
        debug_data.push(call_result);
      }
      if(object_uid !== null && object_uid !== undefined) {
        call_result = bi1_data_validation.is_object_uid(object_uid);
        debug_data.push(call_result);
      } 
      if(object_attribute_uid !== null && object_attribute_uid !== undefined) {
        call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
        debug_data.push(call_result);
      }

      call_result = bi1_data_validation.is_string(rule_join_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(rule_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_array(tags);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(triggered_timestamp);
      debug_data.push(call_result);


      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }
      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      /////// </end> input validation

      var folder = CI.IV_user_folder_path + '/dog_house_history/' + org_uid + '/' + system_uid + '/' + object_uid + '/' + object_attribute_uid + '/' + rule_uid;

      var reference = CI.IV_firebase_db_object.ref(folder);
      if (reference === null) {
        return_msg += "failed to create reference for " + folder;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var timestamp = Math.ceil(new Date().getTime() / 1000).toString();

      var data = {
        timestamp:  timestamp, 
        entry_type: "MANUAL", 
        rule_uid: rule_join_uid, 
        value: "Manually Cleared", 
        org_uid: org_uid, 
        obj_atr_uid: object_attribute_uid, 
        sys_uid: system_uid, 
        obj_uid: object_uid,
        tags: tags,
        previous_value: value,
        triggered_at: triggered_timestamp
      }

      reference.child(timestamp).set(JSON.stringify(data), function(error) {
        if (error) {
          return_msg += "firebase write failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        } else {
          Vue.delete(CI.IV_doghouse_active[org_uid][system_uid][object_uid][object_attribute_uid],rule_uid);
          return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }
      });
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }


    async bi7UpdateCachedJoinData() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7UpdateCachedJoinData ";
      var task_id = "bi7_watchdog_firebase:bi7UpdateCachedJoinData";
      var CI = this;

      var date_object = new Date();
      var time_now = date_object.getTime() / 1000;
      //if a system is deleted the organization structure has to be rebuilt
      var systems_deleted_flag = false;
      //// resetting the lockout if lockout time is greater than 40 secs
      if (time_now - CI.IV_last_update_cached_join_data_run_time > 40) {
        CI.IV_save_join_data_to_cache_lockout = false;
      }
      // preventing if another insance is already running.
      if (CI.IV_save_join_data_to_cache_lockout === true) {
        return;
      } else {
        // acquiring lock.
        CI.IV_save_join_data_to_cache_lockout = true;
      }

      // return if last join listener started in last 10 seconds
      if(time_now - CI.IV_last_join_listener_started_time < 10) {
        CI.IV_save_join_data_to_cache_lockout = false;
        return;
      }

      
       ////// removing old data from localForage
      
      // /// remove old system org associations              
      // var system_remove_list = [];
      // for(var sys_uid in CI.IV_system_org_joins) {
      //     if(sys_uid === 'last_updated') {continue;}
      //   if( sys_uid in CI.IV_system_live_uids === false) { 
      //       system_remove_list.push(sys_uid);
      //     }
      // }
      // for(var index in system_remove_list) {
      //   var sys_uid = system_remove_list[index];
      //   var org_uid = CI.IV_system_org_joins[sys_uid];
      //   CI.IV_local_forage.removeItem('org_sys_join-' + org_uid);
      //   Vue.delete(CI.IV_system_org_joins,sys_uid);
      //   Vue.delete(CI.IV_org_system_joins[org_uid],sys_uid);
      //   if(systems_deleted_flag !== true) { systems_deleted_flag = true;}
      // }
      // ///</end> remove old system org associations

      /// remove old system object associations
      let object_remove_list = [];
      for (let object_uid in CI.IV_system_object_joins_reverse_lookup) {
        let system_uid = CI.IV_system_object_joins_reverse_lookup[object_uid];

        // an object whose system exist in the listeners means we are getting live data for system
        // But object_uid that has no listener for its meta data means:
        // its an object that has been deleted in firebase but is still in cache.
        if (system_uid in CI.IV_listener_system_all_object_and_attributes_joins === true &&
          object_uid in CI.IV_object_live_uids === false) { 
          object_remove_list.push(object_uid);
        }
      }

      // We'll remove all those object's data that has been deleted in firebase but is still in cache.
      for (let obj_index in object_remove_list) {
        let object_uid = object_remove_list[obj_index];
        let system_uid = CI.IV_system_object_joins_reverse_lookup[object_uid];

        CI.IV_local_forage.removeItem('obj_atr_join-' + object_uid);
        Vue.delete(CI.IV_system_object_joins[system_uid], object_uid, object_uid);
        Vue.delete(CI.IV_system_object_joins_reverse_lookup, object_uid);
      }
      ///</end> remove old system object associations

      /// remove old object attribute associations
      let attribute_remove_list = [];
      for (let attribute_uid in CI.IV_object_attribute_joins_reverse_lookup) {
        let object_uid = CI.IV_object_attribute_joins_reverse_lookup[attribute_uid];
        let system_uid = CI.IV_system_object_joins_reverse_lookup[object_uid];

        // an attribute whose object exist in its system's listeners means we are getting live data for it's system.
        // But attribute that is no listener for its meta data means:
        // its an attribute that has been deleted in firebase but is still in cache.
        if (system_uid in CI.IV_listener_system_all_object_and_attributes_joins === true && 
          attribute_uid in CI.IV_object_attribute_live_uids === false) { 
          attribute_remove_list.push(attribute_uid);
        }
      }

      // We'll remove all those object's data that has been deleted in firebase but is still in cache/dictionaries.
      for (let atr_index in attribute_remove_list) {
        let attr_id = attribute_remove_list[atr_index];
        let object_uid = CI.IV_object_attribute_joins_reverse_lookup[attribute_uid];

        CI.IV_local_forage.removeItem('obj_atr_join-' + object_uid);
        Vue.delete(CI.IV_object_attribute_joins[object_uid], attr_id, attr_id);
        Vue.delete(CI.IV_object_attribute_joins_reverse_lookup, attr_id);
      }
      
      ///</end> remove old object attribute associations

      //////</end> removing old data from localForage

      
      //// saving data to localForage
      // for (var org_uid in CI.IV_listener_org_system_joins) {
      //   if (org_uid.indexOf('org_') === 0) {
      //     var data_dict = {
      //       last_updated: time_now,
      //       value: CI.IV_org_system_joins[org_uid]
      //     }

      //     ///// caching data to localForage only when data updated
      //     var cached_value = await CI.IV_local_forage.getItem('org_sys_join-' + org_uid)
      //     if (cached_value !== null) {
      //       var cached_data = JSON.parse(cached_value)["value"];
      //       // only set if value is updated or not present in cache
      //       if (JSON.stringify(cached_data) !== JSON.stringify(data_dict["value"])) {
      //         CI.IV_local_forage.setItem('org_sys_join-' + org_uid, JSON.stringify(data_dict));
      //       }
      //     } else {
      //       CI.IV_local_forage.setItem('org_sys_join-' + org_uid, JSON.stringify(data_dict));
      //     }
      //     /////</end> caching data to localForage only when data updated
      //   }
      // }

      for (var sys_uid in CI.IV_listener_system_all_object_and_attributes_joins) {
        if (sys_uid.indexOf('sys_') === 0) {
          var data_dict = {
            last_updated: time_now,
            value: CI.IV_system_object_joins[sys_uid]
          }

          ///// caching data to localForage only when data updated
          var cached_value = await CI.IV_local_forage.getItem('sys_obj_join-' + sys_uid)
          if (cached_value !== null && cached_value !== undefined) {
            // only set if value is updated or not present in cache
            if (JSON.stringify(cached_value) !== JSON.stringify(data_dict["value"])) {
              CI.IV_local_forage.setItem('sys_obj_join-' + sys_uid, data_dict);
            }
          } else {
            CI.IV_local_forage.setItem('sys_obj_join-' + sys_uid, data_dict);
          }
          /////</end> caching data to localForage only when data updated
        }

        for (var obj_uid in CI.IV_system_object_joins[sys_uid]) {
          if (obj_uid.indexOf('obj_') === 0) {
            var data_dict = {
              last_updated: time_now,
              value: CI.IV_object_attribute_joins[obj_uid]
            }

            ///// caching data to localForage only when data updated
            const cached_value = await CI.IV_local_forage.getItem('obj_atr_join-' + obj_uid);

            if (cached_value !== null && cached_value !== undefined) {
              // only set if value is updated or not present in cache

              if (JSON.stringify(cached_value) !== JSON.stringify(data_dict["value"])) {
                CI.IV_local_forage.setItem('obj_atr_join-' + obj_uid, data_dict);
              }
            } else {
              CI.IV_local_forage.setItem('obj_atr_join-' + obj_uid, data_dict);
            }
            /////</end> caching data to localForage only when data updated
          }
        }
      }
      ////</end> saving data to localForage

      CI.IV_last_update_cached_join_data_run_time = date_object.getTime() / 1000;
      
      
      //this forces the organization system tree view data to refresh so the user sees a deleted system go away
      if(systems_deleted_flag === true) {
        CI.IV_last_updated_timestamps['presets']['all_preset'] =  CI.IV_last_update_cached_join_data_run_time;
      }
      // releasing lock.
      CI.IV_save_join_data_to_cache_lockout = false;
      return;
    }

    bi7LoadCachedJoinData(type=null, uid=null) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7LoadCachedJoinData ";
      var task_id = "bi7_watchdog_firebase:bi7LoadCachedJoinData";
      var CI = this;

      //// input validation
      call_result = bi1_data_validation.is_string(type);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(uid);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if (validation_failed === false &&
          // type.indexOf("org_sys_join-") !== 0 &&
          type.indexOf("sys_obj_join-") !== 0 &&
          type.indexOf("obj_atr_join-") !== 0) {
        return_msg += "type argument is invalid";
        validation_failed = true;
      }

      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      //// </end> input validation

      CI.IV_local_forage.getItem(type + uid).then((json_data)=>{
      if (json_data === null || json_data === undefined) {
        return;
      }
      var data = json_data["values"];
      
      switch(type) {
        case 'sys_obj_join-':
        if (data && Object.keys(data).length > 0) {
          for (var key in data) {
            if (key in CI.IV_system_object_joins[uid] === false || CI.IV_system_object_joins[uid][key] !== key) {
              Vue.set(CI.IV_system_object_joins[uid],key,key);
              Vue.set(CI.IV_system_object_joins_reverse_lookup,key,uid);

              // It will load object attributes joins data as well 
              // because now we are not listening objec attribute join separately.
              if (key in CI.IV_object_attribute_joins === false) {
                CI.IV_object_attribute_joins[key] = {};
              }
                CI.bi7LoadCachedJoinData('obj_atr_join-', key);
            }
          }
        }
        break;

        case 'obj_atr_join-':
        if (data && Object.keys(data).length > 0) {
          for (var key in data) {
            if (key in CI.IV_object_attribute_joins[uid] === false) {
              Vue.set(CI.IV_object_attribute_joins[uid],key,key);
              Vue.set(CI.IV_object_attribute_joins_reverse_lookup,key,uid);
            }
          }
        }
        break;
      }
    });

      
      return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    bi7UnsubscribeSpecificListener(listener_type, uid, component_id) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7UnsubscribeSpecificListener ";
      var task_id = "bi7_watchdog_firebase:bi7UnsubscribeSpecificListener";
      var CI = this;

      ///// input validation
      call_result = bi1_data_validation.is_string(listener_type);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(uid);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if (!validation_failed && !Object.keys(this.IV_firebase_listeners_lookup).includes(listener_type)) {
        validation_failed = true;
        return_msg += "listener type agrument is invalid";
      }

      if(validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      /////</end> input validation

      // new listener_key_id will generate component specific listeners key.
      var listener_key_id = uid;
      if (component_id !== null && component_id !== undefined) {
        listener_key_id = component_id+"_"+uid
      }

      ///// unsubscribe logic
      if (eval("CI." + CI.IV_firebase_listeners_lookup[listener_type])[listener_key_id]) {
        var specific_firebase_listener = eval("CI." + CI.IV_firebase_listeners_lookup[listener_type]);
        try {
          specific_firebase_listener[listener_key_id].off();
          specific_firebase_listener[listener_key_id] = null;
          delete specific_firebase_listener[listener_key_id];
        } catch(error) {
          debug_data.push(JSON.stringify(error))
          return_msg += `failed to turn ${CI.IV_firebase_listeners_lookup[listener_type]} listener off for uid: ${listener_key_id}`;
          specific_firebase_listener[listener_key_id] = null;
          delete specific_firebase_listener[listener_key_id];
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
      }
      /////</end> unsubscribe logic

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7StopDoghouseHistoryListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7StopDoghouseHistoryListener ";
        var task_id = "bi7_watchdog_firebase:bi7StopDoghouseHistoryListener";
        var CI = this;

        ///// unsubscribe logic
        for (var key in CI.IV_listener_doghouse_history) {
            try {
              CI.IV_listener_doghouse_history[key].off();
              CI.IV_listener_doghouse_history[key] = null;
              delete CI.IV_listener_doghouse_history[key];
            } catch(error) {
              debug_data.push(JSON.stringify(error))
              return_msg += `failed to turn ${CI.IV_listener_doghouse_history[key]} listener off.`;
              CI.IV_listener_doghouse_history[key] = null;
              delete CI.IV_listener_doghouse_history[key];
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
              return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
            }
            
        }
            
        /////</end> unsubscribe logic
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7StopDoghouseAcknowledgedListener() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7StopDoghouseAcknowledgedListener ";
      var task_id = "bi7_watchdog_firebase:bi7StopDoghouseAcknowledgedListener";
      var CI = this;

      ///// unsubscribe logic
      for (var key in CI.IV_listener_doghouse_acknowledge) {
          try {
            CI.IV_listener_doghouse_acknowledge[key].off();
            CI.IV_listener_doghouse_acknowledge[key] = null;
            delete CI.IV_listener_doghouse_acknowledge[key];
          } catch(error) {
            debug_data.push(JSON.stringify(error))
            return_msg += `failed to turn ${CI.IV_listener_doghouse_acknowledge[key]} listener off.`;
            CI.IV_listener_doghouse_acknowledge[key] = null;
            delete CI.IV_listener_doghouse_acknowledge[key];
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
          }
          
      }
          
      /////</end> unsubscribe logic
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7UnsubscribeSystemMonitoring(system_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7UnsubscribeSystemMonitoring ";
      var task_id = "bi7_watchdog_firebase:bi7UnsubscribeSystemMonitoring";
      var CI = this;

      ///// input validation
      call_result = bi1_data_validation.is_system_uid(system_uid);
      debug_data.push(call_result);
      if (call_result[CR.success] !== RC.success) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      /////</end> input validation

      ///// unsubscribing main system listener
      try {
          CI.IV_listener_system_all_object_and_attributes_joins[system_uid].off();
          CI.IV_listener_system_all_object_and_attributes_joins[system_uid] = null;
          delete CI.IV_listener_system_all_object_and_attributes_joins[system_uid];
      } catch(error) {
          debug_data.push(JSON.stringify(error))
          return_msg += `failed to turn listener_system_all_object_and_attributes_joins listener off for uid: ${system_uid}`;
          CI.IV_listener_system_all_object_and_attributes_joins[system_uid] = null;
          delete CI.IV_listener_system_all_object_and_attributes_joins[system_uid];
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      /////</end> unsubscribing main system listener

      if (system_uid in CI.IV_system_object_joins === true) {
          for (let obj_uid in CI.IV_system_object_joins[system_uid]) {
            if (obj_uid in CI.IV_listener_object_meta_data === true) {
              CI.bi7UnsubscribeSpecificListener('object_meta_data', obj_uid) 
            }
          }
      }

      for (let object_uid in CI.IV_deleted_object_uids) {
        Vue.delete(CI.IV_deleted_object_uids, object_uid);
      }
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitReportingListenersAndDownloadCSVData(org_uid, sys_uid=null, time_range, history_flag=true, current_flag=false, filters={}, include_uids_flag = false) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitReportingListenersAndDownloadCSVData ";
      var task_id = "bi7_watchdog_firebase:bi7InitReportingListenersAndDownloadCSVData";
      var CI = this;

      if (CI.IV_org_count_and_loading['is_loading'] !== false) {
        setTimeout(function() {
          CI.bi7InitReportingListenersAndDownloadCSVData(org_uid, sys_uid, time_range, history_flag, current_flag, filters, include_uids_flag);
        }, 2000);
        return;
      }
      
      var sys_obj_and_attribute_joins_promises = []
      var attr_history_promises = []
      var attr_current_value_promises = []
      const history_values_flag = history_flag;
      const current_values_flag = current_flag;
      const required_filters = filters;
      var objects_count = 0;
      var attributes_count = 0;

      // Setting loading to true before starting listeners and data preparation. 
      Vue.set(CI.IV_component_loading_states, 'c2m9_c2m10_OrgReporting', true);
      Vue.set(CI.IV_items_count_for_csv_report, 'objects', 0);
      Vue.set(CI.IV_items_count_for_csv_report, 'attributes', 0);

      /// input validation
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_array(time_range, 2, 2);
      debug_data.push(call_result);

      if (sys_uid !== null && sys_uid !== undefined) {
        call_result = bi1_data_validation.is_system_uid(sys_uid);
        debug_data.push(call_result);
      }

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      ///</end> input validation

      // making callback function for firebase failure
      var firebase_failure = function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
      }.bind(this)

      /// callback functions to start listeners and push promises to promises array
      var init_system_objects_and_attributes_join_listeners = function (uid) {
        var listener_location = 'systems/' + uid;
        var listener_ref = CI.IV_firebase_db_object.ref(listener_location);

        return listener_ref.once("value").then(
          function (a_data) {
            return [a_data.val(), uid];
          }.bind(CI),
          firebase_failure
        )
      }

      // we'll need this if we're creating CSV file for all attributes history data.
      var init_attribute_history_listeners = function (uid) {
        var listener_location = 'v2_history_obj_atr/history_' + uid + '/';
        var listener_ref = CI.IV_firebase_db_object.ref(listener_location);

        return listener_ref.once("value").then(
          function (a_data) {
            return [a_data.val(), uid];
          }.bind(CI),
          firebase_failure
        )
      }

      // we'll need this if we're creating CSV file for current values of all attribute with specific name.
      var init_attribute_current_value_listeners = function (uid) {
        var listener_location = 'newest_obj_atr_values/' + uid + '/';
        var listener_ref = CI.IV_firebase_db_object.ref(listener_location);

        return listener_ref.once("value").then(
          function (a_data) {
            return [a_data.val(), uid];
          }.bind(CI),
          firebase_failure
        )
      }
      ///</end> callback functions to start listeners and push promises to promises array

      /// checking if we are preparing data for a system or all systems under org.

      // if we get system id it means we are downloading data only for attributes under this system.
      if (sys_uid !== null && sys_uid !== undefined) {
        CI.IV_system_object_joins[sys_uid] = {};
        sys_obj_and_attribute_joins_promises.push(init_system_objects_and_attributes_join_listeners(sys_uid))

        // calling attribute histery listener for connected to watchdog for this system

        var connected_to_watchdog_uid = sys_uid.replace("sys_", "obj_atr_") + "-8"

        if (connected_to_watchdog_uid in CI.IV_object_attributes_meta_data === false) {
          CI.bi7objectAttributeMetaDataRequestForCSVData(connected_to_watchdog_uid);
        }
        if (history_values_flag === true) {
          CI.IV_object_attribute_history_values[connected_to_watchdog_uid] = [];
          attr_history_promises.push(init_attribute_history_listeners(connected_to_watchdog_uid));
        } else if (current_values_flag === true ) {
          if (connected_to_watchdog_uid in CI.IV_object_attribute_values === false) {
            CI.IV_object_attribute_values[connected_to_watchdog_uid] = {};
          }
          attr_current_value_promises.push(init_attribute_current_value_listeners(connected_to_watchdog_uid));
        }
        //</end> calling attribute histery listener for connected to watchdog for this system

      // if we are getting only org_id it means we are downloading data at the organization level.
      } else {

        /// starting listeners for all systems from nested sub orgs.
        var sub_orgs_ids_list = [];
        var search_string = org_uid + "org_";
        
        for (var key in CI.IV_org_location_strings) {
          if (CI.IV_org_location_strings[key].indexOf(search_string) >= 0) {
            sub_orgs_ids_list.push(key);
          }
        }

        sub_orgs_ids_list.push(org_uid);

        for (let index in sub_orgs_ids_list) {
          for (var system_id in CI.IV_org_system_joins[sub_orgs_ids_list[index]]) {
            if (system_id === "last_updated" || system_id === 'deletion_prevention_key') { continue; }

            CI.IV_system_object_joins[system_id] = {};
            sys_obj_and_attribute_joins_promises.push(init_system_objects_and_attributes_join_listeners(system_id))

            // calling attribute histery listener for connected to watchdog for this system
            var connected_to_watchdog_uid = system_id.replace("sys_", "obj_atr_") + "-8"

            if (connected_to_watchdog_uid in CI.IV_object_attributes_meta_data === false) {
              CI.bi7objectAttributeMetaDataRequestForCSVData(connected_to_watchdog_uid);
            }
            if (history_values_flag === true) {
              CI.IV_object_attribute_history_values[connected_to_watchdog_uid] = [];
              attr_history_promises.push(init_attribute_history_listeners(connected_to_watchdog_uid));
            } else if (current_values_flag === true ) {
              if (connected_to_watchdog_uid in CI.IV_object_attribute_values === false) {
                CI.IV_object_attribute_values[connected_to_watchdog_uid] = {};
              }
              attr_current_value_promises.push(init_attribute_current_value_listeners(connected_to_watchdog_uid));
            }
            //</end> calling attribute histery listener for connected to watchdog for this system
          }
        }
        ///<end> starting listeners for all systems from nested sub orgs.
      }
      ///</end> checking if we are preparing data for a system or all systems under org.

      /// calling all nested listener once for system's objects, object's attributes and attribute's history/current values.
      /// Then Calling bi7GetAttributesCsvDataStep1 to filter data on attribute's name/value and request necessory object's names.

      // It will wait until all sys_obj_and_attribute_joins_promises get completed.
      Promise.all(sys_obj_and_attribute_joins_promises).then((values) => {
        for (let index in values) {
          var system_data = values[index];
          //// data validation
          if (Array.isArray(system_data) === false || system_data.length < 2
          || system_data[0] === undefined || system_data[1] === undefined
           || system_data[0] === null || system_data[1] === null) {
             continue;
           }
           ////</end> data validation

          var system_uid = system_data[1];
          var system_object_uids = system_data[0]['object_uids'];
          var system_attribute_uids = system_data[0]['object_attributes'];

          //// Setting system object joins 
          if (system_object_uids !== null && system_object_uids !== undefined) {
            for (let obj_key in system_object_uids) {

              if (system_object_uids[obj_key][0] === 'd') {
                continue;
              }
              //ignore last updated entries, the system is technically an object but we don't list it with the objects under the system
              if (obj_key === "last_updated" || 
                  obj_key === 'deletion_prevention_key' ||
                  obj_key === system_uid.replace('sys_','obj_')
                  ) {
                continue;
              }

              if (obj_key in CI.IV_object_attribute_joins === false) {
                CI.IV_object_attribute_joins[obj_key] = {};
              }
              
              if (obj_key in CI.IV_system_object_joins[system_uid] === false || CI.IV_system_object_joins[system_uid][obj_key] !== obj_key) {
                CI.IV_system_object_joins[system_uid][obj_key] = obj_key;
                CI.IV_system_object_joins_reverse_lookup[obj_key] = system_uid;
              }

              objects_count += 1;
              Vue.set(CI.IV_items_count_for_csv_report, 'objects', objects_count);
            }
          }
          ////</end> Setting system object joins 

          //// Setting system object_attribute joins 
          if (system_attribute_uids !== null && system_attribute_uids !== undefined) {
            for (let attr_key in system_attribute_uids) {

              //ignore last updated entries
              if (attr_key === "last_updated" || attr_key === 'deletion_prevention_key') {
                continue;
              }

              var attribute_object_uid = "";
              try {
                attribute_object_uid = `obj_${CI.bi7ExtractNumbers(attr_key.split("-")[0])}`;
              } catch(error) {
                return_msg += "failed to JSOn parse firebase data with error:" + error;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
                continue;
              }

              // checking if the attribute belongs to any object under this system
              if (attribute_object_uid in CI.IV_object_attribute_joins === false) {
                continue;
              }
              //</end> checking if the attribute belongs to any object under this system

              if (attr_key in CI.IV_object_attribute_joins[attribute_object_uid] === false) {
                CI.IV_object_attribute_joins[attribute_object_uid][attr_key] = attr_key;
                CI.IV_object_attribute_joins_reverse_lookup[attr_key] = attribute_object_uid;
              }
              
              if (attr_key in CI.IV_object_attributes_meta_data === false) {
                CI.bi7objectAttributeMetaDataRequestForCSVData(attr_key);
              }


              if (history_values_flag === true) {
                CI.IV_object_attribute_history_values[attr_key] = [];
                attributes_count += 1;
                Vue.set(CI.IV_items_count_for_csv_report, 'attributes', attributes_count);
                attr_history_promises.push(init_attribute_history_listeners(attr_key));
              } else if (current_values_flag === true) {
                if (attr_key in CI.IV_object_attribute_values === false) {
                  attributes_count += 1;
                  Vue.set(CI.IV_items_count_for_csv_report, 'attributes', attributes_count);
                  CI.IV_object_attribute_values[attr_key] = {};
                }
                attr_current_value_promises.push(init_attribute_current_value_listeners(attr_key));
              }
            }
          }
          ////</end> Setting system object_attribute joins           
        }

        if (history_values_flag === true) {
          // It will wait until all attr_history_promises get completed.
          Promise.all(attr_history_promises).then((values) => {
            for (let index in values) {
              let value_data = values[index]

              for(var year in value_data[0]) {
                for(var month in value_data[0][year]) {
                  for(var day in value_data[0][year][month]) {
                    for(var timestamp in value_data[0][year][month][day]) {
                      var entry_object = {};
                      entry_object.date = timestamp * 1000;
                      entry_object.value = value_data[0][year][month][day][timestamp];
                      CI.IV_object_attribute_history_values[value_data[1]].push(entry_object);
                    }
                  }
                }
              }
            }
            setTimeout(function() {
              CI.bi7GetAttributesCsvDataStep1(org_uid, sys_uid, time_range, history_values_flag, current_values_flag, required_filters, include_uids_flag)
            }, 2000);
          })
        } else {
          // It will wait until all attr_current_value_promises get completed.
          Promise.all(attr_current_value_promises).then((values) => {
            for (let index in values) {
              let value_data = values[index];
              if(value_data === null || value_data[0] === null) { continue; }
              if ('value' in value_data[0] !== undefined && 'value' in value_data[0] !== null) {
                CI.IV_object_attribute_values[value_data[1]]['value'] = value_data[0]['value'];
              } else {
                CI.IV_object_attribute_values[value_data[1]]['value'] = "";
              }

              if ('last_updated' in value_data[0] !== undefined && 'last_updated' in value_data[0] !== null) {
                CI.IV_object_attribute_values[value_data[1]]['last_updated'] = value_data[0]['last_updated'] * 1000;
              } else {
                CI.IV_object_attribute_values[value_data[1]]['last_updated'] = 0;
              }
            }
            setTimeout(function() {
              CI.bi7GetAttributesCsvDataStep1(org_uid, sys_uid, time_range, history_values_flag, current_values_flag, required_filters, include_uids_flag);
            }, 2000);
          });
        }
      })
      ///</end> calling all nested listener once for system's objects, object's attributes and attribute's history/current values.
      /// Then Calling bi7GetAttributesCsvDataStep1 to filter data on attribute's name/value and request necessory object's names.
    }

    bi7objectAttributeMetaDataRequestForCSVData(uid, check_cache=true) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7objectAttributeMetaDataRequestForCSVData ";
      var task_id = "bi7_watchdog_firebase:bi7objectAttributeMetaDataRequestForCSVData";
      var CI = this;

      //// input validation 
      call_result = bi1_data_validation.is_object_attribute_uid(uid);
      debug_data.push(call_result);
      
      if (call_result[CR.success] !== RC.success) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ////</end> input validation


      // We'll make meta data request for this attribute in 2 conditions.
      // Attribute is renamed, we'll get this information from (IV_renamed_obj_attributes_uids)
      // OR
      // The attribute is not renamed but we don't have name in IV_default_obj_attribute_names.
      // In this case we'll make request for one attribute and rest of the attributes with same uid will use the name
      var uid_num_part = uid.split("-")[1];
      if (uid in CI.IV_renamed_obj_attributes_uids === false) {

        if (uid_num_part in CI.IV_default_obj_attribute_names === true) {

          if (uid in CI.IV_object_attributes_meta_data === false) {
            CI.IV_object_attributes_meta_data[uid] = {}
          }

          // We'll delete all these entries IV_object_attributes_meta_data once we complete building CSV.
          // This is a flag to get name from IV_default_obj_attribute_names while generating CSV file.
          CI.IV_object_attributes_meta_data[uid]['name'] = true;
          return;
        }

        // To make sure we don't make request again for this attribute.
        // Name will be set in processDatarequest function.
        CI.IV_default_obj_attribute_names[uid_num_part] = "";
      }
      CI.IV_deletion_items_keys_after_csv.push(uid);
      
      if (check_cache === true) {
        CI.bi7CreateDataStoreRequest('obj_atr_meta_data', uid, null, false);
      } else {
        var timestamp = new Date().getTime() / 1000;
        CI.bi7CreateMetaDataJsonRequest("obj_atr_meta_data", attr_uid, timestamp, false);
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7GetAttributesCsvDataStep1(org_uid, sys_uid=null, time_range, history_flag=true, current_flag=false, filters={}, include_uids_flag) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetAttributesCsvDataStep1 ";
      var task_id = "bi7_watchdog_firebase:bi7GetAttributesCsvDataStep1";
      var CI = this;
      var response_data = {};
      var filter_name_flag = false;
      var filter_value_flag = false;
      var attribute_names_to_filter = [];
      var search_string_num_part = null;

      //if we are still processsing requests to get object attriubte names and values, we don't want to run this function yet
      if (current_flag === true && CI.IV_process_datatore_last_request_count > 10) {
        setTimeout(function() {
          CI.bi7GetAttributesCsvDataStep1(org_uid, sys_uid, time_range, history_flag, current_flag, filters, include_uids_flag);
        }, 3000);
        return;
      }

      /// Setting filter flags for filtering attribute names or attribute values
      if (filters !== null && filters !== undefined) {
        if (filters['name'] !== null && filters['name'] !== undefined) {
          if (filters['name']['mode'] !== null && filters['name']['mode'] !== undefined && 
              filters['name']['search_text'] !== null && filters['name']['search_text'] !== undefined) {
            attribute_names_to_filter = filters['name']['search_text'].split(",").map(function(item) {
              return item.trim().toLocaleLowerCase();
            });
            filter_name_flag = true;
          }
        }
        if (filters['value'] !== null && filters['value'] !== undefined) {
          if (filters['value']['mode'] !== null && filters['value']['mode'] !== undefined && 
              filters['value']['search_text'] !== null && filters['value']['search_text'] !== undefined) {
            if (["greater", "less"].includes(filters['value']['mode'])) {
              search_string_num_part = CI.bi7ExtractNumbers(filters['value']['search_text']);
            }
            filter_value_flag = true;
          }
        }
      }
      ///</end> Setting filter flags for filtering attribute names or attribute values

      // if we get system id it means we are downloading data only for attributes under this system.
      if (sys_uid !== null && sys_uid !== undefined) {
        var response = CI.bi7GetObjectsDataUnderSystem(sys_uid, time_range, history_flag, current_flag);
        response_data[org_uid] = {}
        response_data[org_uid][sys_uid] = response.objects_data

      // if we are getting only org_id it means we are downloading data at the organization level.
      } else {

        /// getting CSV Data of all attributes for all systems under all nested sub orgs. 
        var sub_orgs_ids_list = [];
        var search_string = org_uid + "org_";
        
        for (var key in CI.IV_org_location_strings) {
          if (CI.IV_org_location_strings[key].indexOf(search_string) >= 0) {
            sub_orgs_ids_list.push(key);
          }
        }

        // Adding this org itself in list.
        sub_orgs_ids_list.push(org_uid);

        for (let index in sub_orgs_ids_list) {
          var response = CI.bi7GetSystemsDataUnderOrg(sub_orgs_ids_list[index], time_range, history_flag, current_flag)
          response_data[sub_orgs_ids_list[index]] = response.systems_data
        }
        ///</end> getting CSV Data of all attributes for all systems under all nested sub orgs. 
      }

      // We'll store filtered out data to this dictionary to pass to step2 function.
      var filtered_response_data = {};
      var offline_systems_data = {};

      /// Filtering response_data with filters from arguments CSV data from all response data.
      for (let org_key in response_data) {
        for (let sys_key in response_data[org_key]) {

          /// Separating out offline systems data
          if (sys_key.includes("-offline")) {
            let system_key = sys_key.replace("-offline", "");

            if (org_key in offline_systems_data === false) {
              offline_systems_data[org_key] = {};
            }
            
            offline_systems_data[org_key][system_key] = true;
            continue;
          }
          ///</end> Separating out offline systems data
          
          for (let obj_key in response_data[org_key][sys_key]) {
            for (let attr_key in response_data[org_key][sys_key][obj_key]) {
              for (let time in response_data[org_key][sys_key][obj_key][attr_key]) {
                let value = response_data[org_key][sys_key][obj_key][attr_key][time]

                let attr_name = attr_key;

                if (attr_key in CI.IV_object_attributes_meta_data === true && 'name' in CI.IV_object_attributes_meta_data[attr_key]) {
                  attr_name = CI.IV_object_attributes_meta_data[attr_key].name;

                  // if we get binary true as attribute name.
                  // it means we'll get this attribute's name from IV_default_obj_attribute_names
                  if (attr_name === true) {
                    let uid_num_part = attr_key.split("-")[1];
                    if (uid_num_part in CI.IV_default_obj_attribute_names === true && CI.IV_default_obj_attribute_names[uid_num_part] !== "") {
                      attr_name = CI.IV_default_obj_attribute_names[uid_num_part];
                    } else {
                      attr_name = attr_key;
                    }
                  }
                }

                //// Filtering attributes with names / values.
                if (filter_name_flag === true) {
                  let search_mode = filters["name"]["mode"];
                  if (search_mode === "equals") {
                    if (!attribute_names_to_filter.includes(attr_name.toLocaleLowerCase())) {
                      continue;
                    }
                  } else {
                    if (attribute_names_to_filter.find((str) => attr_name.toLocaleLowerCase().includes(str)) === undefined) {
                      continue;
                    }
                  }
                }
                if (filter_value_flag === true) {
                  let search_mode = filters["value"]["mode"];
                  let search_string = filters["value"]["search_text"].toLocaleLowerCase();
                  let attr_name_num_part = CI.bi7ExtractNumbers(value);

                  let lowercase_value = '';
                  if (value !== null && value !== undefined) {
                    lowercase_value = value.toString().toLocaleLowerCase();
                  }

                  if (search_mode === "contains") {
                    if (lowercase_value.indexOf(search_string) === -1) {
                      continue;
                    }
                  } else if (search_mode === "not_contains") {
                    if (lowercase_value.indexOf(search_string) !== -1) {
                      continue;
                    }
                  } else if (search_mode === "greater") {
                    if (!(attr_name_num_part > search_string_num_part)) {
                      continue;
                    }
                  } else if (search_mode === "less") {
                    if (!(attr_name_num_part < search_string_num_part)) {
                      continue;
                    }
                  } else if (search_mode === "equals") {
                    if (lowercase_value !== search_string) {
                      continue;
                    }
                  }
                }


                ////</end> Filtering attributes with names / values.

                /// Adding filtered attribute entries in filtered_response_data.
                /// And requesting necessory objects names
                if (org_key in filtered_response_data === false) {
                  filtered_response_data[org_key] = {};
                }
                if (sys_key in filtered_response_data[org_key] === false) {
                  filtered_response_data[org_key][sys_key] = {};
                }
                if (obj_key in filtered_response_data[org_key][sys_key] === false) {
                  filtered_response_data[org_key][sys_key][obj_key] = {};
                }
                if (attr_key in filtered_response_data[org_key][sys_key][obj_key] === false) {
                  filtered_response_data[org_key][sys_key][obj_key][attr_key] = {};
                }
                if (time in filtered_response_data[org_key][sys_key][obj_key][attr_key] === false) {
                  filtered_response_data[org_key][sys_key][obj_key][attr_key][time] = "";
                }

                filtered_response_data[org_key][sys_key][obj_key][attr_key][time] = value;

                if (obj_key in CI.IV_objects_meta_data === false) {

                  // To prevent fetching duplicate objects metadata
                  if (CI.IV_deletion_items_keys_after_csv.includes(obj_key) === false) {
                    CI.IV_deletion_items_keys_after_csv.push(obj_key);
                    
                    // we need latest value from backend
                    var timestamp = new Date().getTime() / 1000;
                    CI.bi7CreateMetaDataJsonRequest("obj_meta_data",obj_key, timestamp, false);
                  }
                }

                ///</end> Adding filtered attribute entries in filtered_response_data.
                ///</end> And requesting necessory objects names
              }
            }
          }
        }
      }
      ///</end> Filtering response_data with filters from arguments CSV data from all response data.
      filters["history_flag"] = history_flag;
      
      /*The delay here is added to wait until the bi7CreateDataStoreRequest process the requests
      Either by setting values from cache or by calling bi7ProcessMetaDataRequest function.
      wait for metadata requests are handeled in bi7GetAttributesCsvDataStep2 function*/
      setTimeout(function() {
        CI.bi7GetAttributesCsvDataStep2(filtered_response_data, org_uid, sys_uid, filters, offline_systems_data, include_uids_flag);
      }, 2000);
    }

    bi7GetAttributesCsvDataStep2(csv_data, base_org_uid, base_sys_uid, filters, offline_systems_data, include_uids_flag) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetAttributesCsvDataStep2 ";
      var task_id = "bi7_watchdog_firebase:bi7GetAttributesCsvDataStep2";
      var CI = this;

      //if we are still processsing requests to get object names, we don't want to run the step3 function yet
      if(CI.IV_meta_data_requests['obj_meta_data'] && Object.keys(CI.IV_meta_data_requests['obj_meta_data']).length > 0) {
        setTimeout(function() {
          CI.bi7GetAttributesCsvDataStep2(csv_data, base_org_uid, base_sys_uid, filters, offline_systems_data, include_uids_flag);
        }, 3000);
        return;
      }

      CI.bi7GetAttributesCsvDataStep3(csv_data, base_org_uid, base_sys_uid, filters, offline_systems_data, include_uids_flag);
    }

    bi7GetAttributesCsvDataStep3(csv_data, base_org_uid, base_sys_uid, filters, offline_systems_data, include_uids_flag) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetAttributesCsvDataStep3 ";
      var task_id = "bi7_watchdog_firebase:bi7GetAttributesCsvDataStep3";
      var CI = this;
      
      // when we don't want to include uids for orgs, systems, objects and attribute.
      var headRowItems = [
        "Organization Name", 
        "System Name", 
        "Object Name", 
        "Attribute Name", 
        "Date",
        "Time", 
        "Week Day",
        "UTC Timestamp",
        "Value"
      ]

      // when we want to include uids for orgs, systems, objects and attribute
      if (include_uids_flag) {
        headRowItems = [
          "Organization Name", 
          "Organization Uid Path", 
          "System Name", 
          "System Uid", 
          "Object Name", 
          "Object Uid", 
          "Attribute Name", 
          "Attribute Uid", 
          "Date",
          "Time", 
          "Week Day",
          "UTC Timestamp",
          "Value"
        ]
      }

      if (filters['include_reporting_link'] === true) {
        headRowItems.push("Reporting page URL")
      }

      const csvHeadRow = headRowItems.join(",");
      var csvContent = "";
      var offlineCSVContent = "";
      csvContent += csvHeadRow + "\r\n";

      if (window.G_dev_flag === 0) {
        var base_reporting_page_url = "https://watchdog.dgnet.cloud/dashboard/p2s1~c2m4~c6~c27~/"
      } else {
        var base_reporting_page_url = "https://dev-watchdog.dgnet.cloud/dashboard/p2s1~c2m4~c6~c27~/"
      }

      // using this flag to add reporting link for an attribute only once
      var add_reporting_link = true;

      //// Setting main CSV data here
      for (let org_key in csv_data) {
        for (let sys_key in csv_data[org_key]) {

          /// Skipping offline systems data from report.
          if (org_key in offline_systems_data === true) {
            if (sys_key in offline_systems_data[org_key] === true) {
              continue;
            }
          }
          /// </end> Skipping offline systems data from report.

          for (let obj_key in csv_data[org_key][sys_key]) {
            for (let attr_key in csv_data[org_key][sys_key][obj_key]) {

              // resetting this flag to add reporting link for next attribute only once
              add_reporting_link = true;

              for (let time in csv_data[org_key][sys_key][obj_key][attr_key]) {
                let value = csv_data[org_key][sys_key][obj_key][attr_key][time]

                //// creating org names path and org uids path for CSV column 
                let org_location = CI.IV_org_locations[org_key];
                let org_index = org_location.findIndex((org) => org === base_org_uid.replace("org_", ""));
                let sub_orgs_list = org_location.slice(org_index);
                sub_orgs_list = sub_orgs_list.map((id) => id = "org_"+id)

                let org_uid_path = sub_orgs_list.join(" > ")
                let org_name_path = sub_orgs_list.map((val) => {
                  if (val in CI.IV_org_meta_data === true && 'name' in CI.IV_org_meta_data[val]) {
                    return val = CI.IV_org_meta_data[val].name;
                  }
                  return val;
                }).join(" > ")
                ////</end> creating org names path and org uids path for CSV column

                //// Setting up names for org, system, object, attribute from metadata
                const moment_time = moment(+time),
                  formatted_date = moment_time.format("YYYY-MM-DD"),
                  formatted_time = moment_time.toDate().toTimeString().slice(0, 17);
                let sys_name = sys_key,
                  obj_name = obj_key,
                  attr_name = attr_key;
                const obj_sys_key = sys_key.replace("sys_", "obj_");
                if (obj_sys_key in CI.IV_objects_meta_data === true && 'name' in CI.IV_objects_meta_data[obj_sys_key]) {
                  sys_name = CI.IV_objects_meta_data[obj_sys_key].name;
                }
                if (obj_key in CI.IV_objects_meta_data === true && 'name' in CI.IV_objects_meta_data[obj_key]) {
                  obj_name = CI.IV_objects_meta_data[obj_key].name;
                }

                if (attr_key in CI.IV_object_attributes_meta_data === true && 'name' in CI.IV_object_attributes_meta_data[attr_key]) {
                  attr_name = CI.IV_object_attributes_meta_data[attr_key].name;

                  // it means we'll get this attribute's name from IV_default_attribute_names
                  if (attr_name === true) {
                    let uid_num_part = attr_key.split("-")[1];
                    if (uid_num_part in CI.IV_default_obj_attribute_names === true && CI.IV_default_obj_attribute_names[uid_num_part] !== "") {
                      attr_name = CI.IV_default_obj_attribute_names[uid_num_part];
                    } else {
                      attr_name = attr_key;
                    }
                  }
                }
                ////</end> Setting up names for org, system, object, attribute from metadata

                // Connected to watchdog attribute open directly under c2m4 instead of c6.
                var reporting_url = base_reporting_page_url;

                // add_reporting_link check to add link once per obj_atribute
                if (filters['include_reporting_link'] === true && add_reporting_link == true) {
                  if (attr_key.slice(-2) === "-8") {
                    reporting_url = base_reporting_page_url.replace("c6~", "")
                  }

                  reporting_url = `${reporting_url}org/${org_key}/sys/${sys_key}/obj/${obj_key}/obj_atr/${attr_key}`;

                  if (filters["history_flag"] === true && Array.isArray(filters["reporting_url_params"]) && filters["reporting_url_params"].length === 2) {
                    if (filters["reporting_url_params"][0] === "start") {

                      let earliest_time = CI.IV_earliest_date_for_object_attribute_history[attr_key];
                      if (earliest_time) {
                        reporting_url += `?range_start=${earliest_time}&range_end=${filters["reporting_url_params"][1]}`
                      }
                    } else {
                      reporting_url += `?range_start=${filters["reporting_url_params"][0]}&range_end=${filters["reporting_url_params"][1]}`
                    }
                  }

                  // Added reporting url for this attribute, now this flag will be true for next object attribute
                  add_reporting_link = false;
                } else {
                  reporting_url = "";
                }

                //when we do not want to include uids for org sys obj attribute
                var row = [
                  org_name_path.replace(/,/g, " |"),
                  sys_name.replace(/,/g, " |"),
                  obj_name.replace(/,/g, " |"),
                  attr_name.replace(/,/g, " |"), 
                  formatted_date, formatted_time,
                  moment_time.format("dddd"),
                  time, value.replace(/\r?\n|\r|\n/g, " ").replace(/,/g, " |")
                ]

                //when we want to include uids for org sys obj attribute
                if (include_uids_flag) {
                  row = [
                    org_name_path.replace(/,/g, " |"), org_uid_path,
                    sys_name.replace(/,/g, " |"), sys_key,
                    obj_name.replace(/,/g, " |"), obj_key,
                    attr_name.replace(/,/g, " |"), attr_key,
                    formatted_date, formatted_time,
                    moment_time.format("dddd"),
                    time, value.replace(/\r?\n|\r|\n/g, " ").replace(/,/g, " |")
                  ]
                }

                if (filters['include_reporting_link'] === true) {
                  row.push(reporting_url)
                } 

                csvContent += row + "\r\n";
              }
            }
          }
        }
      }
      ////</end> Setting main CSV data here


      let download_offline_csv_flag = Object.keys(offline_systems_data).length > 0;
      
      //// Setting offline systems CSV data here
      if (download_offline_csv_flag === true) {

        //when we do not want to include uids for org sys obj attribute
        var offline_csv_head_row = [
          "Organization Name", 
          "System Name", 
        ];

        //when we want to include uids for org sys obj attribute
        if (include_uids_flag) {
          var offline_csv_head_row = [
            "Organization Name", 
            "Organization Uid Path", 
            "System Name", 
            "System Uid"
          ];
        }

        offlineCSVContent += offline_csv_head_row + "\r\n";

        for (let org_key in offline_systems_data) {
          for (let sys_key in offline_systems_data[org_key]) {

            //// creating org names path and org uids path for CSV column 
            let org_location = CI.IV_org_locations[org_key];
            let org_index = org_location.findIndex((org) => org === base_org_uid.replace("org_", ""));
            let sub_orgs_list = org_location.slice(org_index);
            sub_orgs_list = sub_orgs_list.map((id) => id = "org_"+id)

            let org_uid_path = sub_orgs_list.join(" > ")
            let org_name_path = sub_orgs_list.map((val) => {
              if (val in CI.IV_org_meta_data === true && 'name' in CI.IV_org_meta_data[val]) {
                return val = CI.IV_org_meta_data[val].name;
              }
              return val;
            }).join(" > ")
            ////</end> creating org names path and org uids path for CSV column

            let sys_name = sys_key;
            var obj_sys_key = sys_key.replace("sys_", "obj_");
            if (obj_sys_key in CI.IV_objects_meta_data === true && 'name' in CI.IV_objects_meta_data[obj_sys_key]) {
              sys_name = CI.IV_objects_meta_data[obj_sys_key].name;
            }

            //when we do not want to include uids for org sys obj attribute
            var data_row = [
              org_name_path.replace(/,/g, " |"), 
              sys_name.replace(/,/g, " |"), 
            ]

            //when we want to include uids for org sys obj attribute
            if (include_uids_flag) {
              var data_row = [
                org_name_path.replace(/,/g, " |"), 
                org_uid_path, 
                sys_name.replace(/,/g, " |"), 
                sys_key 
              ]
            }

            offlineCSVContent += data_row + "\r\n";
          }
        }
        ////</end> Setting offline systems CSV data here
      }

      /// Clearing the boolean value metadata for this attribute
      for (let attr_uid in CI.IV_object_attributes_meta_data) {
        if ('name' in CI.IV_object_attributes_meta_data[attr_uid] && CI.IV_object_attributes_meta_data[attr_uid].name === true) {
          Vue.delete(CI.IV_object_attributes_meta_data, attr_uid);
        }
      }
      ///</end> Clearing the boolean value metadata for this attribute

      /// Clearing the object attribute's metadata from keys IV_deletion_items_keys_after_csv
      for (let index in CI.IV_deletion_items_keys_after_csv) {
        let id = CI.IV_deletion_items_keys_after_csv[index];

        if (id.indexOf("obj_atr_") === 0) {
          Vue.delete(CI.IV_object_attributes_meta_data, id);
        } else if (id.indexOf("obj_") === 0) {
          Vue.delete(CI.IV_objects_meta_data, id);
        }
      }
      CI.IV_deletion_items_keys_after_csv = [];
      ///</end> Clearing the object attribute's metadata from keys IV_deletion_items_keys_after_csv

      /// Preparing CSVs data to download
      const blob = new Blob([ csvContent ], {
        type : "application/csv;charset=utf-8;"
      });

      const time_now = moment().format("YYYY_MM_DD_hh_mm_ss");
      let file_name =`Reporting CSV (${CI.IV_org_meta_data[base_org_uid].name}) ${time_now}.csv`;
      let sys_name = ""
      
      // Setting system's name if we get the system uid
      if (base_sys_uid !== null && base_sys_uid !== undefined) {
        sys_name = CI.IV_objects_meta_data[base_sys_uid.replace("sys_", "obj_")].name;

        if (sys_name === null || sys_name === undefined) {
          sys_name = base_sys_uid;
        }
      }
      //</end> Setting system's name if we get the system uid

      if (base_sys_uid !== null && base_sys_uid !== undefined) {
        file_name =  `Reporting CSV (${CI.IV_org_meta_data[base_org_uid].name} | ${sys_name}) ${time_now}.csv`;
      }

      if (window.navigator.msSaveBlob) {
        // FOR IE BROWSER
        navigator.msSaveBlob(blob, file_name);
      } else {
        // FOR OTHER BROWSERS
        let link = document.createElement("a");
        let csvUrl = URL.createObjectURL(blob);
        link.href = csvUrl;
        link.style = "visibility:hidden";
        link.download = file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      let file_name_offline = `Offline Systems (${CI.IV_org_meta_data[base_org_uid].name}) ${time_now}.csv`;

      if (base_sys_uid !== null && base_sys_uid !== undefined) {
        file_name_offline =  `Offline Systems (${CI.IV_org_meta_data[base_org_uid].name} | ${sys_name}) ${time_now}.csv`;
      }

      if (download_offline_csv_flag === true) {
        var offline_data_blob = new Blob([ offlineCSVContent ], {
          type : "application/csv;charset=utf-8;"
        });
        
        if (window.navigator.msSaveBlob) {
          // FOR IE BROWSER
          navigator.msSaveBlob(offline_data_blob, file_name_offline);
        } else {
          // FOR OTHER BROWSERS
          let link = document.createElement("a");
          let csvUrl = URL.createObjectURL(offline_data_blob);
          link.href = csvUrl;
          link.style = "visibility:hidden";
          link.download = file_name_offline;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      // Resetting loading to false after starting data downloading
      Vue.set(CI.IV_component_loading_states, 'c2m9_c2m10_OrgReporting', false)

      //</end> Preparing CSV data to download
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };

    }

    //// function for extracting numbers from string if there are any.
    bi7ExtractNumbers(string_value) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7ExtractNumbers ";
      var task_id = "bi7_watchdog_firebase:bi7ExtractNumbers";
      let point = -1, extract = ''

      //// input validation 
      call_result = bi1_data_validation.is_string(string_value);
      debug_data.push(call_result);
      
      if (call_result[CR.success] !== RC.success) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ////</end> input validation


      const nums = '1234567890'.split('')
      let s = string_value;
      for (let i = 0; i < s.length; i++) {
        if (nums.indexOf(s[i]) !== -1) {
          extract += s[i]
        } else if (
          s[i] === '.' &&
          point === -1 &&
          i < s.length - 1 &&
          nums.indexOf(s[i - 1]) !== -1 &&
          nums.indexOf(s[i + 1]) !== -1
        ) {
          point = i
          extract += s[i]
        }
      }
      if (extract.length === 0) return NaN
      return parseFloat(extract)
    }
    
    bi7GetSystemsDataUnderOrg(org_uid, time_range, history_flag=true, current_flag=false) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetSystemsDataUnderOrg ";
      var task_id = "bi7_watchdog_firebase:bi7GetSystemsDataUnderOrg";
      var CI = this;
      var systems_data = {};

      for (var system_uid in CI.IV_org_system_joins[org_uid]) {
        if (system_uid === "last_updated") {
          continue;
        }
        var response = CI.bi7GetObjectsDataUnderSystem(system_uid, time_range, history_flag, current_flag)
        systems_data[system_uid] = response.objects_data

        /// In history report case: Setting system as offline if no value found in history
        if (history_flag === true && Object.keys(response.objects_data).length === 0) {
          systems_data[`${system_uid}-offline`] = true
        }
        ///</end> In history report case: Setting system as offline if no value found in history

        /// In current value report case: Setting system as offline if system's current status is offline
        let system_online_uid = system_uid.replace("sys_", "obj_atr_") + "-8";
        let is_system_offline = "unknown"

        if (system_online_uid in CI.IV_object_attribute_values === true) {

          let value = CI.IV_object_attribute_values[system_online_uid]['value'];

          if (value !== undefined && value !== null) {
            is_system_offline = value.toLowerCase().includes("offline");
          }
        }

        if (current_flag === true && is_system_offline === true) {
          systems_data[`${system_uid}-offline`] = true
        }
        ///</end> In current value report case: Setting system as offline if system's current status is offline
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data, 'systems_data': systems_data };
    }

    bi7GetObjectsDataUnderSystem(sys_uid, time_range, history_flag=true, current_flag=false) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetObjectsDataUnderSystem ";
      var task_id = "bi7_watchdog_firebase:bi7GetObjectsDataUnderSystem";
      var CI = this;
      var objects_data = {};

      if (sys_uid in CI.IV_system_object_joins === true) {
        for(var object_uid in CI.IV_system_object_joins[sys_uid]) {
          var response = CI.bi7GetObjectAttributesDataUnderObject(object_uid, time_range, history_flag, current_flag)
          var objects_with_data = _.filter(response.attributes_data, (attr) => Object.keys(attr).length > 0);
          if (objects_with_data.length > 0) {
            objects_data[object_uid] = response.attributes_data
          }
        }
      }

      // getting history records for connected to watchdog values.
      
      if (sys_uid !== "last_updated" && sys_uid !== 'deletion_prevention_key') {
        var connected_to_watchdog_uid = sys_uid.replace("sys_", "obj_atr_") + "-8";
        var object_uid = sys_uid.replace("sys_", "obj_");

        if (history_flag === true) {
          var response = CI.bi7GetAttributeHistoryValues(connected_to_watchdog_uid, time_range)

          if (Object.keys(response.attributes_value_data).length > 0) {
            if (object_uid in objects_data === false) {
              objects_data[object_uid] = {};
            }
            objects_data[object_uid][connected_to_watchdog_uid] = response.attributes_value_data
          }

        } else if (current_flag === true ) {
          var response = CI.bi7GetAttributeCurrentValue(connected_to_watchdog_uid);
  
          if (object_uid in objects_data === false) {
            objects_data[object_uid] = {};
          }
  
          objects_data[object_uid][connected_to_watchdog_uid] = response.attributes_value_data
        }
      }
      //</end getting history records for connected to watchdog values.

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data, 'objects_data': objects_data };
    }

    bi7GetObjectAttributesDataUnderObject(obj_uid, time_range, history_flag=true, current_flag=false) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetObjectAttributesDataUnderObject ";
      var task_id = "bi7_watchdog_firebase:bi7GetObjectAttributesDataUnderObject";
      var CI = this;
      var attributes_data = {};

      if (obj_uid in CI.IV_object_attribute_joins === true) {
        for(var attribute_uid in CI.IV_object_attribute_joins[obj_uid]) {
          if (history_flag === true) {
            var response = CI.bi7GetAttributeHistoryValues(attribute_uid, time_range);
          } else {
            var response = CI.bi7GetAttributeCurrentValue(attribute_uid);
          }
          attributes_data[attribute_uid] = response.attributes_value_data
        }
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data, 'attributes_data': attributes_data };
    }

    bi7GetAttributeHistoryValues(attr_uid, time_range) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetAttributeHistoryValues ";
      var task_id = "bi7_watchdog_firebase:bi7GetAttributeHistoryValues";
      var CI = this;
      var attributes_value_data = {};

      // getting history records for attribute_uid in parameter
      if (attr_uid in CI.IV_object_attribute_history_values === true) {
        for(var index in CI.IV_object_attribute_history_values[attr_uid]) {
          let time = CI.IV_object_attribute_history_values[attr_uid][index].date;
          let value = CI.IV_object_attribute_history_values[attr_uid][index].value;

          if (time > time_range[0] && time < time_range[1]) {
            attributes_value_data[time] = value;

            // To get earliest time for 
            if (attr_uid in CI.IV_earliest_date_for_object_attribute_history === false ||
                CI.IV_earliest_date_for_object_attribute_history[attr_uid] < time) {
              CI.IV_earliest_date_for_object_attribute_history[attr_uid] = time;
            }
          }
        }
      }
      //</end> getting history records for attribute_uid in parameter

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data, 'attributes_value_data': attributes_value_data };
    }

    bi7GetAttributeCurrentValue(attr_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7GetAttributeHistoryValues ";
      var task_id = "bi7_watchdog_firebase:bi7GetAttributeHistoryValues";
      var CI = this;
      var attributes_value_data = {};

      // getting current value records for attribute_uid in parameter
      if (attr_uid in CI.IV_object_attribute_values === true) {

        let time = CI.IV_object_attribute_values[attr_uid]['last_updated'];
        let value = CI.IV_object_attribute_values[attr_uid]['value'];

        if (time !== undefined && time !== null && value !== undefined && value !== null) {
          attributes_value_data[time] = value;
        }
      }
      //</end> getting current records for attribute_uid in parameter

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data, 'attributes_value_data': attributes_value_data };
    }

    bi7InitRxTxLoggingListener(object_uid) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7InitRxTxLoggingListener ";
        var task_id = "bi7_watchdog_firebase:bi7InitRxTxLoggingListener";

        var CI = this;
        //// input validation 
        call_result = bi1_data_validation.is_object_uid(object_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ////</end> input validation

        var object_rxtx_key_id = `history_obj_txrx_${object_uid.replace("obj_", "")}`;
        var listener_location = `history_obj_txrx/${object_rxtx_key_id}/`;
        CI.IV_listener_rx_tx_logging[object_uid] = CI.IV_firebase_db_object.ref(listener_location);

        ///// removing invalid firebase listener key
        call_result = CI.validateFirebaseListener(CI.IV_listener_rx_tx_logging[object_uid]);
        debug_data.push(call_result)
        if (call_result[CR.success] !== RC.success) {
          delete CI.IV_listener_rx_tx_logging[object_uid];
          return_msg += "failed to create listener for " + listener_location;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///// </end> removing invalid firebase listener key

        CI.IV_listener_rx_tx_logging[object_uid].on("value",
            function (a_data) { CI.rxTxLoggingListener(object_uid, a_data) }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(CI));
    }

    rxTxLoggingListener(object_uid, data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:rxTxLoggingListener ";
        var task_id = "bi7_watchdog_firebase:rxTxLoggingListener";
        var CI = this;

        ////// input validation 
        call_result = bi1_data_validation.is_object_uid(object_uid);
        debug_data.push(call_result);
        if (call_result[CR.success] !== RC.success) {
            return_msg += "input validation failed";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
        }
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }

        /// create the flag to track the newest value we have already read
        if (object_uid in CI.IV_rx_tx_last_time === false) {
            CI.IV_rx_tx_last_time[object_uid] = 0;
        }

        //////</end> input validation 
        var firebase_data = data.val();
        for(var year in firebase_data) {
            for(var month in firebase_data[year]) {
                for(var day in firebase_data[year][month]) {
                    for(var timestamp in firebase_data[year][month][day]) {
                        var vue_timestamp = 0;

                        try {
                            vue_timestamp  = timestamp * 1000;
                        } catch (error) {
                            continue;
                        }

                        //this prevents adding the same data twice since
                        if(vue_timestamp <= CI.IV_rx_tx_last_time[object_uid]) {
                            continue;
                        } else {                        
                            CI.IV_rx_tx_last_time[object_uid] = vue_timestamp;
                        }

                        var entry_object = {RxData: [], TxData: [], date: 0};                        
                        
                        // raw_string format 
                        // "<||:RX~>2017/7/17/3-05-37>asdf1<||:TX~>2017/7/17/3-05-37>fdsa1"
                        var raw_string = firebase_data[year][month][day][timestamp]
                        
                        //some systems send the data as "<||:RX~>2017/7/17/3-05-37>", others as "<||:RX~>/2017/7/17/3-05-37>"
                        raw_string = raw_string.replace(/<\|\|:TX~>\//g,"<||:TX~>")
                        raw_string = raw_string.replace(/<\|\|:RX~>\//g,"<||:RX~>")
                        var splited_values = raw_string.split("<||:")
                        
                        // rempving first part will be ""
                        if (splited_values[0] === "") {splited_values.shift()}

                        entry_object.date = vue_timestamp;

                        // Parsing all possible entries for Rx and Tx values in single firebase location.
                        for (var index in splited_values) {
                          var value = splited_values[index];

                          if (value.includes("RX~>")) {
                            value = value.replace("RX~>", "").split(">");

                            let data_hash = {
                              // bi6BeautifyRxTxDateTime (cpu time, entry time)
                              // entry time will be used to get offset 
                              date: bi6_misc.bi6BeautifyRxTxDateTime(value[0], vue_timestamp),
                              value: value[1]
                            }

                            entry_object.RxData.push(data_hash);

                          } else if (value.includes("TX~>")) {
                            value = value.replace("TX~>", "").split(">");

                            let data_hash = {
                              // bi6BeautifyRxTxDateTime (cpu time, entry time)
                              // entry time will be used to get offset 
                              date: bi6_misc.bi6BeautifyRxTxDateTime(value[0], vue_timestamp),
                              value: value[1]
                            }

                            entry_object.TxData.push(data_hash);
                          }
                        }
                        //</end> Parsing all possible entries for Rx and Tx values in single firebase location.

                        if(object_uid in CI.IV_rx_tx_log_data === false) {
                            Vue.set(CI.IV_rx_tx_log_data,object_uid,{})
                        }
                        if (year in CI.IV_rx_tx_log_data[object_uid] === false) {
                            Vue.set(CI.IV_rx_tx_log_data[object_uid],year,{});
                        }
                        if (month in CI.IV_rx_tx_log_data[object_uid][year] === false) {
                            Vue.set(CI.IV_rx_tx_log_data[object_uid][year],month,{});
                        }
                        if (day in CI.IV_rx_tx_log_data[object_uid][year][month] === false) {
                            Vue.set(CI.IV_rx_tx_log_data[object_uid][year][month],day,[]);
                        }

                        CI.IV_rx_tx_log_data[object_uid][year][month][day].push(entry_object);
                    }
                }
            }
        }
    }

    bi7initGlobalRenamedObjectAttributesListener() {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:bi7initGlobalRenamedObjectAttributesListener ";
        var task_id = "bi7_watchdog_firebase:bi7initGlobalRenamedObjectAttributesListener";
        var CI = this;

        // We'll wait the firebase to connect before trying to start listener.
        if(CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
            setTimeout(CI.bi7initGlobalRenamedObjectAttributesListener.bind(CI),500);
            return;
        }

        var listener_location = 'renamed_obj_atrs';

        CI.IV_global_listener_renamed_obj_attributes = CI.IV_firebase_db_object.ref(listener_location);

        CI.IV_global_listener_renamed_obj_attributes.on("value",
            function (a_data) {
                CI.GlobalRenamedObjecAttributesListener(a_data);              
            }.bind(CI),
            function (errorObject) {
                return_msg += "firebase read failed with error data:" + errorObject;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
            }.bind(this)
        );
    }

    GlobalRenamedObjecAttributesListener(data) {
        var debug_data = [];
        var call_result = {};
        var return_msg = "bi7_watchdog_firebase:GlobalRenamedObjecAttributesListener ";
        var task_id = "bi7_watchdog_firebase:GlobalRenamedObjecAttributesListener";
        var CI = this;

        /// input validation
        if (data === null) {
            return_msg += "data argument is null";
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
            return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
        }
        ///</end> input validation

        var firebase_data = data.val();

        for (var obj_attribute_uid in firebase_data) {
            //set the last updated timestamp for the permissions
            if (obj_attribute_uid === "last_updated" || obj_attribute_uid === 'deletion_prevention_key') {
                continue;
            }

            if (obj_attribute_uid in CI.IV_renamed_obj_attributes_uids === false) {
                let fixed_atr_uid = obj_attribute_uid.replace("attr", "atr");

                // We'll just store boolean value here because we can get the uid from key.
                CI.IV_renamed_obj_attributes_uids[fixed_atr_uid] = true;
            }
        }
    }

    bi7FetchAllAttributes(org_uid, filters) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7FetchAllAttributes ";
      var task_id = "bi7_watchdog_firebase:bi7FetchAllAttributes";
      var CI = this;
      var filtered_systems_object_uids = [];
      var system_online_indicator_attribute_uids = [];

      ////// input validation 
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);
      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
      }
      if (filters === null || filters === undefined) {
        return_msg += "input validation failed, filtters not set. ";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': CR.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      // Setting the loading flag to true
      Vue.set(CI.IV_component_loading_states, 'c2m3_mass_apply_rules', true);

      // Resetting the count for subsequent call without page reload
      Vue.set(CI.IV_progress_counts_for_bulk_rule_application, 'organizations', 0)
      Vue.set(CI.IV_progress_counts_for_bulk_rule_application, 'systems', 0)
      Vue.set(CI.IV_progress_counts_for_bulk_rule_application, 'objects', 0)
      Vue.set(CI.IV_progress_counts_for_bulk_rule_application, 'attributes', 0)

      // Array to save promises for system object and attribute join listener callbacks.
      var sys_obj_and_attribute_joins_promises = []

      // making callback function for firebase failure
      var firebase_failure = function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
      }.bind(this)

      /// callback functions to start listeners and push promises to promises array
      var init_system_objects_and_attributes_join_listeners = function (uid) {
        var listener_location = 'systems/' + uid;
        var listener_ref = CI.IV_firebase_db_object.ref(listener_location);

        return listener_ref.once("value").then(
          function (a_data) {
            return [a_data.val(), uid];
          }.bind(CI),
          firebase_failure
        )
      }

      /// Collecting the org uids of all nested child orgs
      var sub_orgs_ids_list = [];
      var search_string = org_uid + "org_";
      sub_orgs_ids_list.push(org_uid);

      for (var key in CI.IV_org_location_strings) {
        if (CI.IV_org_location_strings[key].indexOf(search_string) >= 0) {
          sub_orgs_ids_list.push(key);
        }
      }
      ///</end> Collecting the org uids of all nested child orgs

      // Loop through all organization to get filtered data
      for (let index in sub_orgs_ids_list) {
        const org_uid = sub_orgs_ids_list[index];

        // Increase the count of organization to show on loading text.
        let org_count = CI.IV_progress_counts_for_bulk_rule_application.organizations + 1;
        Vue.set(CI.IV_progress_counts_for_bulk_rule_application, 'organizations', org_count);

        // Filter out the organizations, which are not matching, if filters.organization.text available.
        if (filters.organization.text != "") {

          if (org_uid in CI.IV_org_meta_data === false) {continue;}
          if (CI.IV_org_meta_data[org_uid].name == undefined) {continue;}
          
          const org_name = CI.IV_org_meta_data[org_uid].name.toLocaleLowerCase();
          const org_filter_text = filters.organization.text.toLocaleLowerCase();

          if (filters.organization.key == 'equals' && org_name != org_filter_text) {
            continue;
          } else if (filters.organization.key == 'contains' && !org_name.includes(org_filter_text)) {
            continue;
          } 
        }

        /// getting systems of all nested and child orgs, so that if a parent org match the name filter 
        let all_child_systems = []
        if (org_uid in CI.IV_org_system_joins === true) {
          all_child_systems = Object.keys(CI.IV_org_system_joins[org_uid])
        }

        // Only filter from all child orgs if organization.text filter is set.
        if (filters.organization.text != "") {
          for (var key in CI.IV_org_location_strings) {
            if (CI.IV_org_location_strings[key].indexOf(org_uid + "org_") >= 0) {
              if (key in CI.IV_org_system_joins === true) {
                all_child_systems = _.uniq(all_child_systems.concat(Object.keys(CI.IV_org_system_joins[key])))
              }
            }
          }
        }
        ///</end> getting systems of all nested and child orgs

        for (var system_id of all_child_systems) {
          if (system_id === "last_updated" || system_id === 'deletion_prevention_key') { continue; }

          // Increase the count of system to show on loading text.
          let sys_count = CI.IV_progress_counts_for_bulk_rule_application.systems + 1;
          Vue.set(CI.IV_progress_counts_for_bulk_rule_application, 'systems', sys_count);

          // Filter out the systems, which are not matching, if filters.systems.text available.
          if (filters.system.text != "") {
            let sys_obj_uid = system_id.replace('sys_','obj_');

            if (CI.IV_objects_meta_data[sys_obj_uid] == undefined) { continue; }
            if (CI.IV_objects_meta_data[sys_obj_uid].name == undefined) { continue; }

            const sys_name = CI.IV_objects_meta_data[sys_obj_uid].name.toLocaleLowerCase();
            const sys_filter_text = filters.system.text.toLocaleLowerCase();

            if (filters.system.key == 'equals' && sys_name != sys_filter_text) {
              continue;
            } else if (filters.system.key == 'contains' && !sys_name.includes(sys_filter_text)) {
              continue;
            } 
          }

          // Start listener for getting system's object and attribute joins
          CI.IV_system_object_joins[system_id] = {};
          sys_obj_and_attribute_joins_promises.push(init_system_objects_and_attributes_join_listeners(system_id))

          // calling attribute histery listener for connected to watchdog for this system
          var connected_to_watchdog_uid = system_id.replace("sys_", "obj_atr_") + "-8"
          system_online_indicator_attribute_uids.push(connected_to_watchdog_uid)
          
          if (connected_to_watchdog_uid in CI.IV_object_attributes_meta_data == false) {
            // we'll use this function here to reuse the code about fetching only attribute names which are renamed
            CI.bi7CreateDataStoreRequest('obj_atr_meta_data', connected_to_watchdog_uid);
          }
        }
      }

      Promise.all(sys_obj_and_attribute_joins_promises).then((values) => {
        for (let index in values) {
          var system_data = values[index];

          //// data validation
          if (Array.isArray(system_data) === false || system_data.length < 2
          || system_data[0] === undefined || system_data[1] === undefined
           || system_data[0] === null || system_data[1] === null) {
             continue;
           }
           ////</end> data validation

          var system_uid = system_data[1];
          var system_object_uids = system_data[0]['object_uids'];
          var system_attribute_uids = system_data[0]['object_attributes'];

          //// Setting system object joins 
          if (system_object_uids !== null && system_object_uids !== undefined) {
            for (let obj_key in system_object_uids) {

              // Skip deleted systems
              if (system_object_uids[obj_key][0] === 'd') {
                continue;
              }

              //ignore last updated entries, the system is technically an object but we don't list it with the objects under the system
              if (obj_key === "last_updated" || 
                  obj_key === 'deletion_prevention_key' ||
                  obj_key === system_uid.replace('sys_','obj_')
              ) {
                continue;
              }

              if (obj_key in CI.IV_object_attribute_joins == false) {
                CI.IV_object_attribute_joins[obj_key] = {};
              }
              
              if (obj_key in CI.IV_system_object_joins[system_uid] === false || CI.IV_system_object_joins[system_uid][obj_key] !== obj_key) {
                CI.IV_system_object_joins[system_uid][obj_key] = obj_key;
                CI.IV_system_object_joins_reverse_lookup[obj_key] = system_uid;
              }

              // Increase the count of objects to show on loading text.
              let obj_count = CI.IV_progress_counts_for_bulk_rule_application.objects + 1;
              Vue.set(CI.IV_progress_counts_for_bulk_rule_application, 'objects', obj_count);

              filtered_systems_object_uids.push(obj_key);
              if (obj_key in CI.IV_objects_meta_data == false) {
                var timestamp = new Date().getTime() / 1000;
                CI.bi7CreateMetaDataJsonRequest("obj_meta_data", obj_key, timestamp, false);
              } 
            }
          }
          ////</end> Setting system object joins 

          //// Setting system object_attribute joins 
          if (system_attribute_uids !== null && system_attribute_uids !== undefined) {
            for (let attr_key in system_attribute_uids) {

              //ignore last updated entries
              if (attr_key === "last_updated" || attr_key === 'deletion_prevention_key') {
                continue;
              }

              var attribute_object_uid = "";
              try {
                attribute_object_uid = `obj_${CI.bi7ExtractNumbers(attr_key.split("-")[0])}`;
              } catch(error) {
                return_msg += "failed to JSON parse firebase data with error:" + error;
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
                continue;
              }

              // checking if the attribute belongs to any object under this system
              if (attribute_object_uid in CI.IV_object_attribute_joins === false) {
                continue;
              }
              //</end> checking if the attribute belongs to any object under this system

              if (attr_key in CI.IV_object_attribute_joins[attribute_object_uid] === false) {
                CI.IV_object_attribute_joins[attribute_object_uid][attr_key] = attr_key;
                CI.IV_object_attribute_joins_reverse_lookup[attr_key] = attribute_object_uid;
              }
            }
          }
          ////</end> Setting system object_attribute joins           
        }

        setTimeout(function() {
          CI.bi7FetchAllAttributesStep2(filters, filtered_systems_object_uids, system_online_indicator_attribute_uids);
        }, 1000);
      })
    }

    bi7InitMassAppliedRulesHistoryListener() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitMassAppliedRulesHistoryListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitMassAppliedRulesHistoryListener";
      var CI = this;

      var listen_folder = CI.IV_user_folder_path + '/mass_applied_rules_history/';

      // we already have listener for this location
      if (CI.IV_listener_mass_applied_rules_history != null) {
        return;
      }

      CI.IV_listener_mass_applied_rules_history = CI.IV_firebase_db_object.ref(listen_folder);

      var init_listener_callback = function() {
        CI.IV_listener_mass_applied_rules_history.on("value",
          function (b_data) { CI.MassAppliedRulesHistoryListener(b_data) }.bind(CI),
          function (error) {
            return_msg += "firebase read failed with error data:" + error;
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
          }.bind(this)
        );
      }

      CI.bi7CreateUserFolderIfNotExists(listen_folder,init_listener_callback);
    }

    MassAppliedRulesHistoryListener(data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:MassAppliedRulesHistoryListener ";
      var task_id = "bi7_watchdog_firebase:MassAppliedRulesHistoryListener";
      var CI = this;

      ///// input validation
      if (data == null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      /////</end> input validation

      var firebase_data = data.val()

      for (let rule_uid in firebase_data) {
        if (rule_uid == "deletion_prevention_key") {continue};

        if (rule_uid in CI.IV_mass_applied_rules_history == false) {
          Vue.set(CI.IV_mass_applied_rules_history, rule_uid, {});
        }

        for (let attribute_uid in firebase_data[rule_uid]) {
          if (attribute_uid == "deletion_prevention_key") {continue};
          Vue.set(CI.IV_mass_applied_rules_history[rule_uid], attribute_uid, true);
        }
      }
    }

    bi7DeleteMassAppliedRuleHistory(rule_uid, attribute_uids) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7WriteMassAppliedRuleHistory ";
      var task_id = "bi7_watchdog_firebase:bi7WriteMassAppliedRuleHistory";
      var CI = this;

      ///// input validation
      call_result = bi1_data_validation.is_string(rule_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_array(attribute_uids, 1);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] != RC.success) {
          validation_failed = true;
        }
      }
      
      if(validation_failed == true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return;
      }
      /////</end> input validation

      /// Removing all attribute uids from history
      var folder = CI.IV_user_folder_path + '/mass_applied_rules_history/' + rule_uid;
      for (let index in attribute_uids) {
        let atr_uid = attribute_uids[index]
        CI.bi7DeleteFirebaseLocation(`${folder}/${atr_uid}`);
      }
      ///</end> Removing all attribute uids from history

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7WriteMassAppliedRuleHistory(rule_uid, attribute_uids) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7WriteMassAppliedRuleHistory ";
      var task_id = "bi7_watchdog_firebase:bi7WriteMassAppliedRuleHistory";
      var CI = this;

      ///// input validation
      call_result = bi1_data_validation.is_string(rule_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_array(attribute_uids, 1);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] != RC.success) {
          validation_failed = true;
        }
      }
      if(validation_failed == true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return;
      }
      /////</end> input validation

      var folder = CI.IV_user_folder_path + '/mass_applied_rules_history/' + rule_uid;
      var updates = {};

      for (let index in attribute_uids) {
        let atr_uid = attribute_uids[index]
        updates[`${folder}/${atr_uid}`] = true;
      }
      
      /// writing data in user's mass_applied_rules_history history folder
      CI.IV_firebase_db_object.ref().update(updates, function(error) {
        if (error) {
          return_msg += "firebase write failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        } else {
          return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }
      });

      ///</end> writing data in user's mass_applied_rules_history history folder
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7FetchAllAttributesStep2(filters, filtered_systems_object_uids, system_online_indicator_uids) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7FetchAllAttributesStep2 ";
      var task_id = "bi7_watchdog_firebase:bi7FetchAllAttributesStep2";
      var CI = this;

      // check if filtered systems and objects uids array is empty 
      if (filtered_systems_object_uids.length < 1) {
        Vue.set(CI.IV_filtered_attributes_list, 'filtered_attributes', []);
        Vue.set(CI.IV_component_loading_states, 'c2m3_mass_apply_rules', false)
        return;
      }

      // Waiting for all needed objects to complete fetching metadata
      if (Object.keys(CI.IV_meta_data_requests['obj_meta_data']).length > 0) {
        setTimeout(function() {
          CI.bi7FetchAllAttributesStep2(filters, filtered_systems_object_uids, system_online_indicator_uids);
        }, 3000);
        return;
      }

      var filtered_objects_attribute_uids = [...system_online_indicator_uids];

      for (var object_uid of filtered_systems_object_uids) {
        let obj_meta_data = CI.IV_objects_meta_data[object_uid];

        // Filtering objects with matching names if name filter present
        if (filters.object_name.text != "") {
        
          if (obj_meta_data == null || obj_meta_data == undefined) { continue; }
          if (obj_meta_data.name == undefined) { continue; }
          const obj_filter_text = filters.object_name.text.toLocaleLowerCase();

          if (filters.object_name.key == 'equals' && obj_meta_data.name.toLocaleLowerCase() != obj_filter_text) {
            continue;
          } else if (filters.object_name.key == 'contains' && !obj_meta_data.name.toLocaleLowerCase().includes(obj_filter_text)) {
            continue;
          } 
        }

        // Filtering objects with matching descriptions if description filter present
        if (filters.object_desc.text != "") {

          if (obj_meta_data == undefined) { continue; }
          if (obj_meta_data.description == undefined) { continue; }
          const obj_desc_filter_text = filters.object_desc.text.toLocaleLowerCase();

          if (filters.object_desc.key == 'equals' && obj_meta_data.description.toLocaleLowerCase() != obj_desc_filter_text) {
            continue;
          } else if (filters.object_desc.key == 'contains' && !obj_meta_data.description.toLocaleLowerCase().includes(obj_desc_filter_text)) {
            continue;
          } 
        }

        if (object_uid in CI.IV_object_attribute_joins === true) {
      
          let object_attributs = CI.IV_object_attribute_joins[object_uid];

          for (let attr_uid in object_attributs) {
            if (attr_uid === "last_updated" || attr_uid === 'deletion_prevention_key') {
              continue;
            }
            
            // Increase the count of attributes to show on loading text.
            let attriubte_count = CI.IV_progress_counts_for_bulk_rule_application.attributes + 1;
            Vue.set(CI.IV_progress_counts_for_bulk_rule_application, 'attributes', attriubte_count);
            
            filtered_objects_attribute_uids.push(attr_uid)
            if (attr_uid in CI.IV_object_attributes_meta_data === false) {

              // we need latest value from backend
              CI.bi7objectAttributeMetaDataRequestForCSVData(attr_uid, true)
            }
          } 
        }
      }

      setTimeout(function() {
        CI.bi7FetchAllAttributesStep3(filters, filtered_objects_attribute_uids);
      }, 1000)

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7FetchAllAttributesStep3(filters, filtered_objects_attribute_uids) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7FetchAllAttributesStep3 ";
      var task_id = "bi7_watchdog_firebase:bi7FetchAllAttributesStep3";
      var CI = this;
      var attributes_list = [];

      /// check if filtered attributes uids array is empty 
      if (filtered_objects_attribute_uids.length < 1) {
        Vue.set(CI.IV_filtered_attributes_list, 'filtered_attributes', []);
        Vue.set(CI.IV_component_loading_states, 'c2m3_mass_apply_rules', false)
        return;
      }
      ///</end> check if filtered attributes uids array is empty

      // Filtering attributes with matching names if name filter present
      if (Object.keys(CI.IV_meta_data_requests['obj_atr_meta_data']).length > 0) {
        setTimeout(function() {
          CI.bi7FetchAllAttributesStep3(filters, filtered_objects_attribute_uids);
        }, 3000);
        return;
      }

      var filtered_attributes_list = [];
      for (let index in filtered_objects_attribute_uids) {

        let attribute_uid = filtered_objects_attribute_uids[index];

        let attr_name = attribute_uid;
        if (attribute_uid in CI.IV_object_attributes_meta_data === true && 
            CI.IV_object_attributes_meta_data[attribute_uid] !== null &&
            CI.IV_object_attributes_meta_data[attribute_uid] !== undefined &&
            'name' in CI.IV_object_attributes_meta_data[attribute_uid]
        ) {
          attr_name = CI.IV_object_attributes_meta_data[attribute_uid].name;

          // if we get binary true as attribute name.
          // it means we'll get this attribute's name from IV_default_obj_attribute_names
          if (attr_name === true) {
            let uid_num_part = attribute_uid.split("-")[1];
            if (uid_num_part in CI.IV_default_obj_attribute_names === true && CI.IV_default_obj_attribute_names[uid_num_part] !== "") {
              attr_name = CI.IV_default_obj_attribute_names[uid_num_part];
            } else {
              attr_name = attribute_uid;
            }
          }
        }

        if (filters.attribute !== null && filters.attribute.text !== "") {
          const atr_filter_text = filters.attribute.text.toLowerCase().trim();

          if (filters.attribute.key == 'equals' && attr_name.toLocaleLowerCase().trim() != atr_filter_text) {
            continue;
          } else if (filters.attribute.key == 'contains' && !attr_name.toLocaleLowerCase().includes(atr_filter_text)) {
            continue;
          }
        }

        filtered_attributes_list.push({id: attribute_uid, name: attr_name});
      }

      Vue.set(CI.IV_filtered_attributes_list, 'filtered_attributes', [])
      Vue.set(CI.IV_filtered_attributes_list, 'filtered_attributes', filtered_attributes_list);
      Vue.set(CI.IV_component_loading_states, 'c2m3_mass_apply_rules', false)

      /// Clearing the object attribute's metadata from keys IV_deletion_items_keys_after_csv
      /// As we are reusing bi7objectAttributeMetaDataRequestForCSVData in previous step
      for (let uid in CI.IV_object_attributes_meta_data) {
        let attr_name = CI.IV_object_attributes_meta_data[uid].name;
        if (attr_name === true) {
          Vue.delete(CI.IV_object_attributes_meta_data, uid);
          delete CI.IV_object_attributes_meta_data[uid]
        }
      }
      CI.IV_deletion_items_keys_after_csv = [];
      ///</end> Clearing the object attribute's metadata from keys IV_deletion_items_keys_after_csv
      ///</end> As we are reusing bi7objectAttributeMetaDataRequestForCSVData in previous step
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data, 'attributes_list': filtered_attributes_list };
    }

    bi7ClearFilteredAttributesListAndListeners() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7ClearFilteredAttributesList ";
      var task_id = "bi7_watchdog_firebase:bi7ClearFilteredAttributesList";
      var CI = this;

      Vue.set(CI.IV_filtered_attributes_list, 'filtered_attributes', []);

      try {
        CI.IV_listener_mass_applied_rules_history.off();
        CI.IV_listener_mass_applied_rules_history = null;
      } catch(error) {
        debug_data.push(JSON.stringify(error))
        return_msg += `failed to turn ${CI.IV_listener_mass_applied_rules_history} listener off.`;
        CI.IV_listener_mass_applied_rules_history = null;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data};

    }

    bi7InitDoghouseTagsListener() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitDoghouseTagsListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitDoghouseTagsListener";
      var CI = this;

      var listen_folder = CI.IV_user_folder_path + '/dog_house_tags/';

      // we already have listener for this location
      if (CI.IV_listener_dog_house_tags !== null) {
        return;
      }

      CI.IV_listener_dog_house_tags = CI.IV_firebase_db_object.ref(listen_folder);

      CI.IV_listener_dog_house_tags.on("value",
        function (b_data) { CI.DoghouseTagsListener(b_data) }.bind(CI),
        function (error) {
          return_msg += "firebase read failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(this)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data};
    }

    DoghouseTagsListener(data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:DoghouseTagsListener ";
      var task_id = "bi7_watchdog_firebase:DoghouseTagsListener";
      var CI = this;

      ///// input validation
      if (data === null || data === undefined) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      /////</end> input validation

      var firebase_data = data.val()

      for (let tag_id in firebase_data) {
        if (tag_id === "deletion_prevention_key") {continue};


        var entry = {};
        try {
          entry = JSON.parse(firebase_data[tag_id])
        } catch (e) {
          return_msg += "Failed to parse JSON, errors:" + JSON.stringify(e.message);
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
        }

        if (tag_id in CI.IV_dog_house_tags === false || CI.IV_dog_house_tags[tag_id]["name"] !== entry["name"]) {
          Vue.set(CI.IV_dog_house_tags, tag_id, {});
        }

        entry["id"] = tag_id;
        Vue.set(CI.IV_dog_house_tags, tag_id, entry);
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data};
    }

    bi7AddOrUpdateDoghouseTag(name, tag_id=null) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7AddOrUpdateDoghouseTag ";
      var task_id = "bi7_watchdog_firebase:bi7AddOrUpdateDoghouseTag";
      var CI = this;

      ////// input validation
      call_result = bi1_data_validation.is_string(name);
      debug_data.push(call_result);
      if (tag_id !== null) {
        call_result = bi1_data_validation.is_string(tag_id);
        debug_data.push(call_result);
      }

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if(validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      /////// </end> input validation

      var firebase_error_callback = function(error) {
        if (error) {
          return_msg += "firebase write failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }
      };

      if (tag_id === null) {
        let folder_path = CI.IV_user_folder_path + '/dog_house_tags/';
        let reference = CI.IV_firebase_db_object.ref(folder_path);

        let data = {name: name}
        reference.push().set(JSON.stringify(data), firebase_error_callback);
      } else {
        let folder_path = CI.IV_user_folder_path + `/dog_house_tags/${tag_id}`;
        let reference = CI.IV_firebase_db_object.ref(folder_path);

        let data = {name: name}
        reference.set(JSON.stringify(data), firebase_error_callback);
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7AssignOrUnAssignDoghouseTag(doghouse_entry, tag_id, assign_flag, unassign_flag) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7AssignDoghouseTag ";
      var task_id = "bi7_watchdog_firebase:bi7AssignDoghouseTag";
      var CI = this;

      ///// input validation
      call_result = bi1_data_validation.is_string(tag_id);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      if (doghouse_entry === null) {
        return_msg += "doghouse_entry argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      /////</end> input validation

      var folder_path = CI.IV_user_folder_path + 
                    '/dog_house_active/' + 
                    doghouse_entry["org_uid"] + '/' + 
                    doghouse_entry["sys_uid"] + '/' + 
                    doghouse_entry["obj_uid"] + '/' + 
                    doghouse_entry["obj_atr_uid"] + '/' + 
                    doghouse_entry['rule_uid'];

      let tag_ids = doghouse_entry["tags"];
      if (assign_flag === true) {
        if (!tag_ids.includes(tag_id)) {
          tag_ids.push(tag_id);
        }
      } else if (unassign_flag === true) {
        if (tag_ids.includes(tag_id)) {
          let index = tag_ids.indexOf(tag_id);
          tag_ids.splice(index, 1);
        }
      } else {return;}

      var data_object = {
        "timestamp": doghouse_entry["timestamp"],
        "sys_uid": doghouse_entry["sys_uid"],
        "rule_uid": doghouse_entry["rule_uid"],
        "value": doghouse_entry["value"],
        "org_uid": doghouse_entry["org_uid"],
        "obj_atr_uid": doghouse_entry["obj_atr_uid"],
        "obj_uid": doghouse_entry["obj_uid"],
        "tags": tag_ids
      };

      let reference = CI.IV_firebase_db_object.ref(folder_path);

      reference.set(JSON.stringify(data_object), function(error) {
        if (error) {
          return_msg += "firebase write failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }
      });

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7DeleteDoghouseTag(tag_id) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7DeleteDoghouseTag ";
      var task_id = "bi7_watchdog_firebase:bi7DeleteDoghouseTag";
      var CI = this;

      ///// input validation
      call_result = bi1_data_validation.is_string(tag_id);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ////</end> input validation

      var folder_path = CI.IV_user_folder_path + "/dog_house_tags/" + tag_id;

      CI.bi7DeleteFirebaseLocation(folder_path);
      Vue.delete(CI.IV_dog_house_tags, tag_id);
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7ClearActiveAlertsForRule(rule_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7ClearActiveAlertsForRule ";
      var task_id = "bi7_watchdog_firebase:bi7ClearActiveAlertsForRule";
      var CI = this;

      ///// input validation
      call_result = bi1_data_validation.is_string(rule_uid);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ////</end> input validation

      let firebase_locations_to_delete = [];

      for (let org_uid in CI.IV_doghouse_active) {
        for (let sys_uid in CI.IV_doghouse_active[org_uid]) {
          for (let obj_uid in CI.IV_doghouse_active[org_uid][sys_uid]) {
            for (let obj_attr_uid in CI.IV_doghouse_active[org_uid][sys_uid][obj_uid]) {
              for (let rule_join_uid in CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_attr_uid]) {
                let entry = CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_attr_uid][rule_join_uid];
                if (entry === null || entry === undefined) {continue;}

                if (entry.rule_uid === rule_uid) {
                  let active_location = CI.IV_user_folder_path + '/dog_house_active/' + entry.org_uid + '/' + entry.sys_uid + '/' + entry.obj_uid + '/' + entry.obj_atr_uid + '/' + entry.rule_uid;
                  let acknowledged_location = CI.IV_user_folder_path + '/dog_house_ackowledged/' + entry.org_uid + '/' + entry.sys_uid + '/' + entry.obj_uid + '/' + entry.obj_atr_uid + '/' + entry.rule_uid;
                  CI.bi7DeleteFirebaseLocation(active_location)
                  CI.bi7DeleteFirebaseLocation(acknowledged_location)
                  try {
                    Vue.delete(CI.IV_doghouse_active[org_uid][sys_uid][obj_uid][obj_attr_uid], rule_join_uid)
                    Vue.delete(CI.IV_doghouse_acknowledged[org_uid][sys_uid][obj_uid][obj_attr_uid], rule_join_uid);
                  } catch (error) {}
                  
                }
              }
            }
          }
        }
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitOrgNotificationGroupJoinsListener(org_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitOrgNotificationGroupJoinsListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitOrgNotificationGroupJoinsListener";

      ////// input validation
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);

      if (call_result[CR.success] != RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 
      var CI = this;
      CI.IV_component_loading_states[`c5_doghouse_${org_uid}`] = true;

      if (CI.IV_listener_org_ngp_joins[org_uid] != null) {
        CI.IV_component_loading_states[`c5_doghouse_${org_uid}`] = false;
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var listener_location = 'organization/' + org_uid + '/notification_groups';
      CI.IV_listener_org_ngp_joins[org_uid] = CI.IV_firebase_db_object.ref(listener_location);
      
      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_org_ngp_joins[org_uid]);
      debug_data.push(call_result)
      if (call_result[CR.success] != RC.success) {
        delete CI.IV_listener_org_ngp_joins[org_uid];
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        CI.IV_component_loading_states[`c5_doghouse_${org_uid}`] = false;
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_org_ngp_joins[org_uid].on("value",
        function (a_data) {
          CI.OrgNotificationGroupJoinsListenerCallback(org_uid, a_data)
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(this)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    OrgNotificationGroupJoinsListenerCallback(org_uid, data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:OrgNotificationGroupJoinsListenerCallback ";
      var task_id = "bi7_watchdog_firebase:OrgNotificationGroupJoinsListenerCallback";

      ////// input validation 
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);
      if (call_result[CR.success] != RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        CI.IV_component_loading_states[`c5_doghouse_${org_uid}`] = false;
        return { 'success': call_result[CR.success], 'return_msg': return_msg, 'debug_data': debug_data };
      }

      if (data == null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        CI.IV_component_loading_states[`c5_doghouse_${org_uid}`] = false;
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var CI = this;
      var firebase_data = data.val();

      for (var ngp_uid in firebase_data) {

        //ignore last updated entries
        if (ngp_uid === "last_updated" || ngp_uid === 'deletion_prevention_key') {
          continue;
        }

        let actual_ngp_uid = `ngp_${ngp_uid}`;
        if (actual_ngp_uid in CI.IV_ngp_meta_data == false) {
          Vue.set(CI.IV_ngp_meta_data, actual_ngp_uid, {});
        }

        if (org_uid in CI.IV_org_ngp_joins == false) {
          Vue.set(CI.IV_org_ngp_joins, org_uid, {});
        }

        if (actual_ngp_uid in CI.IV_org_ngp_joins[org_uid] === false) {
          Vue.set(CI.IV_org_ngp_joins[org_uid], actual_ngp_uid, actual_ngp_uid);
        }

        // Only fetch the ngp metadata info if not present already
        if (actual_ngp_uid in CI.IV_ngp_meta_data === false ||
            'name' in CI.IV_ngp_meta_data[actual_ngp_uid] === false ||
            typeof(CI.IV_ngp_meta_data[actual_ngp_uid]['name']) !== "string") {
          CI.bi7CreateDataStoreRequest('ngp_meta_data', actual_ngp_uid);
        }
        //</end> Only fetch the ngp metadata info if not present already
      }

      CI.IV_component_loading_states[`c5_doghouse_${org_uid}`] = false;
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    removeNGPUserGlobalJoinsListener() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:removeNGPUserGlobalJoinsListener ";
      var task_id = "bi7_watchdog_firebase:removeNGPUserGlobalJoinsListener";
      var CI = this;

      if (CI.IV_listener_ngp_users_global_last_updated === null) {
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      try {
        CI.IV_listener_ngp_users_global_last_updated.off();
        CI.IV_listener_ngp_users_global_last_updated = null;
      } catch(error) {
        debug_data.push(JSON.stringify(error))
        return_msg += `failed to turn IV_listener_ngp_users_global_last_updated listener off.`;
        CI.IV_listener_ngp_users_global_last_updated = null;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitNGPUserGlobalJoins() {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitNGPUserGlobalJoins ";
      var task_id = "bi7_watchdog_firebase:bi7InitNGPUserGlobalJoins";
      var CI = this;

      // listener is already active
      if (CI.IV_listener_ngp_users_global_last_updated !== null) {
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var listener_location = 'ngp_users';
      CI.IV_listener_ngp_users_global_last_updated = CI.IV_firebase_db_object.ref(listener_location);
      
      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_ngp_users_global_last_updated);
      debug_data.push(call_result)
      if (call_result[CR.success] != RC.success) {
        delete CI.IV_listener_ngp_users_global_last_updated;
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_ngp_users_global_last_updated.on("value",
        function (a_data) {
          CI.NGPUserGlobalJoinsCallback(a_data)
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(this)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    NGPUserGlobalJoinsCallback(data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:NGPUserGlobalJoinsCallback ";
      var task_id = "bi7_watchdog_firebase:NGPUserGlobalJoinsCallback";

      ////// input validation 
      if (data == null) {
          return_msg += "data argument is null";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var CI = this;
      var firebase_data = data.val();

      for (var uid in firebase_data) {
        if (uid === "deletion_prevention_key") {continue;}
        if (uid === "last_updated") {continue;}

        let ngp_uid = `ngp_${uid}`;

        if (ngp_uid in CI.IV_ngp_users_last_updated === false) {
          Vue.set(CI.IV_ngp_users_last_updated, ngp_uid, firebase_data[uid]);
          continue;
        }

        if (firebase_data[uid] > CI.IV_ngp_users_last_updated[ngp_uid]) {
          Vue.set(CI.IV_ngp_users_last_updated, ngp_uid, firebase_data[uid]);
        }
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitNotificationGroupRuleJoins(ngp_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitNotificationGroupRuleJoins ";
      var task_id = "bi7_watchdog_firebase:bi7InitNotificationGroupRuleJoins";
      var CI = this;

      CI.IV_loading_ngp_rules[ngp_uid] = true;
      ///// input validation
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        CI.IV_loading_ngp_rules[ngp_uid] = false;
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ////</end> input validation

      // This means we already have listener initiated for this nop_uid
      if (ngp_uid in CI.IV_listener_ngp_rule_joins === true) {
        CI.IV_loading_ngp_rules[ngp_uid] = false;
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var listener_location = 'ngp_rules/' + ngp_uid.replace("ngp_", "");
      CI.IV_listener_ngp_rule_joins[ngp_uid] = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_ngp_rule_joins[ngp_uid]);
      debug_data.push(call_result)
      if (call_result[CR.success] != RC.success) {
        CI.IV_loading_ngp_rules[ngp_uid] = false;
        delete CI.IV_listener_ngp_rule_joins[ngp_uid]
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_ngp_rule_joins[ngp_uid].on("value",
        function (a_data) {
          CI.NotificationGroupRuleJoinsCallback(ngp_uid, a_data)
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(this)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    NotificationGroupRuleJoinsCallback(ngp_uid, data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:NotificationGroupRuleJoinsCallback ";
      var task_id = "bi7_watchdog_firebase:NotificationGroupRuleJoinsCallback";

      ////// input validation 
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        CI.IV_loading_ngp_rules[ngp_uid] = false;
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      if (data == null) {
        CI.IV_loading_ngp_rules[ngp_uid] = false;
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var CI = this;
      var firebase_data = data.val();
      var rules_needs_information = [];

      if (ngp_uid in CI.IV_ngp_rule_joins === false) {
        Vue.set(CI.IV_ngp_rule_joins, ngp_uid, {});
      }

      for (let rule_uid in firebase_data) {
        if (rule_uid === "deletion_prevention_key") {continue;}
        if (rule_uid === "last_updated") {continue;}

        if (firebase_data[rule_uid].indexOf("deleted_") === 0) {
          if (ngp_uid in CI.IV_ngp_rule_joins === true) {
            Vue.delete(CI.IV_ngp_rule_joins[ngp_uid], rule_uid)
          }
          continue;
        }

        if (rule_uid in CI.IV_ngp_rule_joins[ngp_uid] === false) {
          Vue.set(CI.IV_ngp_rule_joins[ngp_uid], rule_uid, firebase_data[rule_uid])
          rules_needs_information.push(rule_uid);
          continue;
        }

        if (firebase_data[rule_uid] > CI.IV_ngp_rule_joins[ngp_uid][rule_uid]) {
          Vue.set(CI.IV_ngp_rule_joins[ngp_uid], rule_uid, firebase_data[rule_uid])
          rules_needs_information.push(rule_uid);
        }

      }

      if (rules_needs_information.length > 0) {
        CI.bi7FetchNotificationGroupRulesInformation(ngp_uid, rules_needs_information)
      } else {
        CI.IV_loading_ngp_rules[ngp_uid] = false;
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7FetchNotificationGroupRulesInformation(ngp_uid, rules_list) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7FetchNotificationGroupRulesInformation ";
      var task_id = "bi7_watchdog_firebase:bi7FetchNotificationGroupRulesInformation";

      ////// input validation 
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      call_result = bi1_data_validation.is_array(rules_list);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var CI = this;
      rules_list.forEach((rule, index, theArray) => theArray[index] = [rule, index])
      
      var getNGPRulesInformationCallback = (result) => {
        let rules_information = result.rules_information;

        for (let index in rules_information) {
          let rule_data = rules_information[index];
          let rule_uid = rules_list[rule_data[0]][0];

          let data = {
            name: rule_data[1][0],
            uid: rule_uid,
            description: rule_data[1][1],
            ruleLogic: JSON.parse(rule_data[1][2])
          }

          Vue.set(CI.IV_notification_group_rules_information, rule_uid, data);
        }
        CI.IV_loading_ngp_rules[ngp_uid] = false;
      };
      
      getNGPRulesInformation(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        ngp_uid,
        rules_list
      ).then(
        getNGPRulesInformationCallback,
        function(error) {
          CI.IV_loading_ngp_rules[ngp_uid] = false;
          return_msg += "There was an error getting notification group rules information,";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
          return { 'success': RC.ajax_failure, 'return_msg': return_msg, 'debug_data': debug_data };
        }
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitNGPRuleAssignmentListener(ngp_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitNGPRuleAssignmentListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitNGPRuleAssignmentListener";
      var CI = this;

      ///// input validation
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ////</end> input validation

      // This means we already have listener initiated for this nop_uid
      if (ngp_uid in CI.IV_listener_ngp_rule_assignment === true) {
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      if (ngp_uid in CI.IV_ngp_rule_assignment_data === false) {
        Vue.set(CI.IV_ngp_rule_assignment_data, ngp_uid, {});
      }

      var listener_location = 'ngp_assigned_details/' + ngp_uid.replace("ngp_", "");
      CI.IV_listener_ngp_rule_assignment[ngp_uid] = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_ngp_rule_assignment[ngp_uid]);
      debug_data.push(call_result)
      if (call_result[CR.success] != RC.success) {
        delete CI.IV_listener_ngp_users_global_last_updated;
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_ngp_rule_assignment[ngp_uid].on("value",
        function (a_data) {
          CI.NGPRuleAssignmentListenerCallback(ngp_uid, a_data)
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(this)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    NGPRuleAssignmentListenerCallback(ngp_uid, data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:NGPRuleAssignmentListenerCallback ";
      var task_id = "bi7_watchdog_firebase:NGPRuleAssignmentListenerCallback";

      ////// input validation 
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      if (data == null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var CI = this;
      var firebase_data = data.val();

      for (let org_uid in firebase_data) {
        if (org_uid === "deletion_prevention_key") {continue;}
        if (org_uid === "last_updated") {continue;}

        for (let sys_uid in firebase_data[org_uid]) {
          if (sys_uid === "deletion_prevention_key") {continue;}
          if (sys_uid === "last_updated") {continue;}

          for (let obj_uid in firebase_data[org_uid][sys_uid]) {
            if (obj_uid === "deletion_prevention_key") {continue;}
            if (obj_uid === "last_updated") {continue;}

            for (let atr_uid in firebase_data[org_uid][sys_uid][obj_uid]) {
              if (atr_uid === "deletion_prevention_key") {continue;}
              if (atr_uid === "last_updated") {continue;}

              var rule_uid = "";

              for (let key in firebase_data[org_uid][sys_uid][obj_uid][atr_uid]) {
                if (key === "deletion_prevention_key") {continue;}
                if (key === "last_updated") {continue;}

                let rule_data = firebase_data[org_uid][sys_uid][obj_uid][atr_uid][key];

                rule_uid = key.split("_")[4];
                if (rule_data.indexOf("deleted_") === 0) {
                  if (rule_uid in CI.IV_ngp_rule_assignment_data[ngp_uid] === true) {
                    Vue.delete(CI.IV_ngp_rule_assignment_data[ngp_uid], rule_uid);
                  }
                  continue;
                }

                let entry = {
                  org_uid: `org_${org_uid}`,
                  sys_uid: `sys_${sys_uid}`,
                  obj_uid: `obj_${obj_uid}`,
                  obj_atr_uid: `obj_atr_${obj_uid}-${atr_uid}`,
                  instant_retrigger_time: parseInt(rule_data.substr(3)),
                  type_doghouse: rule_data[0] === "T",
                  type_instant: rule_data[1] === "T",
                  type_daily: rule_data[2] === "T",
                  uid: rule_uid
                }

                if (rule_uid in CI.IV_ngp_rule_assignment_data[ngp_uid] === false) {
                  Vue.set(CI.IV_ngp_rule_assignment_data[ngp_uid], rule_uid, {});
                }

                Vue.set(CI.IV_ngp_rule_assignment_data[ngp_uid][rule_uid], key, entry);
              }
            }
          }
        }
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitUserNotificationGroupJoinsListener(loading_key="user_ngp_joins") {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitUserNotificationGroupJoinsListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitUserNotificationGroupJoinsListener";
      var CI = this;

      // We'll wait the firebase to connect before trying to start listener.
      if (CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
        setTimeout(() => {
          this.bi7InitUserNotificationGroupJoinsListener(loading_key)
        },500);
        return;
      }

      Vue.set(CI.IV_ngp_loading_states, loading_key, true);

      // We already have a listener started
      if (CI.IV_listener_users_ngp_joins !== null) {
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var listener_location = CI.IV_user_folder_path +  '/notification_groups';
      CI.IV_listener_users_ngp_joins = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_users_ngp_joins);
      debug_data.push(call_result)
      if (call_result[CR.success] !== RC.success) {
        CI.IV_listener_users_ngp_joins = null;
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_users_ngp_joins.on("value",
        function (a_data) {
          CI.userNotificationGroupJoinsListenerCallback(a_data, loading_key)
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(CI));

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    userNotificationGroupJoinsListenerCallback(data, loading_key) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:userNotificationGroupJoinsListenerCallback ";
      var task_id = "bi7_watchdog_firebase:userNotificationGroupJoinsListenerCallback";
      var CI = this;

      ////// input validation 
      if (data == null || data.val() === null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var firebase_data = data.val();
      let no_ngp_data = true;

      for (let key in firebase_data) {
        //ignore last updated entries
        if (key === "last_updated" || key === 'deletion_prevention_key') {
            continue;
        }

        let actual_ngp_uid = `ngp_${key}`;

        if (firebase_data[key].indexOf("deleted_") === 0) {
          if (actual_ngp_uid in CI.IV_user_ngp_joins === true) {
            Vue.delete(CI.IV_user_ngp_joins, actual_ngp_uid)
          }
          continue;
        }
        no_ngp_data = false;

        if (actual_ngp_uid in CI.IV_ngp_meta_data == false) {
          Vue.set(CI.IV_ngp_meta_data, actual_ngp_uid, {});
        }

        if (actual_ngp_uid in CI.IV_user_ngp_joins === false) {
          Vue.set(CI.IV_user_ngp_joins, actual_ngp_uid, actual_ngp_uid);
        }

        // Only fetch the ngp metadata info if not present already
        if (actual_ngp_uid in CI.IV_ngp_meta_data === false ||
            'name' in CI.IV_ngp_meta_data[actual_ngp_uid] === false ||
            typeof(CI.IV_ngp_meta_data[actual_ngp_uid]['name']) !== "string") {
          CI.bi7CreateDataStoreRequest('ngp_meta_data', actual_ngp_uid);
        }

        if (actual_ngp_uid in CI.IV_listener_ngp_triggered_all === false) {
          CI.bi7InitNotificationAllTriggeredListener(actual_ngp_uid, true);
        }
        //</end> Only fetch the ngp metadata info if not present already
      }

      Vue.set(CI.IV_ngp_loading_states, loading_key, false);
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitNotificationGroupOrgJoinsListener(loading_key="org_ngp_joins") {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitNotificationGroupOrgJoinsListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitNotificationGroupOrgJoinsListener";
      var CI = this;

      // We'll wait the firebase to connect before trying to start listener.
      if (CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
        setTimeout(() => {
          this.bi7InitNotificationGroupOrgJoinsListener(loading_key)
        },500);
        return;
      }

      Vue.set(CI.IV_ngp_loading_states, loading_key, true);

      // We already have a listener started
      if (CI.IV_listener_ngp_org_joins !== null) {
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var listener_location = 'ngp_orgs';
      CI.IV_listener_ngp_org_joins = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_ngp_org_joins);
      debug_data.push(call_result)
      if (call_result[CR.success] !== RC.success) {
        CI.IV_listener_ngp_org_joins = null;
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_ngp_org_joins.on("value",
        function (a_data) {
          CI.NotificationGroupOrgJoinsListenerCallback(a_data, loading_key)
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(CI));

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    NotificationGroupOrgJoinsListenerCallback(data, loading_key) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:NotificationGroupOrgJoinsListenerCallback ";
      var task_id = "bi7_watchdog_firebase:NotificationGroupOrgJoinsListenerCallback";
      const CI = this;

      ////// input validation 
      if (data == null || data.val() === null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      //////</end> input validation 

      var firebase_data = data.val();

      for (let ngp_uid in firebase_data) {
        //ignore last updated entries
        if (ngp_uid === "last_updated" || ngp_uid === 'deletion_prevention_key') {
          continue;
        }

        let actual_ngp_uid = `ngp_${ngp_uid}`;
        let org_uids = firebase_data[ngp_uid];

        for (let org_uid in org_uids) {
          if (org_uid === "last_updated" || org_uid === 'deletion_prevention_key') {
            continue;
          }

          if (actual_ngp_uid in CI.IV_ngp_org_joins === false) {
            Vue.set(CI.IV_ngp_org_joins, actual_ngp_uid, {});
          }

          Vue.set(CI.IV_ngp_org_joins[actual_ngp_uid], org_uid, org_uid);
        }
      }

      Vue.set(CI.IV_ngp_loading_states, loading_key, false);
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitNotificationFocusedTriggeredListener(ngp_uid, org_uid, sys_uid=null, obj_uid=null, obj_atr_uid=null) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitNotificationFocusedTriggeredListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitNotificationFocusedTriggeredListener";
      var CI = this;

      ////// input validation
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }
      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      /////// </end> input validation

      var listener_key = `${ngp_uid}|${org_uid}`;

      /// Setting empty data to aadd in listening locations
      if (org_uid in CI.IV_ngp_triggered_alerts_data === false) {
        Vue.set(CI.IV_ngp_triggered_alerts_data, org_uid, {});
      }
      if (sys_uid && sys_uid in CI.IV_ngp_triggered_alerts_data[org_uid] === false) {
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid], sys_uid, {});
      }
      if (sys_uid && obj_uid && obj_uid in CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid] === false) {
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid], obj_uid, {});
      }
      if (sys_uid && obj_uid && obj_atr_uid && obj_atr_uid in CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid] === false) {
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid], obj_atr_uid, {});
      }
      ///</end> Setting empty data to add in listening locations

      // We already have a listener started for this ngp and org
      if (listener_key in CI.IV_listener_ngp_triggered_focused === true) {
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var listener_location = `ngp_triggered_focused/${ngp_uid.replace("ngp_", "")}/${org_uid.replace("org_", "")}`;
      CI.IV_listener_ngp_triggered_focused[listener_key] = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_ngp_triggered_focused[listener_key]);
      debug_data.push(call_result)
      if (call_result[CR.success] !== RC.success) {
        delete CI.IV_listener_ngp_triggered_focused[listener_key];
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_ngp_triggered_focused[listener_key].on("value",
        function (a_data) {
          CI.notificationAllTriggeredListenerCallback(ngp_uid, a_data)
        }.bind(CI),
        function (errorObject) {
          return_msg += "firebase read failed with error data:" + errorObject;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(CI)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitNotificationAllTriggeredListener(ngp_uid, is_global=false, org_uid, sys_uid=null, obj_uid=null, obj_atr_uid=null) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitNotificationAllTriggeredListener ";
      var task_id = "bi7_watchdog_firebase:bi7InitNotificationAllTriggeredListener";
      var CI = this;

      // We'll wait the firebase to connect before trying to start listener.
      if (CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
        setTimeout(function() {CI.bi7InitNotificationAllTriggeredListener(ngp_uid, is_global, org_uid, sys_uid, obj_uid, obj_atr_uid)}.bind(CI), 500);
        return;
      }

      /// input valiidation
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);
      
      if (call_result[CR.success] !== RC.success) {
        CI.IV_loading_ngp_rules[ngp_uid] = false;
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///</end> input valiidation

      /// Setting empty data to aadd in listening locations
      if (org_uid in CI.IV_ngp_triggered_alerts_data === false) {
        Vue.set(CI.IV_ngp_triggered_alerts_data, org_uid, {});
      }
      if (sys_uid && sys_uid in CI.IV_ngp_triggered_alerts_data[org_uid] === false) {
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid], sys_uid, {});
      }
      if (sys_uid && obj_uid && obj_uid in CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid] === false) {
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid], obj_uid, {});
      }
      if (sys_uid && obj_uid && obj_atr_uid && obj_atr_uid in CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid] === false) {
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid], obj_atr_uid, {});
      }
      ///</end> Setting empty data to add in listening locations

      var listener_location = `ngp_triggered_all/${ngp_uid.replace('ngp_', '')}`;
      CI.IV_listener_ngp_triggered_all[ngp_uid] = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_ngp_triggered_all[ngp_uid]);
      debug_data.push(call_result)
      if (call_result[CR.success] !== RC.success) {
        CI.IV_listener_ngp_triggered_all[ngp_uid] = null;
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key
      CI.IV_listener_ngp_triggered_all[ngp_uid].on("value",
        function (a_data) {
          CI.notificationAllTriggeredListenerCallback(ngp_uid, a_data, is_global)
        }.bind(CI),
        function (error) {
          return_msg += "firebase read failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(CI)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    notificationAllTriggeredListenerCallback(ngp_uid, data, is_global=false) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:notificationAllTriggeredListenerCallback ";
      var task_id = "bi7_watchdog_firebase:notificationAllTriggeredListenerCallback";

      ////// input validation
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);
      
      if (call_result[CR.success] !== RC.success) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      if (data == null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      /////// </end> input validation

      const CI = this;
      const firebase_data = data.val();
      // this is used to know where in IV_ngp_triggered_alerts_entries to put the data in each index from the results from p2s7t18
      const updated_entry_entity_keys_lookup = {
        "mact": [],
        "active":[],
        "hist": [],
        "ack": [],
        "cleared": []
      }
      const updated_entry_entity_keys = {
        "mact": [],
        "active":[],
        "hist": [],
        "ack": [],
        "cleared": []
      }

      let entries_to_queue_for_count = {}

      for (let key in firebase_data) {
        if (key === "last_updated" || key === 'deletion_prevention_key') {
          continue;
        }
        if (key.includes("deleted_")) {
          continue;
        }
        /// Extracting data from key and value
        const key_parts = key.split("_"),
              data_parts = firebase_data[key].split("|"),
              status = key_parts[0],
              org_uid = `org_${key_parts[1]}`,
              obj_atr_uid =`obj_atr_${key_parts[3]}-${key_parts[4]}`,
              sys_uid = `sys_${key_parts[2]}`,
              obj_uid = `obj_${key_parts[3]}`,
              rule_uid = key_parts[5],
              event_timestamp = parseInt(data_parts[0]),
              url_safe_key = data_parts[1],
              actual_ngp_uid = ngp_uid,
              status_type_key = `${status}_last_updated`,
              status_type_url_safe_key = `${status}_url_safe_key`

        if (`${actual_ngp_uid}|${org_uid}` in CI.IV_ngp_triggered_alerts_entries === false) {
          Vue.set(CI.IV_ngp_triggered_alerts_entries, `${actual_ngp_uid}|${org_uid}`, {});
        }
        /// </end> Extracting data from key

        /// Set same data in IV_ngp_triggered_alerts_data to be used in different format in different component
        if (org_uid in CI.IV_ngp_triggered_alerts_data === false) {
          Vue.set(CI.IV_ngp_triggered_alerts_data, org_uid, {});
        }
        if (sys_uid in CI.IV_ngp_triggered_alerts_data[org_uid] === false) {
          Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid], sys_uid, {});
        }
        if (obj_uid in CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid] === false) {
          Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid], obj_uid, {});
        }
        if (obj_atr_uid in CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid] === false) {
          Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid], obj_atr_uid, {});
        }
        /// Set same data in IV_ngp_triggered_alerts_data to be used in different format in different component

        key_parts.splice(0, 1)
        let unique_id = ngp_uid + "_"  + key_parts.join("_");
        let entry = {};
        let skip_iteration = false;
        let unique_key = `${key_parts[0]}_${key_parts[1]}_${key_parts[2]}_${key_parts[3]}_${rule_uid}`;

        /// if this notifcation doesn't have an entry already create it and populate it with this data
        if (unique_id in CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`] === false) {
          Vue.set(CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`], unique_id, {});
          entry = {
            rule_uid: rule_uid,
            ngp_uid: actual_ngp_uid,
            org_uid: org_uid,
            sys_uid: sys_uid,
            obj_uid: obj_uid,
            obj_atr_uid: obj_atr_uid,
            url_safe_key: url_safe_key,
            last_updated: event_timestamp,
            datastore_timestamp: 0,
            value : null,
            rule_name : null,
            user_uid : 0,
            user_request_timestamp : 0
          }
          entry[status_type_key] = event_timestamp;
          entry[status_type_url_safe_key] = url_safe_key;

          if (!is_global) {
            let index_key_str = updated_entry_entity_keys[status].length.toString();
            updated_entry_entity_keys[status].push(url_safe_key)
            updated_entry_entity_keys_lookup[status][index_key_str] = {
              "ngp_uid": actual_ngp_uid,
              "org_uid": org_uid,
              "sys_uid": sys_uid,
              "obj_uid": obj_uid,
              "obj_atr_uid": obj_atr_uid,
              "rule_uid": rule_uid,
              "unique_id" : unique_id
            };
          }

          Vue.set(CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`], unique_id, entry);

          entries_to_queue_for_count[unique_key] = {status: status, event_timestamp: event_timestamp, complete_entry: CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`][unique_id]};
          skip_iteration = true;
        }
        ///</end> if this notifcation doesn't have an entry already create it and populate it with this data

        /// Set same data in IV_ngp_triggered_alerts_data to be used in different format in different component
        if (rule_uid in CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid][obj_atr_uid] === false) {
          Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid][obj_atr_uid], rule_uid, entry);
          if (skip_iteration) {continue;}
        }
        ///</end> Set same data in IV_ngp_triggered_alerts_data to be used in different format in different component

        /// read existing data and update it, if the firebase data is newer
        entry = CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`][unique_id]
        if (entry["last_updated"] >= event_timestamp) { 
          
          // Only add key for fetching data if not global
          if (!is_global) {

            // skip entry if data already fetched is new enough
            if (unique_id in CI.IV_last_fetched_time_ngp_triggered_alerts_data === true && 
                CI.IV_last_fetched_time_ngp_triggered_alerts_data[unique_id] >= event_timestamp
            ) {
              continue;
            }
            
            CI.IV_last_fetched_time_ngp_triggered_alerts_data[unique_id] = entry["last_updated"];

            let index_key_str = updated_entry_entity_keys[status].length.toString();
            updated_entry_entity_keys[status].push(url_safe_key)
            updated_entry_entity_keys_lookup[status][index_key_str] = {
              "ngp_uid": actual_ngp_uid,
              "org_uid": org_uid,
              "sys_uid": sys_uid,
              "obj_uid": obj_uid,
              "obj_atr_uid": obj_atr_uid,
              "rule_uid": rule_uid,
              "unique_id" : unique_id
            };
          }
          continue; 
        }

        Vue.set(CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`][unique_id], status_type_key, event_timestamp);
        Vue.set(CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`][unique_id], status_type_url_safe_key, url_safe_key);
        Vue.set(CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`][unique_id], "last_updated", event_timestamp);

        entries_to_queue_for_count[unique_key] = {status: status, event_timestamp: event_timestamp, complete_entry: CI.IV_ngp_triggered_alerts_entries[`${actual_ngp_uid}|${org_uid}`][unique_id]};

        // Update same data in IV_ngp_triggered_alerts_data to be used in different format in different component
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid], status_type_key, event_timestamp);
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid], status_type_url_safe_key, url_safe_key);
        Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid], "last_updated", event_timestamp);

        if (!is_global) {
          let index_key_str = updated_entry_entity_keys[status].length.toString();
          updated_entry_entity_keys[status].push(url_safe_key)
          updated_entry_entity_keys_lookup[status][index_key_str] = {
            "ngp_uid": actual_ngp_uid,
            "org_uid": org_uid,
            "sys_uid": sys_uid,
            "obj_uid": obj_uid,
            "obj_atr_uid": obj_atr_uid,
            "rule_uid": rule_uid,
            "unique_id" : unique_id
          };
        }
        ///</end> read existing data and update it, if the firebase data is newer
      }

      /// Queue this entry to process the doghouse count
      let timestamp = new Date().getTime();
      let epoch_minutes = parseInt(timestamp / (1000 * 60));
       const statusStrToIntMap = {
        'active': 1,
        'mact': 2,
        'ack': 3,
        'hist': 4,
        'cleared': 4
      }

      for (let key in entries_to_queue_for_count) {
        let key_parts = key.split("_")
        let unique_key = `${key}_${timestamp}`;
        let entry = entries_to_queue_for_count[key];
        let max_key_name = ""
        let previous_states_keys = {}
      
        let alert_count_entry = [entry['event_timestamp'], statusStrToIntMap[entry['status']], false, key_parts[0], key_parts[1], key_parts[2], key_parts[3]]

        previous_states_keys = _.pickBy(entry['complete_entry'], (value, key) => key.includes("_last_updated") && entry['complete_entry'][key] !== entry['complete_entry']['last_updated'])
        max_key_name = _.maxBy(Object.keys(previous_states_keys), function (o) { return previous_states_keys[o]; });

        if (!max_key_name) {
          alert_count_entry[7] = ""
          CI.bi7QueueDoghouseCountEntry(unique_key, alert_count_entry, "ngp");
          continue;
        }

        if (max_key_name.includes('active') || max_key_name.includes('mact')) {
          alert_count_entry[7] = 'active'
        } else if (max_key_name.includes('ack')) {
          alert_count_entry[7] = 'acknowledged'
        } else {
          alert_count_entry[7] = 'history'
        }
        CI.bi7QueueDoghouseCountEntry(unique_key, alert_count_entry, "ngp");
      }
      ///</end> Queue this entry to process the doghouse count

      /// Only make call for data if any new item required
      let total_items_count = updated_entry_entity_keys["active"].length + updated_entry_entity_keys["ack"].length + updated_entry_entity_keys["hist"].length + updated_entry_entity_keys["mact"].length;
      
      if (total_items_count === 0){
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///</end> Only make call for data if any new item required

      /// Only get further NGP data if the callback was triggered from bi7InitNotificationFocusedTriggeredListener
      if (!is_global) {
        p2s7t18GetNgpEntriesByEntityKey(
          window.G_firebase_auth.bi5FirebaseEmailAddressProperty,
          window.G_firebase_auth.bi5TokenProperty,
          updated_entry_entity_keys["active"],
          updated_entry_entity_keys["ack"],
          updated_entry_entity_keys["hist"],
          updated_entry_entity_keys["mact"],
          updated_entry_entity_keys_lookup
        ).then(
          function (return_data) {
            const entries = return_data["updated_entries"]
            const updated_entry_entity_keys_lookup = return_data["lookup_data"]
            const longToShortStatusNameMap = {
              'active': 'active',
              'acknowledged': 'ack',
              'manual_active': 'mact',
              'manual_history': 'hist',
            }
            for (let status_key in entries) {
              //loop through all results from the specific status entry
              for (let array_index in entries[status_key]) {
                const updated_entry = entries[status_key][array_index];
                const status = longToShortStatusNameMap[status_key];
                const index_key_str = updated_entry[3].toString();
                const ngp_uid = updated_entry_entity_keys_lookup[status][index_key_str]["ngp_uid"];
                const org_uid = updated_entry_entity_keys_lookup[status][index_key_str]["org_uid"];
                const sys_uid = updated_entry_entity_keys_lookup[status][index_key_str]["sys_uid"];
                const obj_uid = updated_entry_entity_keys_lookup[status][index_key_str]["obj_uid"];
                const obj_atr_uid = updated_entry_entity_keys_lookup[status][index_key_str]["obj_atr_uid"];
                const rule_uid = updated_entry_entity_keys_lookup[status][index_key_str]["rule_uid"];
                const unique_id = updated_entry_entity_keys_lookup[status][index_key_str]["unique_id"];

                const entry_data = {
                  triggered_timestamp: updated_entry[0],
                  value : updated_entry[1],
                  rule_name : updated_entry[2],
                  user_uid : updated_entry[4],
                  user_request_timestamp : updated_entry[5],
                  entry_type : updated_entry[6]
                }
                for( let new_value_key in entry_data) {
                  Vue.set(CI.IV_ngp_triggered_alerts_entries[`${ngp_uid}|${org_uid}`][unique_id],
                    new_value_key , entry_data[new_value_key]
                  );
                  Vue.set(CI.IV_ngp_triggered_alerts_data[org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid],
                    new_value_key , entry_data[new_value_key]
                  );
                }
                CI.IV_last_fetched_time_ngp_triggered_alerts_data[unique_id] = CI.IV_ngp_triggered_alerts_entries[`${ngp_uid}|${org_uid}`][unique_id]['last_updated'];
              }
            }
          },
          function (error) {}
        )
      }
      ///</end> Only get further NGP data if the callback was triggered from bi7InitNotificationFocusedTriggeredListener

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    updateDoghouseCountDictionaries(target_type, uids, action_type) {
      const CI = this,
        [org_uid, sys_uid, obj_uid, obj_atr_uid] = uids,
        compound_atr_uid = `${obj_uid}-${obj_atr_uid}`,
        getNewTotal = (IV_dict_name, uid) => {
          const current_total = CI[IV_dict_name][uid] && parseInt(CI[IV_dict_name][uid]);
          let new_total;
          if (action_type === 'increment') {
            new_total = current_total ? current_total + 1 : 1;
          } else if (action_type === 'decrement'){
            new_total = current_total ? current_total - 1 : 0;
          }
          return new_total;
        },
        now_time = new Date();

      if (target_type === 'active') {
        Vue.set(CI.IV_doghouse_active_count_org_level, org_uid, getNewTotal('IV_doghouse_active_count_org_level', org_uid));
        Vue.set(CI.IV_doghouse_active_count_sys_level, sys_uid, getNewTotal('IV_doghouse_active_count_sys_level', sys_uid));
        Vue.set(CI.IV_doghouse_active_count_object_level, obj_uid, getNewTotal('IV_doghouse_active_count_object_level', obj_uid));
        Vue.set(CI.IV_doghouse_active_count_obj_atr_level, compound_atr_uid, getNewTotal('IV_doghouse_active_count_obj_atr_level', compound_atr_uid));
        CI.IV_doghouse_count_last_updated['active_alerts'] = parseInt(now_time.getTime() / 1000);
      }
      if (target_type === 'acknowledged') {
        Vue.set(CI.IV_doghouse_acknowledged_count_org_level, org_uid, getNewTotal('IV_doghouse_acknowledged_count_org_level', org_uid));
        Vue.set(CI.IV_doghouse_acknowledged_count_sys_level, sys_uid, getNewTotal('IV_doghouse_acknowledged_count_sys_level', sys_uid));
        Vue.set(CI.IV_doghouse_acknowledged_count_object_level, obj_uid, getNewTotal('IV_doghouse_acknowledged_count_object_level', obj_uid));
        Vue.set(CI.IV_doghouse_acknowledged_count_obj_atr_level, compound_atr_uid, getNewTotal('IV_doghouse_acknowledged_count_obj_atr_level', compound_atr_uid));
        CI.IV_doghouse_count_last_updated['acknowledged_alerts'] = parseInt(now_time.getTime() / 1000);
      }
    }

    bi7QueueDoghouseCountEntry(unique_key, entry, alert_type) {
      const debug_data = [];
      let call_result = {};
      let return_msg = "bi7_watchdog_firebase:bi7QueueDoghouseCountEntry ";
      const task_id = "bi7_watchdog_firebase:bi7QueueDoghouseCountEntry";
      const CI = this;

      if (entry[0] < CI.IV_page_load_time) {
        const [
          event_timestamp,
          event_type,
          has_been_processed,
          org_uid,
          sys_uid,
          obj_uid,
          obj_atr_uid,
          previous_state,
          next_state
        ] = entry,
        uids = [org_uid, sys_uid, obj_uid, obj_atr_uid];
        
        switch (event_type) {
          case 1:
            // Pass to case 2
          case 2:
            CI.updateDoghouseCountDictionaries('active', uids, 'increment');
            break;
          case 3:
            CI.updateDoghouseCountDictionaries('acknowledged', uids, 'increment');
            if (alert_type === "acknowledged" || alert_type === "active") CI.updateDoghouseCountDictionaries('active', uids, 'decrement');
            break;
          case 4:
            // ignore
        }

        return;
      }

      let event_timestamp = new Date().getTime();
      let epoch_minutes = parseInt(event_timestamp / (1000 * 60));

      if (epoch_minutes in CI.IV_doghouse_count_update_queue === false) {
        CI.IV_doghouse_count_update_queue[epoch_minutes] = {};
      }

      CI.IV_doghouse_count_update_queue[epoch_minutes][unique_key] = entry;
      CI.IV_doghouse_count_last_updated[`${alert_type}_alerts`] = parseInt(new Date().getTime() / 1000);

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    processDoghouseCountUpdateQueue() {
      const debug_data = [];
      let call_result = {};
      let return_msg = "bi7_watchdog_firebase:processDoghouseCountUpdateQueue ";
      const task_id = "bi7_watchdog_firebase:processDoghouseCountUpdateQueue";
      const CI = this;

      // Verify DB connection is completed
      if (CI.IV_instance_initialized !== true || CI.IV_user_info['uid'] === 0) {
        setTimeout(CI.processDoghouseCountUpdateQueue.bind(CI), 500);
        return;
      }

      const now_time = new Date();
      const now_time_epoch = parseInt(now_time.getTime() / 1000);

      // This acts as a safety in case processDoghouseCountUpdateQueue crashes while running and doesn't set IV_doghouse_count_update_request_active back to false
      if (CI.IV_doghouse_count_update_request_active === true
          && (now_time_epoch - CI.IV_doghouse_count_update_last_run_time) > 10
        ) {
        CI.IV_doghouse_count_update_request_active = false;
      }

      if (CI.IV_doghouse_count_update_request_active === true) {
        setTimeout(CI.processDoghouseCountUpdateQueue.bind(CI), 100);
        return;
      }

      if (CI.IV_doghouse_count_update_queue.length === 0) {
        setTimeout(CI.processDoghouseCountUpdateQueue.bind(CI), 2000);
        return;
      }

      // Acquire lock to prevent duplicate/parallel execution
      CI.IV_doghouse_count_update_request_active = true;
      Vue.set(CI.IV_doghouse_update_count_request_status, 'active', true)

      /// Handle new count events pushed to queue
      for (let epochMinutes in CI.IV_doghouse_count_update_queue) {
        console.log("processDoghouseCountUpdateQueue ran")
        for (let eventUniqueId in CI.IV_doghouse_count_update_queue[epochMinutes]) {
          const [
              event_timestamp,
              event_type,
              has_been_processed,
              org_uid,
              sys_uid,
              obj_uid,
              obj_atr_uid,
              previous_state,
              next_state
            ] = CI.IV_doghouse_count_update_queue[epochMinutes][eventUniqueId],
            uids = [org_uid, sys_uid, obj_uid, obj_atr_uid];
          
          let actual_previous_state = previous_state || "active";

          /// Only process entries that haven't been processed
          if (!has_been_processed) {
            switch (event_type) {
              case 1:
                //// Process update events of type active (follows through into case 2 until the 'break' keyword)
              case 2:
                //// Process update events of type manual active
                // If manually set back to active after last update happened, also subtract 1 from acknowledged alerts dictionaries
                if (actual_previous_state === 'acknowledged' && event_type === 2) {
                  CI.updateDoghouseCountDictionaries('acknowledged', uids, 'decrement')
                }
                CI.updateDoghouseCountDictionaries('active', uids, 'increment')
                ////</end> Process update events of type active + manual active
                break
              case 3:
                //// Process update events of type acknowledged
                if (actual_previous_state === 'active') {
                  CI.updateDoghouseCountDictionaries('active', uids, 'decrement')
                }
                CI.updateDoghouseCountDictionaries('acknowledged', uids, 'increment')
                break
              case 4:
                //// Process update events of type hist or cleared
                // check whether this type of update happened from the Active or Acknowledged list                
                if (actual_previous_state === 'active') {
                  // Subtract 1 from active alerts totals
                  CI.updateDoghouseCountDictionaries('active', uids, 'decrement')
                } else if (actual_previous_state === 'acknowledged') {
                  // Subtract 1 from acknowledged alerts totals
                  CI.updateDoghouseCountDictionaries('acknowledged', uids, 'decrement')
                  
                  // Acknowledged state moved back to active (Only in personal rules case)
                  if (next_state && next_state === "active") {
                    CI.updateDoghouseCountDictionaries('active', uids, 'increment')
                  }
                }
                ////</end> Process update events of type acknowledged
                break
            }
          }
          ///</end> Only process entries that haven't been processed
        }
        // Clear the queue after it has been processed
        delete CI.IV_doghouse_count_update_queue[epochMinutes]
      }
      ///</end> Handle new count events pushed to queue

      /// Setting active and acknowledged alerts from sub organizations
      for (let org_uid in CI.IV_org_permissions) {
        const child_org_uids = [org_uid];
        let child_active_alerts_count = 0;
        let child_acknowledged_alerts_count = 0;
        
        /// Getting all child organiation uids
        for (let key in CI.IV_org_location_strings) {
          const search_string = org_uid + "org_";
          if (window.G_watchdog_data.IV_org_location_strings[key].indexOf(search_string) >= 0) {
            child_org_uids.push(key)
          }
        }
        ///>/end> Getting all child organiation uids

        for (let org_key of child_org_uids) {
          let org_numeric_uid = org_key.replace("org_", "")
          
          if (org_numeric_uid in CI.IV_doghouse_active_count_org_level) {
            child_active_alerts_count += CI.IV_doghouse_active_count_org_level[org_numeric_uid];
          }

          if (org_numeric_uid in CI.IV_doghouse_acknowledged_count_org_level) {
            child_acknowledged_alerts_count += CI.IV_doghouse_acknowledged_count_org_level[org_numeric_uid];
          }
        }

        Vue.set(CI.IV_doghouse_active_count_tree_based_org_level, org_uid.replace("org_", ""), child_active_alerts_count)
        Vue.set(CI.IV_doghouse_acknowledged_count_tree_based_org_level, org_uid.replace("org_", ""), child_acknowledged_alerts_count)
      }
      ///</end> Setting active and acknowledged alerts from sub organizations

      // Set last time count updated
      CI.IV_doghouse_count_update_last_run_time = parseInt(now_time.getTime() / 1000);

      // Release lock to make next call executeable
      CI.IV_doghouse_count_update_request_active = false;
      Vue.set(CI.IV_doghouse_update_count_request_status, 'active', false)

      setTimeout(CI.processDoghouseCountUpdateQueue.bind(CI), 2000);

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7UnsubscribeNGPDoghouseListeners(focused_listener_keys=[]) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7UnsubscribeNGPDoghouseListeners ";
      var task_id = "bi7_watchdog_firebase:bi7UnsubscribeNGPDoghouseListeners";
      var CI = this;
      /// input validation 
      call_result = bi1_data_validation.is_array(focused_listener_keys);
      debug_data.push(call_result);

      if (call_result[CR.success] !== RC.success) {
        CI.IV_loading_ngp_rules[focused_listener_keys] = false;
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///</end> input validation 

      if (focused_listener_keys.length > 0) {
        for (let key_index in focused_listener_keys) {
          let key = focused_listener_keys[key_index];
          CI.bi7UnsubscribeSpecificListener('ngp_triggered_focused', key)
        }
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitActiveNGPTagAllListener(ngp_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitActiveNGPTagAllListener";
      var task_id = "bi7_watchdog_firebase:bi7InitActiveNGPTagAllListener";
      var CI = this;

      // We already have a listener started for this ngp and org
      if (ngp_uid in CI.IV_listener_ngp_active_tags_all === true) {
        return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var listener_location = `/ngp_active_tag_all/${ngp_uid.replace("ngp_", "")}`;
      CI.IV_listener_ngp_active_tags_all[ngp_uid] = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_ngp_active_tags_all[ngp_uid]);
      debug_data.push(call_result)
      if (call_result[CR.success] !== RC.success) {
        CI.IV_listener_ngp_active_tags_all[ngp_uid] = null;
        delete CI.IV_listener_ngp_active_tags_all[ngp_uid];
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_ngp_active_tags_all[ngp_uid].on("value",
        function (a_data) {CI.activeNGPTagAllListenerCallback(ngp_uid, a_data)}.bind(CI),
        function (error) {
          return_msg += "firebase read failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(CI)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };

    }

    activeNGPTagAllListenerCallback(ngp_uid, data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:activeNGPTagAllListenerCallback ";
      var task_id = "bi7_watchdog_firebase:activeNGPTagAllListenerCallback";

      ////// input validation
      if (data === null || data.val() === null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      /////// </end> input validation

      var CI = this;
      var firebase_data = data.val();

      if (ngp_uid in CI.IV_ngp_active_tags_all === false) {
        Vue.set(CI.IV_ngp_active_tags_all, ngp_uid, {});
      }

      // Need to empty same object to prevent vue reactivity
      Object.keys(CI.IV_ngp_active_tags_all[ngp_uid]).forEach(k => delete CI.IV_ngp_active_tags_all[ngp_uid][k])

      for (let key in firebase_data) {

        if (key === "last_updated" || key === 'deletion_prevention_key') {
          continue;
        }
        
        // Prevention from invalid key type
        if (!key.includes("_")) {continue;}

        /// Extracting data from key
        let key_parts = key.split("_");
        let org_uid = `org_${key_parts[0]}`;

        if (org_uid in CI.IV_ngp_active_tags_all[ngp_uid] === false) {
          Vue.set(CI.IV_ngp_active_tags_all[ngp_uid], org_uid, {});
        }

        let sys_uid = `sys_${key_parts[1]}`;

        if (sys_uid in CI.IV_ngp_active_tags_all[ngp_uid][org_uid] === false) {
          Vue.set(CI.IV_ngp_active_tags_all[ngp_uid][org_uid], sys_uid, {});
        }

        let obj_uid = `obj_${key_parts[2]}`;

        if (obj_uid in CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid] === false) {
          Vue.set(CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid], obj_uid, {});
        }

        let obj_atr_uid = `obj_atr_${key_parts[2]}-${key_parts[3]}`
        
        if (obj_atr_uid in CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid][obj_uid] === false) {
          Vue.set(CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid][obj_uid], obj_atr_uid, {});
        }

        let rule_uid = key_parts[4];
        
        if (rule_uid in CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid] === false) {
          Vue.set(CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid], rule_uid, {});
        }

        let unique_tag_entry = key_parts[5].split("|")[1]

        if (unique_tag_entry in CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid] === false) {
          Vue.set(CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid], unique_tag_entry, {});
        }

        if(firebase_data[key] in CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid][unique_tag_entry] === false) {
          Vue.set(CI.IV_ngp_active_tags_all[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid][unique_tag_entry], "url_safe_key", firebase_data[key])
        }
        /// </end> Extracting data from key
      }

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7InitActiveNGPTagFocusedListener(ngp_uid, org_uid) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7InitActiveNGPTagFocusedListener";
      var task_id = "bi7_watchdog_firebase:bi7InitActiveNGPTagFocusedListener";
      var CI = this;

      ////// input validation
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }
      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      /////// </end> input validation

      // We already have a listener started for this ngp and org

      var listener_location = '/ngp_active_tag_focused/';
      CI.IV_listener_ngp_active_tags_focused = CI.IV_firebase_db_object.ref(listener_location);

      ///// removing invalid firebase listener key
      call_result = CI.validateFirebaseListener(CI.IV_listener_ngp_active_tags_focused);
      debug_data.push(call_result)
      if (call_result[CR.success] !== RC.success) {
        CI.IV_listener_ngp_active_tags_focused = null;
        delete CI.IV_listener_ngp_active_tags_focused;
        return_msg += "failed to create listener for " + listener_location;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        Vue.set(CI.IV_ngp_loading_states, loading_key, false);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      ///// </end> removing invalid firebase listener key

      CI.IV_listener_ngp_active_tags_focused.on("value",
        function (a_data) {CI.activeNGPTagFocusedListenerCallback(ngp_uid, org_uid, a_data)}.bind(CI),
        function (error) {
          return_msg += "firebase read failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        }.bind(CI)
      );

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7AddDoghouseActiveEntry(rule_uid, rule_join_uid, org_uid, system_uid, object_uid, object_attribute_uid, value, tags, timestamp, triggered_at) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7AddDoghouseActiveEntry ";
      var task_id = "bi7_watchdog_firebase:bi7AddDoghouseActiveEntry";
      var CI = this;

      //////// input validation
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_system_uid(system_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_object_uid(object_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(rule_join_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(rule_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(value);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(triggered_at);
      debug_data.push(call_result);


      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] != RC.success) {
          validation_failed = true;
        }
      }

      if (validation_failed == true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }
      /////// </end> input validation

      var folder = CI.IV_user_folder_path + '/dog_house_active/' + org_uid + '/' + system_uid + '/' + object_uid + '/' + object_attribute_uid  + '/' + rule_uid;

      var reference = CI.IV_firebase_db_object.ref(folder);
      if (reference == null) {
        return_msg += "failed to create reference for " + folder;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        return { 'success': RC.firebase_failure, 'return_msg': return_msg, 'debug_data': debug_data };
      }

      var data = {
        rule_uid: rule_join_uid, 
        org_uid: org_uid, 
        obj_atr_uid: object_attribute_uid, 
        sys_uid: system_uid, 
        obj_uid: object_uid,
        value: value,
        tags: tags,
        timestamp: triggered_at || timestamp,
        mact_timestamp: parseInt(2 + (new Date().getTime() / 1000)).toString()
      }

      reference.set(JSON.stringify(data), function(error) {
        if (error) {
          return_msg += "firebase write failed with error data:" + error;
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
        } else {
          return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
        }
      });

      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    activeNGPTagFocusedListenerCallback(ngp_uid, org_uid, data) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:activeNGPTagFocusedListenerCallback";
      var task_id = "bi7_watchdog_firebase:activeNGPTagFocusedListenerCallback";

      ////// input validation
      call_result = bi1_data_validation.is_ngp_uid(ngp_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }

      if (data == null || data.val() == null) {
        return_msg += "data argument is null";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
      }
      /////// </end> input validation

      var CI = this;
      var firebase_data = data.val();

      // Need to empty same object to prevent vue reactivity on object removal
      Object.keys(CI.IV_ngp_active_tags_focused).forEach(k => delete CI.IV_ngp_active_tags_focused[k])
      
      for (let ngp_key in firebase_data) {
        let ngp_uid = `ngp_${ngp_key}`
        
        if (ngp_uid in CI.IV_ngp_active_tags_focused === false) {
          Vue.set(CI.IV_ngp_active_tags_focused,ngp_uid, {});
        }

        for (let org_group_key in firebase_data[ngp_key]) {

          if (org_group_key === "last_updated" || org_group_key === 'deletion_prevention_key') {
            continue;
          }

          for (let key in firebase_data[ngp_key][org_group_key]) {
            if (key === "last_updated" || key === 'deletion_prevention_key') {
              continue;
            }
            
            // Prevention from invalid key type
            if (!key.includes("_")) {continue;}

            /// Extracting data from key
            let key_parts = key.split("_");
            let org_uid = `org_${key_parts[0]}`;
  
            if (org_uid in CI.IV_ngp_active_tags_focused[ngp_uid] === false) {
              Vue.set(CI.IV_ngp_active_tags_focused[ngp_uid], org_uid, {});
            }
  
            let sys_uid = `sys_${key_parts[1]}`;
  
            if (sys_uid in CI.IV_ngp_active_tags_focused[ngp_uid][org_uid] === false) {
              Vue.set(CI.IV_ngp_active_tags_focused[ngp_uid][org_uid], sys_uid, {});
            }
  
            let obj_uid = `obj_${key_parts[2]}`;
  
            if (obj_uid in CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid] === false) {
              Vue.set(CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid], obj_uid, {});
            }
  
            let obj_atr_uid = `obj_atr_${key_parts[2]}-${key_parts[3]}`
            
            if (obj_atr_uid in CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid][obj_uid] === false) {
              Vue.set(CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid][obj_uid], obj_atr_uid, {});
            }
  
            let rule_uid = key_parts[4];
            
            if (rule_uid in CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid] === false) {
              Vue.set(CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid], rule_uid, {});
            }

            let unique_tag_entry = key_parts[5].split("|")[1]

            if (unique_tag_entry in CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid] === false) {
              Vue.set(CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid], unique_tag_entry, {});
            }

            if (firebase_data[ngp_key][org_group_key][key] in CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid][unique_tag_entry] === false) {
              Vue.set(CI.IV_ngp_active_tags_focused[ngp_uid][org_uid][sys_uid][obj_uid][obj_atr_uid][rule_uid][unique_tag_entry], "url_safe_key", firebase_data[ngp_key][org_group_key][key])
            }
            /// </end> Extracting data from key
          }
        }
      }
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };

    }


    bi7ClearDoghouseHistoryEntry(rule_uid, org_uid, system_uid, object_uid, object_attribute_uid, timestamp) {
      var debug_data = [];
      var call_result = {};
      var return_msg = "bi7_watchdog_firebase:bi7ClearDoghouseHistoryEntry ";
      var task_id = "bi7_watchdog_firebase:bi7ClearDoghouseHistoryEntry";
      var CI = this;

      //////// input validation
      call_result = bi1_data_validation.is_org_uid(org_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_system_uid(system_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_object_uid(object_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_object_attribute_uid(object_attribute_uid);
      debug_data.push(call_result);
      call_result = bi1_data_validation.is_string(rule_uid);
      debug_data.push(call_result);

      var validation_failed = false;
      for (var index in debug_data) {
        if (debug_data[index][CR.success] !== RC.success) {
          validation_failed = true;
        }
      }

      if (validation_failed === true) {
        return_msg += "input validation failed";
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
        return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
      }

      /////// </end> input validation

      CI.bi7DeleteFirebaseLocation(CI.IV_user_folder_path + '/dog_house_history/' + org_uid + '/' + system_uid + '/' + object_uid + '/' + object_attribute_uid + '/' + rule_uid + '/' + timestamp);
      Vue.delete(CI.IV_doghouse_history[org_uid][system_uid][object_uid][object_attribute_uid],timestamp);
      
      return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    bi7GetNGPActiveEntries(ngp_list, org_list, sys_uid, obj_uid, obj_atr_uid) {
      const CI = this
      getNotificationGroupActiveEntries(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        ngp_list,
        org_list,
        sys_uid,
        obj_uid,
        obj_atr_uid
      ).then(
        success => {
          // console.log(CI.IV_ngp_triggered_alerts_entries)
          const activeEntries = success['active_entries']
          for (let index in activeEntries) {
            for (let ngp_uid in activeEntries[index]) {
              const orgs_data = activeEntries[index][ngp_uid];
              // console.log(index, ngp_uid, orgs_data)
              for (let org_uid in orgs_data) {
                for (let sys_uid in orgs_data[org_uid]) {
                  for (let obj_uid in orgs_data[org_uid][sys_uid]) {
                    for (let atr_uid in orgs_data[org_uid][sys_uid][obj_uid]) {
                      for (let rule_uid in orgs_data[org_uid][sys_uid][obj_uid][atr_uid]) {
                        const data = orgs_data[org_uid][sys_uid][obj_uid][atr_uid][rule_uid];
                        const entry = {}
                        entry["org_uid"] = org_uid;
                        entry["sys_uid"] = sys_uid;
                        entry["obj_uid"] = obj_uid;
                        entry["obj_atr_uid"] = atr_uid.replace("obj_atr_", `obj_atr_${obj_uid.replace("obj_", "")}-`);
                        entry["timestamp"] = data[0];
                        entry["entry_type"] = data[1];
                        entry["value"] = data[2];
                        entry["rule_name"] = data[3];
                        entry["url_safe_key"] = data[4]
                        entry["acknowledged_state"] = data[5]
                        entry["rule_uid"] = rule_uid;
                        entry["ngp_uid"] = ngp_uid;

                        let key = ngp_uid.split("_")[1] + "_" + org_uid.split("_")[1] + "_" + sys_uid.split("_")[1] + "_" + obj_uid.split("_")[1] + "_" + atr_uid.split("_")[2] + "_" + rule_uid
                        // console.log(key)
                        // console.log(CI.IV_ngp_triggered_alerts_entries[`${ngp_uid}|${org_uid}`][key])
                        if(CI.IV_ngp_triggered_alerts_entries[`${ngp_uid}|${org_uid}`]) {
                          if(CI.IV_ngp_triggered_alerts_entries[`${ngp_uid}|${org_uid}`][key]) {
                            // do we need to update any properties in the entries?
                          }
                        } else {
                          // does this method ever need to initialize entries in IV_ngp_triggered_alerts_entries?
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },
        error => {}
      );

    }
} 
//</end> getting data from firebase for systems about their acknowledged notifications

export default bi7_watchdog_firebase
//once the file is loaded put it in the list of loaded includes
if (typeof window.loaded_includes === "undefined") { window.loaded_includes = {} }
window.loaded_includes['base_i7'] = true;



// WEBPACK FOOTER //
// ./src/watchdog_includes/base_i7_watchdog_data.js